<template>
  <!-- Show a loading message or spinner -->
  <div v-if="!project || !project.status">Loading project data...</div>
  <section v-else-if="!isMobile" style="display: flex; height: max-content; min-height: 100%; zoom: 0.8;">
    <div class="left-side-bar bg-vb-tertiary">
      <div class="logo-wrapper">
        <a href="/listing-new">
          <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-img" />
        </a>
      </div>
      <div class="side-menu-wrapper">
        <div>
          <div class="side-menu-item" @click="openTab = { title: 'Now Selling', value: 'overview' }"
            :class="{ active_tab: openTab.value === 'overview' }">
            <font-awesome-icon :icon="['fas', 'eye']" class="mr-3" />Overview
          </div>
          <div v-if="['admin', 'realtor'].includes(current_user.role)" class="side-menu-item"
            @click="openTab = { title: 'Unit Mix', value: 'unitmix' }, setRpdHeaderFields()"
            :class="{ active_tab: openTab.value === 'unitmix' }">
            <font-awesome-icon :icon="['fas', 'house-user']" class="mr-3" />Unit
            Mix
          </div>
          <div v-if="
            (['developer', 'developerbc'].includes(current_user.role) &&
              project.status &&
              [
                'now leasing',
                'leased out',
                'leased out 2',
                'now leasing 2',
                'now selling',
              ].includes(project.status.toLowerCase())) ||
            (['developer', 'developerbc'].includes(current_user.role) &&
              project.status &&
              [
                'now selling',
                'now selling 2',
                'sold out',
                'sold out 2',
              ].includes(project.status.toLowerCase()))
          " class="side-menu-item" @click="openTab = { title: 'Unit Mix', value: 'unitmix' }, setRpdHeaderFields"
            :class="{ active_tab: openTab.value === 'unitmix' }">
            <font-awesome-icon :icon="['fas', 'house-user']" class="mr-3" />Unit
            Mix
          </div>
          <div v-if="
            (isAdmin || showFlag) &&
            [
              'Now Selling',
              'Now Selling 2',
              'Sold Out',
              'Sold Out 2',
            ].includes(project.status)
          " class="side-menu-item"
            @click="openTab = { title: 'Unit Mix', value: 'unitmixrental' }, setRpdHeaderFields()"
            :class="{ active_tab: openTab.value === 'unitmixrental' }">
            <font-awesome-icon :icon="['fas', 'house-user']" class="mr-3" />Unit
            Mix Rental
          </div>
          <div v-if="!isAdmin && project.status &&
            ['now leasing', 'now selling', 'sold out', 'leased out'].includes(
              project.status.toLowerCase()
            )" class="side-menu-item" @click="
              (openTab = { title: 'History', value: 'history' }), loadChart()
              " :class="{ active_tab: openTab.value === 'history' }">
            <font-awesome-icon :icon="['fas', 'history']" class="mr-3" />Absorptions
          </div>

          <div v-if="
            project.status &&
            !['selling soon', 'in planning', 'leasing soon'].includes(
              project.status.toLowerCase()
            )
          " class="side-menu-item" @click="
            (openTab = { title: 'Features', value: 'features' }), loadChart()
            " :class="{ active_tab: openTab.value === 'features' }">
            <font-awesome-icon :icon="['fas', 'tasks']" class="mr-3" />Features
          </div>
          <div v-else class="side-menu-item" @click="
            (openTab = { title: 'Features', value: 'features' }), loadChart()
            " :class="{ active_tab: openTab.value === 'features' }">
            <font-awesome-icon :icon="['fas', 'tasks']" class="mr-3" />Gallery
          </div>
          <div v-if="(project.is_approve_amenities == '1' && !isAdmin) || isAdmin" class="side-menu-item" @click="
            (openTab = { title: 'Amenity Details', value: 'amenity_details' })
            " :class="{ active_tab: openTab.value === 'amenity_details' }">
            <font-awesome-icon :icon="['fas', 'info']" class="mr-3" />Amenity Details
          </div>
          <div v-if="project.is_admin && !project.skip_ava" class="side-menu-item"
            @click="openTab = { title: 'Availability', value: 'availability' }"
            :class="{ active_tab: openTab.value === 'availability' }">
            <font-awesome-icon :icon="['fas', 'home']" class="mr-3" />Availability
          </div>
          <div v-if="mappedUtcExtra.length > 0" class="side-menu-item" @click="
            openTab = {
              title: 'Development Stats',
              value: 'developmentstats',
            }
            " :class="{ active_tab: openTab.value === 'developmentstats' }">
            <font-awesome-icon :icon="['fas', 'chart-line']" class="mr-3" />Development Stats
          </div>
          <div v-if="
            ['admin', 'developer', 'developerbc', 'editor'].includes(
              current_user.role
            )
          " class="side-menu-item" @click="
            openTab = {
              title: 'Permits | Planning Process',
              value: 'permits',
            }
            " :class="{ active_tab: openTab.value === 'permits' }">
            <font-awesome-icon :icon="['fas', 'check-circle']" class="mr-3" />Permit
          </div>
          <div v-if="
            isAdmin &&
            project.status &&
            !['selling soon', 'in Planning', 'leasing soon'].includes(
              project.status.toLowerCase()
            )
          " class="side-menu-item" @click="openTab = { title: 'Notes', value: 'notes' }"
            :class="{ active_tab: openTab.value === 'notes' }">
            <font-awesome-icon :icon="['fas', 'thumbtack']" class="mr-3" />Notes
          </div>
          <div v-if="isAdmin" class="side-menu-item" @click="openTab = { title: 'History', value: 'history' }"
            :class="{ active_tab: openTab.value === 'history' }">
            <font-awesome-icon :icon="['fas', 'history']" class="mr-3" />Project
            History
          </div>
          <div v-if="project.is_admin" class="side-menu-item" @click="openTab = { title: 'Upload', value: 'upload' }"
            :class="{ active_tab: openTab.value === 'upload' }">
            <font-awesome-icon :icon="['fas', 'upload']" class="mr-3" />Upload
          </div>
          <div v-if="false && showFlag" class="side-menu-item"
            @click="openTab = { title: 'Upload', value: 'uploadnew' }"
            :class="{ active_tab: openTab.value === 'uploadnew' }">
            <font-awesome-icon :icon="['fas', 'upload']" class="mr-3" />Rental
            Update
          </div>
          <div class="side-menu-item" @click="(openTab = { title: 'Project Timeline', value: 'timeline' })"
            :class="{ active_tab: openTab.value === 'timeline' }">
            <font-awesome-icon :icon="['fas', 'tasks']" class="mr-3" />Project timeline
          </div>
        </div>
        <hr class="bg-white" />
        <div>
          <div class="side-menu-bottom">
            <div v-if="!['developer', 'developerbc'].includes(current_user.role)" class="side-menu-bottom-item">
              New Features
            </div>
            <b-button variant="light" v-b-modal.feedback-modal style="margin-left:38px;">
              <font-awesome-icon :icon="['fas', 'envelope']" style="font-size: 20px" class="mr-3" />Send feedback
            </b-button>
            <div class="side-menu-bottom-item" @click="logout()">Log Out</div>
            <div v-if="!['developer', 'developerbc'].includes(current_user.role)" class="side-menu-bottom-item">
              <a href="/presale-database#contact" style="color: #fff">Contact</a>
            </div>
          </div>

          <div class="d-flex justify-content-between mx-auto type-icons" style="width: 16rem"
            v-if="!['developer', 'developerbc'].includes(current_user.role)">
            <font-awesome-icon class="svg-inline--fa type-icons-fontawesome" :icon="['fas', 'external-link-alt']"
              style="color: #ffffff; font-size: 1.3rem" />
            <font-awesome-icon class="svg-inline--fa type-icons-fontawesome" :icon="['fas', 'map-marked-alt']"
              style="font-size: 1.3rem" />
          </div>
        </div>
      </div>
    </div>
    <div class="type-container" style="height: max-content">
      <div class="fl-wrap single-project-detail">
        <div class="row print-none type-title bg-white">
          <h2 class="text-decoration-none font-weight-bold pt-1 text-vb-primary" style="font-size: 30px">
            {{ project.status }}
          </h2>
          <div class="align-items-center justify-content-end print-none row type-icons">
            <!-- {{project.developer}} -->
            <b-button variant="outline-vb-primary" class="mr-3" @click="generateImage">Download Pdf
              <font-awesome-icon class="type-icons-fontawesome" :icon="['fas', 'download']" />
            </b-button>

            <b-button variant="outline-vb-primary" class="mr-3" @click="exportData">Export CSV
              <font-awesome-icon class="type-icons-fontawesome" :icon="['fas', 'file-export']" v-if="
                project.status &&
                [
                  'now selling',
                  'now leasing',
                  'now leasing 2',
                  'leased out',
                  'leased out 2',
                ].includes(project.status.toLowerCase())
              " />
            </b-button>

            <b-button v-if="isAdmin" variant="outline-vb-primary" class="mr-3" @click="goToNewView">New View
              <font-awesome-icon class="type-icons-fontawesome" :icon="['fas', 'arrow-circle-right']" />
            </b-button>

            <a class="" :href="'/project?project=' + project.nid + '&fid=' + collection_ids" v-if="
              isAdmin &&
              project.status &&
              [
                'in planning',
                'leasing soon',
                'selling soon',
                'now selling',
                'now selling 2',
                'now leasing',
                'now leasing 2',
                'sold out',
                'sold out 2',
                'leased out',
                'leased out 2',
              ].includes(project.status.toLowerCase())
            ">Land Page</a>
            <a class="text-decoration-none font-weight-normal text-light mx-2" v-if="project.is_admin" :href="'https://www.realpropertydata.ca/backend/node/' +
              project.nid +
              '/edit'
              ">Edit</a>
            <a class="text-decoration-none font-weight-normal text-light mx-2" v-if="project.is_admin" :href="'https://www.realpropertydata.ca/backend/node/' + project.nid
              ">View</a>
          </div>
        </div>
        <div class="row print-none" v-if="project.is_admin && userStore.current_user.role == 'admin'">
          <!-- <div class="text-left col-md-2 mt-auto"><a v-if="project.is_admin" :href="project_link+'&tab='+$route.query.fid">Presale Page</a></div> -->
          <!-- <div class="col-md-2 text-right mt-auto">
                        <a :href="project.web_link[0]" target="_blank" class="type-ad-header" style="color: #2C3E5A"><font-awesome-icon style="color: #2C3E5A;" :icon="['fas', 'share-square']" /> Project Website</a>
                    </div> -->
        </div>
        <div class="row mt-50 mx-auto justify-content-between content-utc-body mb-3"
          :class="[openTab.value != 'image' ? ['pb-20', 'border-bottom'] : '']">
          <div class="d-flex">
            <a class="text-vb-primary text-decoration-none mr-2" :href="project.web_link ? project.web_link[0] : '#'"
              target="_blank"><strong style="font-size: 2.2rem">{{
                project.project_name
              }}</strong></a>
          </div>
          <i style="font-size: large" v-if="new Date(lastUpdated).getFullYear() > 2000">Last Updated: {{ lastUpdated
          }}</i>
          <div class="mt-2">
            {{ project.address }}
          </div>
        </div>
        <b-modal id="summary-table-modal" ref="summary-table-modal" size="lg" title="Plan Preview" ok-only>
          <div class="row justify-content-between mx-3">
            <div>
              <b-button @click="exportFloorPlans" variant="primary" class="mb-3">Export Floorplans</b-button>
              <b-button @click="exportFloorPlanToCsv" variant="primary" class="mb-3">Export Csv</b-button>
            </div>
            <div>
              <b-button v-b-modal.graph-view variant="primary"><font-awesome-icon :icon="['fas', 'chart-bar']" />
                Visualize
                Data</b-button>
            </div>
          </div>
          <SummaryTable ref="childComp" :report-detail-summary="unitPreviewSummary"
            :header-fields="unitPreviewSummaryHeader" :is-market-strata="isMarketStrata"
            v-on:filterSummary="filterSummary" />
        </b-modal>
        <b-modal id="graph-view" ref="graph-view" title="Graph Preview" @shown="generateFloorPlanSummaryChart" ok-only>
          <canvas ref="summaryChart" id="summaryChart"></canvas>
        </b-modal>
        <div class="tab-row">
          <b-tabs active-nav-item-class="type-nav-active" active-tab-class="type-content-active"
            nav-class="type-nav-general print-none">
            <b-tab title="Overview" :active="openTab.value === 'overview'">
              <div class="content-utc-body mx-auto">
                <div class="row">
                  <div class="col-md-5" style="overflow-y: scroll; max-height: 30rem">
                    <div class="row" v-for="(val, key) in overViewData" :key="key">
                      <template v-if="key === 'Developer'">
                        <div class="col-xs-6 mt-4">
                          {{ key }}
                        </div>
                        <div class="col-xs-6 overview-val mt-4">
                          <template v-for="(item, index) in val">
                            <router-link :key="index" target="_blank" :to="{
                              name: 'developer-results',
                              query: {
                                developerId: item['target_id'],
                                developerName: item.name,
                              },
                            }" class="badge badge-vb-secondary m-1" style="font-size: 18px">
                              {{ item.name }}
                            </router-link>
                          </template>
                        </div>
                      </template>
                      <template v-else-if="
                        key != 'unitCollection' &&
                        !['Sales Start Date', 'Lease Start Date'].includes(
                          key
                        )
                      ">
                        <div class="col-xs-6 mt-4">
                          {{ key }}
                        </div>
                        <div class="col-xs-6 overview-val mt-4">
                          {{ val ? val : "-" }}
                        </div>
                      </template>
                      <template v-else-if="
                        ['Sales Start Date', 'Lease Start Date'].includes(key)
                      ">
                        <div class="col-xs-6 mt-4">
                          {{ key }}
                        </div>

                        <div class="col-xs-6 overview-val mt-4 d-flex">
                          <template v-if="
                            ['admin', 'editor'].includes(current_user.role) &&
                            formatSalesStartDate != '-'
                          ">
                            <b-form-datepicker style="max-width: 15rem" class="mr-2" id="datepicker-dateformat1"
                              :date-format-options="{
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                              }" locale="en" :disabled="['admin', 'editor'].includes(current_user.role)
                                ? editSalesStartDate
                                : true
                                " v-model="formatSalesStartDate"></b-form-datepicker>

                            <div class="d-flex align-self-middle">
                              <font-awesome-icon v-if="editSalesStartDate" @click="editSalesStartDate = false"
                                class="text-vb-tertiary _cursor-pointer mt-5" :icon="['fas', 'edit']"
                                style="font-size: larger" />
                              <font-awesome-icon v-if="!editSalesStartDate" @click="updateSalesStartDate"
                                class="text-success _cursor-pointer mt-5" :icon="['fas', 'save']"
                                style="font-size: larger" />
                            </div>
                          </template>
                          <template v-else>
                            <div>
                              <span v-if="formatSalesStartDate != '-'">{{
                                formatSalesStartDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }
                                )
                              }}</span>
                              <span v-else class="font-italic">Previewing</span>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <template v-for="(unitCollection, unitCollectionKey) in val">
                          <div class="col-xs-6 mt-4" :key="unitCollectionKey">
                            {{ unitCollection[0] }}
                          </div>
                          <div class="col-xs-6 overview-val mt-4" :key="unitCollectionKey">
                            {{ unitCollection[1] }}
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                  <div class="col-md-7 pt-1 mobile-mt-20 print-none">
                    <div>
                      <div class="col-12">
                        <template v-if="false">
                          <h4>Projects nearby</h4>
                          <div class="row" v-if="project.nearby_projects && project.nearby_projects.length > 0">
                            <div v-for="(project, index) in project.nearby_projects" :key="index">
                              <a :href="project.url" target="_blank">
                                <b-badge variant="vb-secondary" class="m-1">{{ project.title }}</b-badge>
                              </a>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="col-md-12">
                        <div id="map" class="updated-maps mt-4" style="height: 430px"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row px-2 pt-4 text-left hidden-md hidden-sm hidden-xs print-none">
                  <b-button class="mx-2" variant="vb-primary" v-b-modal="'feature-files'" v-if="
                    project.date_based_features &&
                    project.date_based_features.length > 0
                  " pill>Features</b-button>
                  <template v-if="!['realtor'].includes(current_user.role)">
                    <b-button class="mx-2" variant="vb-secondary" v-b-modal="'consultant'" pill>Consultants</b-button>
                  </template>
                  <template v-if="
                    project.status &&
                    ![
                      'in planning', 'leasing soon', 'selling soon'
                    ].includes(project.status.toLowerCase())
                  ">
                    <b-button class="mx-2" variant="vb-secondary" v-b-modal="'modal-incentives'"
                      pill>Incentives</b-button>
                  </template>
                </div>
                <div class="row px-2 pt-4 text-left hidden-lg print-none">
                  <span style="cursor: pointer" v-b-modal="'site-plan-files'"
                    class="btn btn-primary-reverse col-xs-5 ml-2" v-if="
                      project.site_plan_features &&
                      project.site_plan_features.length > 0
                    ">Site Plan</span>
                  <span class="col-xs-1"></span>
                  <span style="cursor: pointer" v-b-modal="'consultant'"
                    class="btn btn-primary-reverse col-xs-5">Consultants</span>
                </div>
                <template v-if="
                  project.status &&
                  !['selling soon', 'in planning', 'leasing soon'].includes(
                    project.status.toLowerCase()
                  )
                ">
                  <div class="row">
                    <div
                      class="col-xs-12 text-left mt-20 align-items-center justify-content-between row justify-content-between"
                      style="max-width: 600px">
                      <h3>Project Total</h3>
                      <i class="m-0" style="font-size: large">{{ isMarketStrata ? "Sold" : "Lease" }} Report: {{
                        lastUpdate }}</i>
                    </div>
                  </div>
                  <div class="display--inline-grid">
                    <div class="display--inline-grid">
                      <div class="square-wrapper p-2" v-for="(value, key, index) in unitComponent" :key="index">
                        <div class="square-blue" v-if="
                          !['net $psf', 'net price', 'net rent'].includes(
                            Object.keys(value)[0].toLowerCase()
                          ) ||
                          (['net $psf', 'net price', 'net rent'].includes(
                            Object.keys(value)[0].toLowerCase()
                          ) &&
                            value[Object.keys(value)] != '$0')
                        " :class="{
                          '_bg-light-blue': [
                            'avg $psf',
                            'gross price',
                            'gross $psf',
                            'gross rent',
                            'avg rent',
                          ].includes(Object.keys(value)[0].toLowerCase()),
                          'bg-vb-accent': ![
                            'avg sf',
                            'avg $psf',
                            'gross price',
                            'gross $psf',
                            'gross rent',
                            'net $psf',
                            'net price',
                            'avg rent',
                            'net rent',
                          ].includes(Object.keys(value)[0].toLowerCase()),
                          'bg-vb-primary': [
                            'net $psf',
                            'net price',
                            'net rent',
                          ].includes(Object.keys(value)[0].toLowerCase()),
                          'bg-vb-blue-accent text-light': [
                            'avg sf',
                            'avg size',
                          ].includes(Object.keys(value)[0].toLowerCase()),
                        }">
                          <div :class="{
                            'text-white': [
                              'net $psf',
                              'net price',
                              'net rent',
                            ].includes(Object.keys(value)[0].toLowerCase()),
                          }">
                            <div>{{ Object.keys(value)[0] }}</div>
                            <div>
                              <strong>{{ value[Object.keys(value)] }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <hr />
                <div class="row justify-content-between align-items-center px-3" v-if="
                  project.unit_component &&
                  project.unit_component.bed &&
                  project.unit_component.bed.length !== 0
                ">
                  <h3>Unit Breakdown</h3>
                  <div class="align-items-center row">
                    <button type="button" class="btn mr-2 btn-primary" @click="exportUnitBreakDownFloorPlans">
                      Export Floorplans
                    </button>
                    <b-button @click="exportUnitBreakdown" variant="vb-primary">Export
                      <font-awesome-icon :icon="['fas', 'file-export']" class="ml-2" /></b-button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <template v-if="
                      project.unit_component &&
                      project.unit_component.bed &&
                      project.unit_component.bed.length !== 0
                    ">
                      <table class="table mt-3 table-striped">
                        <thead class="fp-header text-light">
                          <tr>
                            <!-- Sortable headers -->
                            <th class="pl-4 align-content-end sortable" @click="sortBy('bed')"
                              :class="{ active: currentSort === 'bed' }">
                              Type
                              <span v-if="currentSort === 'bed'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('bath')"
                              :class="{ active: currentSort === 'bath' }">
                              Baths
                              <span v-if="currentSort === 'bath'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('num')"
                              :class="{ active: currentSort === 'num' }">
                              # Units
                              <span v-if="currentSort === 'num'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('percentage')"
                              :class="{ active: currentSort === 'percentage' }">
                              %
                              <span v-if="currentSort === 'percentage'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('confirmed_sold')" :class="{
                              active: currentSort === 'confirmed_sold',
                            }">
                              Conf.
                              {{ `${isMarketStrata ? "Sold" : "Leased"}` }}
                              <span v-if="currentSort === 'confirmed_sold'" class="arrow"
                                :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('parking')"
                              :class="{ active: currentSort === 'parking' }">
                              Pkg
                              <span v-if="currentSort === 'parking'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('stall.final')"
                              :class="{ active: currentSort === 'stall.final' }">
                              Stalls
                              <span v-if="currentSort === 'stall.final'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('minSize')"
                              :class="{ active: currentSort === 'minSize' }">
                              Min SF
                              <span v-if="currentSort === 'minSize'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('maxSize')"
                              :class="{ active: currentSort === 'maxSize' }">
                              Max SF
                              <span v-if="currentSort === 'maxSize'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('avgSf')"
                              :class="{ active: currentSort === 'avgSf' }">
                              Avg SF
                              <span v-if="currentSort === 'avgSf'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('minPrice')"
                              :class="{ active: currentSort === 'minPrice' }">
                              Min Price
                              <span v-if="currentSort === 'minPrice'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('maxPrice')"
                              :class="{ active: currentSort === 'maxPrice' }">
                              Max Price
                              <span v-if="currentSort === 'maxPrice'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('avgPrice')"
                              :class="{ active: currentSort === 'avgPrice' }">
                              Avg Price
                              <span v-if="currentSort === 'avgPrice'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th class="align-content-end sortable" @click="sortBy('avgPricePsf')"
                              :class="{ active: currentSort === 'avgPricePsf' }">
                              Avg $PSF
                              <span v-if="currentSort === 'avgPricePsf'" class="arrow" :class="currentSortDir"></span>
                            </th>
                            <th v-if="
                              ['admin', 'developer', 'developerbc'].includes(
                                current_user.role.toLowerCase()
                              )
                            ">
                              <b-button class="mx-2" variant="vb-red" v-b-modal="'site-plan-files'" v-if="
                                project.site_plan_features &&
                                project.site_plan_features.length > 0
                              ">Site Plan</b-button>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="fp-body">
                          <template v-for="(unit_t, unit_key) in mlsTotalSort">
                            <tr v-bind:key="'unit_breakdown_' + unit_key" style="cursor: pointer"
                              class="_tr-fix-height">
                              <!-- Your existing td elements -->
                              <td v-b-modal="'mls-unit-' + unit_key" class="bed-column border-right"
                                v-if="unit_t.bed == '-'">
                                {{ unit_t.bed }} <br />
                                {{
                                  unit_t.fp_specs && unit_t.fp_specs.toLowerCase() == "none"
                                    ? ""
                                    : unit_t.fp_specs
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" class="bed-column border-right"
                                v-else-if="unit_t.bed == '0'">
                                0 <br />
                                {{
                                  unit_t.fp_specs && unit_t.fp_specs.toLowerCase() == "none"
                                    ? ""
                                    : unit_t.fp_specs
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" class="bed-column border-right" v-else-if="
                                parseInt(unit_t.bed) > 0 &&
                                typeof parseInt(unit_t.bed) == 'number'
                              ">
                                <strong>{{ unit_t.bed }}-bed</strong> <br />
                                {{
                                  unit_t.fp_specs && unit_t.fp_specs.toLowerCase() == "none"
                                    ? ""
                                    : unit_t.fp_specs
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" class="bed-column border-right" v-else>
                                <strong>{{
                                  unit_t.bed
                                    ? unit_t.bed
                                      .replace("jr", "Jr 1-bed")
                                      .replace("s", "Studio")
                                    : "0"
                                }}</strong>
                                <br />
                                {{
                                  unit_t.fp_specs && unit_t.fp_specs.toLowerCase() == "none"
                                    ? ""
                                    : unit_t.fp_specs
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.bath }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.num }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ getAverageUnits(mlsTotalSort, unit_t.num) }}%
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.confirmed_sold }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.parking }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.stall ? unit_t.stall.final : "" }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.minSize | numFormat }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.maxSize | numFormat }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key">
                                {{ unit_t.custom_avg_size | numFormat
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" style="border-left: 1px #8e8e8e solid"
                                class="_bg-light-blue">
                                {{
                                  unit_t.minPrice
                                    ? "$" + numberWithCommas(unit_t.minPrice)
                                    : "-"
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" class="_bg-light-blue">
                                {{
                                  unit_t.maxPrice
                                    ? "$" + numberWithCommas(unit_t.maxPrice)
                                    : "-"
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" class="_bg-light-blue">
                                {{
                                  formatCurrency(unit_t.custom_avg_price)
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" v-if="
                                [
                                  'developer',
                                  'admin',
                                  'developerbc',
                                ].includes(current_user.role) &&
                                project.status &&
                                [
                                  'now leasing',
                                  'now leasing 2',
                                  'leased out',
                                  'leased out 2',
                                ].includes(project.status.toLowerCase())
                              " class="_bg-light-blue">
                                {{
                                  unit_t.custom_avg_price && unit_t.custom_avg_size && unit_t
                                    ? "$" +
                                    numberWithCommas(
                                      (
                                        unit_t.custom_avg_price / unit_t.custom_avg_size
                                      ).toFixed(2)
                                    )
                                    : "-"
                                }}
                              </td>
                              <td v-b-modal="'mls-unit-' + unit_key" v-else class="_bg-light-blue">
                                {{
                                  unit_t.custom_avg_price && unit_t.custom_avg_size && unit_t
                                    ? "$" +
                                    numberWithCommas(
                                      Math.round(
                                        unit_t.custom_avg_price / unit_t.custom_avg_size
                                      )
                                    )
                                    : "-"
                                }}
                              </td>
                              <td>
                                <a class="border-vb-primary btn btn-outline-light text-vb-primary btn-sm" :href="'/unit-mix?uid=' +
                                  $route.query.uid +
                                  '&unit_key=' +
                                  unit_t.unit_key +
                                  '&size_range=' +
                                  unit_t.size_range +
                                  '&is_market_strata=' +
                                  isMarketStrata +
                                  '&project=' +
                                  $route.query.project +
                                  '&sid=' +
                                  $route.query.sid +
                                  '&fid=' +
                                  $route.query.fid
                                  " target="_blank">View Unit Mix</a>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                      <b-modal v-for="(unit_t, unit_key) in mlsTotalSort"
                        v-bind:key="'unit_breakdown_modal_' + unit_key" :id="'mls-unit-' + unit_key" hide-footer>
                        <template #modal-header="{ close }">
                          <!-- Emulate built in modal header close button action -->
                          <!-- Erl Todo -->
                          <h5 class="m-0">FLOOR PLAN BREAKDOWN</h5>
                          <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
                          <button type="button" aria-label="Close" class="close modal-close" @click="close()">
                            ×
                          </button>
                        </template>
                        <div class="row my-30">
                          <div class="col-xs-3 text-left">
                            <a :href="project.web_link ? project.web_link[0] : '#'
                              " target="_blank">
                              <h2>
                                <strong>{{ project.project_name }}</strong>
                              </h2>
                            </a>
                          </div>
                          <div class="col-xs-6 text-left d-flex justify-content-center align-items-center">
                            <div class="ml-3">
                              <span class="text-white p-2 mx-2 _price-backup"
                                style="background-color: #0b36dc">Verified</span>
                              <span class="text-white p-2 mx-2 _price-backup"
                                style="background-color: #ff6f16">Semi-Verified</span>
                              <span class="text-white bg-danger p-2 mx-2 _price-backup">Estimated</span>
                            </div>
                          </div>
                          <div class="col-sm-3 text-right">
                            <div class="modal-address">
                              {{ project.address }}
                            </div>
                          </div>
                        </div>
                        <table class="table text-left table-borderless plan-table">
                          <thead>
                            <th>BED</th>
                            <th>BATH</th>
                            <th>FP SPECS</th>
                            <th>SF</th>
                            <th>PLAN NAME</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="bed-column">
                                {{ unit_t.bed ? unit_t.bed : "0" }}-bed
                              </td>
                              <td>
                                {{ unit_t.bath ? unit_t.bath : "0" }}-bath
                              </td>
                              <td>{{ unit_t.fp_specs }}</td>
                              <td>
                                {{ unit_t.minSize | numFormat }} -
                                {{ unit_t.maxSize | numFormat }} SF
                              </td>
                              <td>
                                <span v-if="typeof unit_t.plan_name != 'undefined'">{{ unit_t.plan_name.join(", ")
                                }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="col-xs-6 d-block text-center" v-for="(file, file_key) in unit_t.floor_plan"
                          :key="'floor_plan_' + file_key">
                          <div class="row fp-img">
                            <a target="_blank" :href="file.link">
                              <img class="floorplan-pdf" :src="file.preview" />
                            </a>
                          </div>
                          <div class="row floor-plan-block">
                            <div class="col-xs-4"><b>Unit #</b></div>
                            <div class="col-xs-4"><b>Plan Name</b></div>
                            <div class="col-xs-4"><b>Size</b></div>
                          </div>
                          <div class="row floor-plan-block">
                            <div class="col-xs-4">{{ file.unit_num }}</div>
                            <div class="col-xs-4">{{ file.plan_name }}</div>
                            <div class="col-xs-4">{{ file.unit_size }}</div>
                          </div>
                          <div class="row floor-plan-block">
                            <div class="col-xs-4"><b>List Price</b></div>
                            <div class="col-xs-4"><b>Price Date</b></div>
                            <div class="col-xs-4"><b>Status</b></div>
                          </div>
                          <div class="row floor-plan-block">
                            <div class="col-xs-4" :style="{ color: setColor(file.price_backup) }">
                              {{
                                file.list_price
                                  ? "$" + numberWithCommas(file.list_price)
                                  : "$0"
                              }}
                            </div>
                            <div class="col-xs-4">
                              {{
                                file.price_date != "1969-12-31"
                                  ? file.price_date
                                  : "-"
                              }}
                            </div>
                            <div class="col-xs-4">{{ file.status }}</div>
                          </div>
                        </div>
                      </b-modal>
                    </template>
                  </div>
                </div>
                <b-alert v-if="isAdmin && showMessage.haveDiscrepancy && project.unit_component_note.length <= 0" show
                  variant="warning">
                  Released Units <span class="font-weight-bold">{{ showMessage.rlsd_units }}</span> and Total # of Units
                  <span class="font-weight-bold">{{ showMessage.total_units }}</span> in the Unit Breakdown table does
                  not match. Would you
                  like to leave a note ?
                </b-alert>
                <section
                  v-if="isAdmin || (!isAdmin && project.unit_component_note && project.unit_component_note.length > 0)">
                  <Notes :notes="project.unit_component_note" v-on:fetchData="fetchData" :openTab="openTab.value">
                  </Notes>
                </section>
                <div class="row print-only-flex">
                  <div class="col-md-12">
                    <h2 class="table-header-text text-left">
                      Permits and Bylaws
                    </h2>
                    <table class="table text-left">
                      <thead class="table-borderless fp-header" style="background: #12283fe5">
                        <th>TYPE</th>
                        <th>
                          <div style="margin-left: 30px">STATUS</div>
                        </th>
                        <th>SUBMISSION DATE</th>
                        <th>STATUS DATE</th>
                        <th># Month</th>
                      </thead>
                      <tbody>
                        <tr v-if="project.sd_sub_date || project.sd_app_date">
                          <td><b>Subdivision Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.sd_status)">⬤ {{ project.sd_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.sd_sub_date ? project.sd_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="project.ss_sub_date || project.ss_app_date">
                          <td><b>Site Servicing Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.ss_status)">⬤ {{ project.ss_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.ss_sub_date ? project.ss_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Rezoning</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.rz_status)">⬤ {{ project.rz_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.rz_sub_date ? project.rz_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="project.rz_fsr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">First and Second Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.rz_fsr_diff.app
                                ? project.rz_fsr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.rz_fsr_diff.month
                                ? project.rz_fsr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.rz_fr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">First Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.rz_fr_diff.app
                                ? project.rz_fr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.rz_fr_diff.month
                                ? project.rz_fr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.rz_sr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Second Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.rz_sr_diff.app
                                ? project.rz_sr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.rz_sr_diff.month
                                ? project.rz_sr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.rz_app_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Approval</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.rz_app_diff.app
                                ? project.rz_app_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.rz_app_diff.month
                                ? project.rz_app_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.rz_adopt_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Adoption</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.rz_adopt_diff.app
                                ? project.rz_adopt_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.rz_adopt_diff.month
                                ? project.rz_adopt_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.oa_sub_date || project.oa_app_date">
                          <td><b>OCP Amendment Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.oa_status)">⬤ {{ project.oa_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.oa_sub_date ? project.oa_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="project.ocp_fsr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">First and Second Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.ocp_fsr_diff.app
                                ? project.ocp_fsr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.ocp_fsr_diff.month
                                ? project.ocp_fsr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.ocp_fr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">First Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.ocp_fr_diff.app
                                ? project.ocp_fr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.ocp_fr_diff.month
                                ? project.ocp_fr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.ocp_sr_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Second Reading</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.ocp_sr_diff.app
                                ? project.ocp_sr_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.ocp_sr_diff.month
                                ? project.ocp_sr_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.ocp_app_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Approval</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.ocp_app_diff.app
                                ? project.ocp_app_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.ocp_app_diff.month
                                ? project.ocp_app_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.ocp_adopt_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Adoption</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.ocp_adopt_diff.app
                                ? project.ocp_adopt_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.ocp_adopt_diff.month
                                ? project.ocp_adopt_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Development Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.dp_status)">⬤ {{ project.dp_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.dp_sub_date ? project.dp_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="project.dp_app_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Approval</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.dp_app_diff.app
                                ? project.dp_app_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.dp_app_diff.month
                                ? project.dp_app_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.dp_issuance_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Issuance</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.dp_issuance_diff.app
                                ? project.dp_issuance_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.dp_issuance_diff.month
                                ? project.dp_issuance_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.dvp_sub_date || project.dvp_app_date">
                          <td><b>Development Variance Application</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.dvp_status)">⬤ {{ project.dvp_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.dvp_sub_date ? project.dvp_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="project.dvp_app_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Approval</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.dvp_app_diff.app
                                ? project.dvp_app_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.dvp_app_diff.month
                                ? project.dvp_app_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr v-if="project.dvp_issuance_diff">
                          <td>
                            <span class="st-symbol">⤷</span>
                            <span class="st-label">Issuance</span>
                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            {{
                              project.dvp_issuance_diff.app
                                ? project.dvp_issuance_diff.app
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              project.dvp_issuance_diff.month
                                ? project.dvp_issuance_diff.month
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Building Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.bp_status)">⬤ {{ project.bp_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.bp_sub_date ? project.bp_sub_date : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr v-if="
                          project.demolition_sub_date ||
                          project.demolition_app_date
                        ">
                          <td><b>Demolition Permit</b></td>
                          <td class="text-left status-col">
                            <span class="status-cell" :class="statusSwitch(project.demolition_status)">⬤ {{
                              project.demolition_status
                            }}</span>
                          </td>
                          <td>
                            {{
                              project.demolition_sub_date
                                ? project.demolition_sub_date
                                : "-"
                            }}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mt-5 print-only-flex">
                  <div class="col-md-12">
                    <h2 style="float: left" class="table-header-text text-left">
                      PLANNING PROCESS
                    </h2>
                    <span class="hidden-xs hidden-sm hidden-md btn btn-primary-reverse print-none"
                      style="float: right; margin-top: 20px" v-b-modal="'planning-docs'">Planning Docs</span>
                    <table class="table">
                      <thead class="fp-header">
                        <th>Date</th>
                        <th>Application Type</th>
                        <th>Application Stage</th>
                        <th>Outcome</th>
                        <th>CBA Status</th>
                      </thead>
                      <tbody class="fp-body fp-border">
                        <tr class="planning-table-cell" v-for="(val, key) in permitSort"
                          :key="'planning_process_' + key">
                          <td class="text-center">
                            <a v-if="val.file" :href="val.file" target="_blank">{{ val.time }}</a>
                            <div v-else>{{ val.time }}</div>
                          </td>
                          <td class="text-center">{{ val.col_1 }}</td>
                          <td class="text-center">{{ val.col_2 }}</td>
                          <td class="text-center" v-html="(val.col_3 ? val.col_3 : '') +
                            (val.col_4 ? '<br>' + val.col_4 : '') +
                            (val.col_5 ? '<br>' + val.col_5 : '') +
                            (val.col_6 ? '<br>' + val.col_6 : '')
                            "></td>
                          <td>
                            <div v-if="val.rz">REZ: {{ val.rz }}</div>
                            <div v-if="val.dp">DP: {{ val.dp }}</div>
                            <div v-if="val.dvp">DVP: {{ val.dvp }}</div>
                            <div v-if="val.sub">Sub: {{ val.sub }}</div>
                            <div v-if="val.srv">Serv: {{ val.srv }}</div>
                            <div v-if="val.demo">Demo: {{ val.demo }}</div>
                            <div v-if="val.ocp">OCP: {{ val.ocp }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <span class="btn btn-primary-reverse hidden-lg" style="float: right; margin-top: 20px"
                      v-b-modal="'planning-docs'">Planning Docs</span>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Unit Mix" :active="openTab.value === 'unitmix'" lazy>
              <div class="fields-toggle-wrapper" v-if="custom_header_field" ref="target_custom_header_field">
                <div class="fields-toggle-block selected-fields">
                  <div class="row justify-content-between">
                    <div class="fields-toggle-title">
                      Shown Data Point
                      <b-button size="sm" class="btn btn-outline-vb-primary btn-secondary btn-sm px-2 py-1 rounded-pill"
                        @click="resetHeaders"><font-awesome-icon :icon="['fas', 'undo']" /></b-button>
                    </div>
                    <font-awesome-icon style="
                        font-size: 20px;
                        cursor: pointer;
                        position: absolute;
                        top: 12px;
                        right: 12px;
                      " class="text-danger" @click="custom_header_field = false" :icon="['fas', 'times-circle']" />
                  </div>
                  <draggable class="row" :list="rpdTableList1" group="field" :move="checkMove" :sort="true">
                    <template v-for="(element, index) in rpdTableList1">
                      <div :class="{
                        'd-none': [
                          'checkbox',
                          'delete',
                          'updatemls',
                          'custom_price_change'
                        ].includes(element.key),
                      }" class="list-group-item _cursor-pointer" :key="'element-a123' + element.label">
                        {{ isAdmin ? --index : index }}. {{ element.label }}
                      </div>
                    </template>
                  </draggable>
                </div>
                <div class="fields-toggle-bar"></div>
                <div class="fields-toggle-block">
                  <div class="fields-toggle-title">
                    Drag and Drop Data Points
                  </div>
                  <draggable class="row" :list="rpdTableList2" group="field" :sort="true">
                    <template v-for="(element, index) in rpdTableList2">
                      <div :class="{
                        'd-none': ['checkbox', 'updatemls'].includes(
                          element.key.toLocaleLowerCase()
                        ),
                      }" class="list-group-item _cursor-pointer" :key="'element-a123' + element.label">
                        {{ element.label }}
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
              <div class="row mt-4 ml-1 justify-content-between align-items-center container"
                style="margin: 0 auto !important; max-width: 128rem">
                <div></div>
              </div>
              <div class="row py-3">
                <div class="col-md-12">
                  <div>
                    <RpdTable id="my-table" ref="unitMixTable" v-model="totalRows.all" :totalRows="totalRows.all"
                      :current-page="currentPage.all" :per-page="99999" :listing_type="'all'" :row_data="allMlsData"
                      :header_fields="rpdTableList1" :custom_headers="rpdTableList2" :user_role="current_user.role"
                      :project_status="project.status" :totalListingSummary="totalListingSummary"
                      :current-availability="currentAvailability" :isMarketStrata="isMarketStrata"
                      :query-params="queryParams" :project-type="project.new_p_type" :open-tab="openTab.value"
                      v-on:deleteMLS="deleteMLS" v-on:selectAllRows="selectAllRows" v-on:refreshResults="refreshResults"
                      v-on:toggleFavorite="toggleFavorite" v-on:updateTotalRows="updateTotalRows"
                      v-on:toggleField="toggleField" v-on:showUnitPreview="showUnitPreview"
                      v-on:updateFields="updateFields" v-on:updateMls="updateMls" v-on:popHistory="tabularRowHistory"
                      v-on:reloadData="reloadData" v-on:triggerBulkUpdate="handleBulkUpdateTrigger">
                    </RpdTable>
                    <b-modal id="tabular-history-modal" size="lg" hide-header hide-footer body-class="p-0"
                      modal-class="sp-bare-modal">
                      <template>
                        <SummaryPopUp :data="mlsData ? mlsData : []" :listing_type="'all'"
                          :project_status="project.status" :occupancy_date="project.occupancy_date"
                          :sold_out_date="project.sold_out_date" :mlsHistory="mlsData ? mlsData : []"
                          v-on:editMLSEntryNew="editMLSEntryNew" v-on:deleteMLSEntry="deleteMLSEntry"
                          v-on:showBackupTextModal="showBackupTextModal" :isMarketStrata="isMarketStrata"
                          v-on:close="$bvModal.hide('tabular-history-modal')" />
                      </template>
                    </b-modal>

                    <b-modal v-for="(d, k) in allMlsData" :id="'mls-fp-' + d.mls_floor_plan_feature.fid" hide-footer
                      :key="'other' + k">
                      <div v-if="d.mls_floor_plan_feature.fid" class="d-block text-center">
                        <a target="_blank" :href="d.mls_floor_plan_feature.link"><img class="floorplan-pdf"
                            :src="d.mls_floor_plan_feature.preview" /></a>
                      </div>
                    </b-modal>
                  </div>
                </div>
              </div>
              <b-modal id="mls-entry-new" hide-footer>
                <b-form v-on:submit.prevent="mlsEntryUpload" class="text-left">
                  <b-form-group id="mls-input-group-status" label="Status:" label-for="mls-upload-status">
                    <b-form-select id="mls-upload-status" v-model="MLSuploadForm.status"
                      :options="mlsStatus"></b-form-select>
                  </b-form-group>
                  <b-form-group id="mls-input-group-list-price" label="List Price:" label-for="mls-upload-list-price">
                    <b-form-input v-model="MLSuploadForm.listPrice" id="mls-upload-list-price" type="text"
                      placeholder="List Price"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-list-price" label="Sold Price:" label-for="mls-upload-sold-price">
                    <b-form-input v-model="MLSuploadForm.soldPrice" id="mls-upload-sold-price" type="text"
                      placeholder="Sold Price"></b-form-input>
                  </b-form-group>
                  <b-form-group id="input-group-price-backup" label="Price Backup:" label-for="upload-price-backup">
                    <b-form-select id="upload-price-backup" v-model="MLSuploadForm.priceBackup"
                      :options="priceBackupOption"></b-form-select>
                  </b-form-group>
                  <label for="upload-list-date" style="font-size: 1.8rem">List Price Date</label>
                  <b-form-datepicker id="mls-upload-list-price-date" v-model="MLSuploadForm.listPriceDate" reset-button
                    class="mb-2"></b-form-datepicker>
                  <label for="upload-list-date" style="font-size: 1.8rem">Sold Date</label>
                  <b-form-datepicker id="mls-upload-sold-date" v-model="MLSuploadForm.soldDate" reset-button
                    class="mb-2"></b-form-datepicker>
                  <label for="upload-backup-file" style="font-size: 1.8rem">Back-up File:</label>
                  <b-form-group id="mls-input-group-5">
                    <b-form-file v-model="MLSuploadForm.floorPlan" :state="Boolean(MLSuploadForm.floorPlan)"
                      placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
                  </b-form-group>
                  <b-form-group style="margin-top: 40px" id="mls-input-group-backup-text" label="Back-up Text:"
                    label-for="mls-upload-backup-text">
                    <b-form-input v-model="MLSuploadForm.backupText" id="mls-upload-backup-text" type="text"
                      placeholder="Backup Text"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-buyer-incentives" label="Buyer Incentives:"
                    label-for="mls-upload-buyer-incentives">
                    <b-form-input v-model="MLSuploadForm.buyerIncentives" id="mls-upload-buyer-incentives" type="text"
                      placeholder="Buyer Incentives"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-realtor-incentives" label="Realtor Incentives:"
                    label-for="mls-upload-realtor-incentives">
                    <b-form-input v-model="MLSuploadForm.realtorIncentives" id="mls-upload-realtor-incentives"
                      type="text" placeholder="Realtor Incentives"></b-form-input>
                  </b-form-group>
                  <b-button type="submit" variant="primary">Submit</b-button>
                </b-form>
              </b-modal>
            </b-tab>
            <b-tab title="Bulk Update" :active="openTab.value === 'bulk_update'" v-if="openTab.value === 'bulk_update'">
              <div class="content-utc-body mx-auto mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h3>Bulk Update Listings</h3>
                  <b-button @click="openTab = { title: 'Unit Mix', value: 'unitmix' }">
                    Back to Unit Mix
                  </b-button>
                </div>
                <!-- Pass the stored CIDs to the component -->
                <BulkUpload :selected-cids="selectedCidsForBulk" />
              </div>
            </b-tab>
            <b-tab title="Unit Mix Rental" :active="openTab.value === 'unitmixrental'" lazy>
              <div class="fields-toggle-wrapper" v-if="custom_header_field" ref="target_custom_header_field">
                <div class="fields-toggle-block selected-fields">
                  <div class="row justify-content-between">
                    <div class="fields-toggle-title">
                      Shown Data Point
                      <b-button size="sm" class="btn btn-outline-vb-primary btn-secondary btn-sm px-2 py-1 rounded-pill"
                        @click="resetHeaders"><font-awesome-icon :icon="['fas', 'undo']" /></b-button>
                    </div>
                    <font-awesome-icon style="
                        font-size: 20px;
                        cursor: pointer;
                        position: absolute;
                        top: 12px;
                        right: 12px;
                      " class="text-danger" @click="custom_header_field = false" :icon="['fas', 'times-circle']" />
                  </div>
                  <draggable class="row" :list="rpdTableList1" group="field" :move="checkMove" :sort="true">
                    <template v-for="(element, index) in rpdTableList1">
                      <div :class="{
                        'd-none': [
                          'checkbox',
                          'delete',
                          'updatemls',
                          'custom_price_change'
                        ].includes(element.key),
                      }" class="list-group-item _cursor-pointer" :key="'element-a123' + element.label">
                        {{ isAdmin ? --index : index }}. {{ element.label }}
                      </div>
                    </template>
                  </draggable>
                </div>
                <div class="fields-toggle-bar"></div>
                <div class="fields-toggle-block">
                  <div class="fields-toggle-title">
                    Drag and Drop Data Points
                  </div>
                  <draggable class="row" :list="rpdTableList2" group="field" :sort="true">
                    <template v-for="(element, index) in rpdTableList2">
                      <div :class="{
                        'd-none': ['checkbox', 'updatemls'].includes(
                          element.key.toLocaleLowerCase()
                        ),
                      }" class="list-group-item _cursor-pointer" :key="'element-a123' + element.label">
                        {{ element.label }}
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
              <div class="row mt-4 ml-1 justify-content-between align-items-center container"
                style="margin: 0 auto !important; max-width: 128rem">
                <div></div>
              </div>
              <div class="row py-3">
                <div class="col-md-12">
                  <div v-if="mlsRentalData.length > 0">
                    <RpdTable id="mls-rental-table" ref="unitMixRentalTable" v-model="totalRows.all"
                      :totalRows="totalRows.all" :current-page="currentPage.all" :per-page="99999"
                      :listing_type="'rental'" :row_data="mlsRentalData" :header_fields="rpdTableList1.filter(
                        (header) => header.key != 'updatemls'
                      )
                        " :custom_headers="rpdTableList2" :current-availability="currentAvailability"
                      :user_role="current_user.role" :project_status="project.status"
                      :totalListingSummary="totalListingSummary" :isMarketStrata="isMarketStrata"
                      :query-params="queryParams" :project-type="project.new_p_type" :open-tab="openTab.value"
                      v-on:deleteMLS="deleteMLS" v-on:selectAllRows="selectAllRows" v-on:refreshResults="refreshResults"
                      v-on:toggleFavorite="toggleFavorite" v-on:updateTotalRows="updateTotalRows"
                      v-on:toggleField="toggleField" v-on:showUnitPreview="showUnitPreview"
                      v-on:updateFields="updateFields" v-on:updateMls="updateMls" v-on:popHistory="popHistory"
                      v-on:deleteMlsRentalRow="deleteMlsRentalRow">
                    </RpdTable>
                    <b-modal id="rental-mls-popup" size="lg" hide-header hide-footer body-class="p-0"
                      modal-class="sp-bare-modal">
                      <SummaryPopUp :data="mlsData || []" :mlsHistory="mlsData || []" :listing_type="'rental'"
                        :project_status="project.status" :occupancy_date="project.occupancy_date"
                        :sold_out_date="project.sold_out_date" v-on:editMLSEntryNew="editMLSEntryNew"
                        v-on:deleteMLSEntry="deleteMLSEntry" v-on:showBackupTextModal="showBackupTextModal"
                        :isMarketStrata="isMarketStrata" v-on:close="$bvModal.hide('rental-mls-popup')" />
                    </b-modal>
                    <b-modal ref="editRentalModal" hide-footer title="Edit MLS Rental History">
                      <div class="d-block text-center">
                        <EditRentalForm v-if="editableRentalData" :rentalData="editableRentalData"
                          v-on:fetchData="fetchData" />
                      </div>
                    </b-modal>
                    <b-modal v-for="(d, k) in allMlsData" :id="'mls-fp-' + d.mls_floor_plan_feature.fid" hide-footer
                      :key="'other' + k">
                      <div v-if="d.mls_floor_plan_feature.fid" class="d-block text-center">
                        <a target="_blank" :href="d.mls_floor_plan_feature.link"><img class="floorplan-pdf"
                            :src="d.mls_floor_plan_feature.preview" /></a>
                      </div>
                    </b-modal>
                  </div>
                  <div v-else>
                    <b-alert show variant="info">
                      <h4 class="text-center py-3">
                        No rental listings available.
                      </h4>
                    </b-alert>
                  </div>
                  <Notes :notes="project.mls_rental_note" v-on:fetchData="fetchData" :openTab="openTab.value"></Notes>
                </div>
              </div>
              <b-modal id="mls-entry-new" hide-footer>
                <b-form v-on:submit.prevent="mlsEntryUpload" class="text-left">
                  <b-form-group id="mls-input-group-status" label="Status:" label-for="mls-upload-status">
                    <b-form-select id="mls-upload-status" v-model="MLSuploadForm.status"
                      :options="mlsStatus"></b-form-select>
                  </b-form-group>
                  <b-form-group id="mls-input-group-list-price" label="List Price:" label-for="mls-upload-list-price">
                    <b-form-input v-model="MLSuploadForm.listPrice" id="mls-upload-list-price" type="text"
                      placeholder="List Price"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-list-price" label="Sold Price:" label-for="mls-upload-sold-price">
                    <b-form-input v-model="MLSuploadForm.soldPrice" id="mls-upload-sold-price" type="text"
                      placeholder="Sold Price"></b-form-input>
                  </b-form-group>
                  <label for="upload-list-date" style="font-size: 1.8rem">List Price Date</label>
                  <b-form-datepicker id="mls-upload-list-price-date" v-model="MLSuploadForm.listPriceDate" reset-button
                    class="mb-2"></b-form-datepicker>
                  <label for="upload-list-date" style="font-size: 1.8rem">Sold Date</label>
                  <b-form-datepicker id="mls-upload-sold-date" v-model="MLSuploadForm.soldDate" reset-button
                    class="mb-2"></b-form-datepicker>
                  <label for="upload-backup-file" style="font-size: 1.8rem">Back-up File:</label>
                  <b-form-group id="mls-input-group-5">
                    <b-form-file v-model="MLSuploadForm.floorPlan" :state="Boolean(MLSuploadForm.floorPlan)"
                      placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
                  </b-form-group>
                  <b-form-group style="margin-top: 40px" id="mls-input-group-backup-text" label="Back-up Text:"
                    label-for="mls-upload-backup-text">
                    <b-form-input v-model="MLSuploadForm.backupText" id="mls-upload-backup-text" type="text"
                      placeholder="Backup Text"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-buyer-incentives" label="Buyer Incentives:"
                    label-for="mls-upload-buyer-incentives">
                    <b-form-input v-model="MLSuploadForm.buyerIncentives" id="mls-upload-buyer-incentives" type="text"
                      placeholder="Buyer Incentives"></b-form-input>
                  </b-form-group>
                  <b-form-group id="mls-input-group-realtor-incentives" label="Realtor Incentives:"
                    label-for="mls-upload-realtor-incentives">
                    <b-form-input v-model="MLSuploadForm.realtorIncentives" id="mls-upload-realtor-incentives"
                      type="text" placeholder="Realtor Incentives"></b-form-input>
                  </b-form-group>
                  <b-button type="submit" variant="primary">Submit</b-button>
                </b-form>
              </b-modal>
            </b-tab>
            <b-tab title="Availability" :active="openTab.value === 'availability'"
              v-if="project.is_admin && !project.skip_ava">
              <div class="row py-3">
                <div class="col-md-12">
                  <div class="row text-left">
                    <div class="col-4 mb-3" style="
                        font-style: normal;
                        font-weight: 800;
                        font-size: 17px;
                        line-height: 18px;
                        color: #4d7ce1;
                      ">
                      Current Availability
                    </div>
                  </div>
                  <div class="row text-left">
                    <div class="col-md-7">
                      <div class="row">
                        <div style="padding-left: 15px">
                          <div class="ft-avg-label mb-2">Units</div>
                          <div class="ft-avg-content" style="
                              padding-right: 50px;
                              border-right: solid 2px #000;
                            ">
                            {{ project.unit_component.available }}
                          </div>
                        </div>
                        <div style="margin-left: 50px">
                          <div class="ft-avg-label mb-2">Avg Size</div>
                          <div class="ft-avg-content" style="
                              padding-right: 50px;
                              border-right: solid 2px #000;
                            ">
                            {{
                              project.unit_component.active_avg_size | numFormat
                            }}
                          </div>
                        </div>
                        <div style="margin-left: 50px">
                          <div class="ft-avg-label mb-2">Avg Price</div>
                          <div class="ft-avg-content" style="
                              padding-right: 50px;
                              border-right: solid 2px #000;
                            ">
                            ${{
                              project.unit_component.active_avg_price
                              | numFormat
                            }}
                          </div>
                        </div>
                        <div style="margin-left: 50px">
                          <div class="ft-avg-label mb-2">Avg $PSF</div>
                          <div class="ft-avg-content">
                            ${{
                              project.unit_component.active_avg_psf | numFormat
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="
                    project.unit_component.activeBed &&
                    project.unit_component.activeBed.length !== 0
                  ">
                    <table class="table mt-3 table-striped">
                      <thead class="fp-header">
                        <!-- <th>Plan Name</th> -->
                        <th>Beds</th>
                        <th>FP Specs</th>
                        <th>Baths</th>
                        <th># Units</th>
                        <th>Parking</th>
                        <th>Stalls</th>
                        <th>Min SF</th>
                        <th>Max SF</th>
                        <th>Avg SF</th>
                        <th>Min Price</th>
                        <th>Max Price</th>
                        <th>Avg Price</th>
                        <th>Avg $PSF</th>
                      </thead>
                      <tbody class="fp-body">
                        <tr style="cursor: pointer" v-b-modal="'mls-unit-sold-' + unit_key"
                          v-for="(unit_t, unit_key) in mlsAvailTotalSort" v-bind:key="'ah_' + unit_key">
                          <!-- <td v-if="typeof unit_t.plan_name != 'undefined'">{{unit_t.plan_name.join(', ')}}</td>
                                                    <td v-else></td> -->
                          <td v-if="unit_t.bed == '-'">{{ unit_t.bed }}</td>
                          <td v-else>
                            {{ unit_t.bed ? unit_t.bed : "0" }}-bed
                          </td>
                          <td>{{ unit_t.fp_specs }}</td>
                          <td>{{ unit_t.bath }}</td>
                          <td>{{ unit_t.num }}</td>
                          <td>{{ unit_t.parking }}</td>
                          <td>{{ unit_t.stall ? unit_t.stall.final : "" }}</td>
                          <td>{{ unit_t.minSize | numFormat }}</td>
                          <td>{{ unit_t.maxSize | numFormat }}</td>
                          <td>
                            {{
                              ((unit_t.total_size * 1.0) / unit_t.num)
                              | numFormat
                            }}
                          </td>
                          <td>
                            {{
                              unit_t.minPrice
                                ? "$" + numberWithCommas(unit_t.minPrice)
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              unit_t.maxPrice
                                ? "$" + numberWithCommas(unit_t.maxPrice)
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              unit_t.avgPrice
                                ? "$" + numberWithCommas(unit_t.avgPrice)
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              unit_t.avgPrice && unit_t.total_size && unit_t
                                ? "$" +
                                numberWithCommas(
                                  (
                                    unit_t.avgPrice /
                                    (unit_t.total_size / unit_t.num)
                                  ).toFixed(0)
                                )
                                : "-"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-modal v-for="(unit_t, unit_key) in mlsAvailTotalSort" v-bind:key="'ai_' + unit_key"
                      :id="'mls-unit-sold-' + unit_key" hide-footer>
                      <template #modal-header="{ close }">
                        <!-- Emulate built in modal header close button action -->
                        <h5>FLOOR PLAN BREAKDOWN</h5>
                        <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
                        <button type="button" aria-label="Close" class="close modal-close" @click="close()">
                          ×
                        </button>
                      </template>
                      <div class="row my-30">
                        <div class="col-xs-3 text-left">
                          <a :href="project.web_link ? project.web_link[0] : '#'" target="_blank">
                            <h2>
                              <strong>{{ project.project_name }}</strong>
                            </h2>
                          </a>
                        </div>
                        <div class="col-xs-3 text-left">
                          <a :href="'/unit-mix?uid=' +
                            $route.query.uid +
                            '&unit_key=' +
                            unit_t.unit_key +
                            '&size_range=' +
                            unit_t.size_range +
                            '&is_market_strata=' +
                            isMarketStrata
                            " target="_blank">View Unit Mix</a>
                        </div>
                        <div class="col-sm-6 text-right">
                          <div class="modal-address">{{ project.address }}</div>
                        </div>
                      </div>
                      <table class="table text-left table-borderless plan-table">
                        <thead>
                          <th>BED</th>
                          <th>BATH</th>
                          <th>FP SPECS</th>
                          <th>SF</th>
                          <th>PLAN NAME</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="bed-column">
                              {{ unit_t.bed ? unit_t.bed : "0" }}-bed
                            </td>
                            <td>{{ unit_t.bath ? unit_t.bath : "0" }}-bath</td>
                            <td>{{ unit_t.fp_specs }}</td>
                            <td>
                              {{ unit_t.minSize | numFormat }} -
                              {{ unit_t.maxSize | numFormat }} SF
                            </td>
                            <td>
                              <span v-if="typeof unit_t.plan_name != 'undefined'">{{ unit_t.plan_name.join(", ")
                              }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col-xs-6 d-block text-center" v-for="(file, file_key) in unit_t.floor_plan"
                        :key="'aj_' + file_key">
                        <div class="row fp-img">
                          <a target="_blank" :href="file.link"><img class="floorplan-pdf" :src="file.preview" /></a>
                        </div>
                        <div class="row floor-plan-block">
                          <div class="col-xs-4"><b>Unit #</b></div>
                          <div class="col-xs-4"><b>Status</b></div>
                          <div class="col-xs-4" v-if="file.status == 'Active'">
                            <b>List Price</b>
                          </div>
                          <div class="col-xs-4" v-else><b>Sold Price</b></div>
                        </div>
                        <div class="row floor-plan-block">
                          <div class="col-xs-4">{{ file.unit_num }}</div>
                          <div class="col-xs-4">{{ file.status }}</div>
                          <div v-if="file.status == 'Active'" class="col-xs-4">
                            {{
                              file.list_price
                                ? "$" + numberWithCommas(file.list_price)
                                : "$0"
                            }}
                          </div>
                          <div v-else class="col-xs-4">
                            {{
                              file.sold_price
                                ? "$" + numberWithCommas(file.sold_price)
                                : "$0"
                            }}
                          </div>
                        </div>
                        <div class="row floor-plan-block">
                          <div class="col-xs-4"><b>Beds</b></div>
                          <div class="col-xs-4"><b>Baths</b></div>
                          <div class="col-xs-4"><b>Size</b></div>
                        </div>
                        <div class="row floor-plan-block">
                          <div class="col-xs-4">
                            {{ unit_t.bed ? unit_t.bed : "0" }}
                          </div>
                          <div class="col-xs-4">
                            {{ unit_t.bath ? unit_t.bath : "0" }}
                          </div>
                          <div class="col-xs-4">{{ file.unit_size }}</div>
                        </div>
                      </div>
                    </b-modal>
                  </template>
                </div>
              </div>
            </b-tab>
            <b-tab title="Development Stats" :active="openTab.value === 'developmentstats'">
              <template v-if="typeGroup">
                <ProjectTypeUTC :group-info="typeGroup" :utc-info="utcExtra" :fid="collection_ids"></ProjectTypeUTC>
              </template>
            </b-tab>
            <b-tab title="Permits" :active="openTab.value === 'permits'" v-if="
              ['admin', 'developer', 'developerbc'].includes(
                current_user.role
              )
            ">
              <div class="row align-items-center justify-content-end mr-3 mb-4">
                <template v-if="
                  ['developer', 'developerbc'].includes(current_user.role)
                ">
                  <b-button class="mx-1 btn-sm" variant="vb-secondary" v-b-modal="'consultant'"
                    pill>Consultants</b-button>
                </template>
                <b-button class="mx-1 btn-sm ml-3" variant="vb-primary" v-b-modal="'planning-docs'" pill>Planning
                  Docs</b-button>
              </div>
              <b-card no-body>
                <b-tabs card>
                  <b-tab title="Permits" active>
                    <div class="row">
                      <div class="col-md-12">
                        <table class="table text-left table-striped" id="permit_table">
                          <thead class="table text-light text-center bg-vb-secondary">
                            <th>Entitlement Stage</th>
                            <th>Status</th>
                            <th>Submission Date</th>
                            <th>Status Date</th>
                            <th># of Months</th>
                          </thead>
                          <tbody class="text-center">
                            <tr v-if="project.sd_sub_date || project.sd_app_date">
                              <td><strong>Subdivision Permit</strong></td>
                              <td class="status-col">
                                <span>{{ project.sd_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.sd_sub_date
                                    ? project.sd_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.ss_sub_date || project.ss_app_date">
                              <td><strong>Site Servicing Permit</strong></td>
                              <td class="status-col">
                                <span> {{ project.ss_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.ss_sub_date
                                    ? project.ss_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><strong>Rezoning</strong></td>
                              <td class="status-col">
                                <span>{{ project.rz_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.rz_sub_date
                                    ? project.rz_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.rz_fsr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">First and Second Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.rz_fsr_diff.app
                                    ? project.rz_fsr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.rz_fsr_diff.month
                                    ? project.rz_fsr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.rz_fr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">First Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.rz_fr_diff.app
                                    ? project.rz_fr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.rz_fr_diff.month
                                    ? project.rz_fr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.rz_sr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Second Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.rz_sr_diff.app
                                    ? project.rz_sr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.rz_sr_diff.month
                                    ? project.rz_sr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.rz_app_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Approval</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.rz_app_diff.app
                                    ? project.rz_app_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.rz_app_diff.month
                                    ? project.rz_app_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.rz_adopt_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Adoption</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.rz_adopt_diff.app
                                    ? project.rz_adopt_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.rz_adopt_diff.month
                                    ? project.rz_adopt_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.oa_sub_date || project.oa_app_date">
                              <td><strong>OCP Amendment Permit</strong></td>
                              <td class="status-col">
                                <span>{{ project.oa_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.oa_sub_date
                                    ? project.oa_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.ocp_fsr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">First and Second Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.ocp_fsr_diff.app
                                    ? project.ocp_fsr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.ocp_fsr_diff.month
                                    ? project.ocp_fsr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.ocp_fr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">First Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.ocp_fr_diff.app
                                    ? project.ocp_fr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.ocp_fr_diff.month
                                    ? project.ocp_fr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.ocp_sr_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Second Reading</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.ocp_sr_diff.app
                                    ? project.ocp_sr_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.ocp_sr_diff.month
                                    ? project.ocp_sr_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.ocp_app_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Approval</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.ocp_app_diff.app
                                    ? project.ocp_app_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.ocp_app_diff.month
                                    ? project.ocp_app_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.ocp_adopt_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Adoption</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.ocp_adopt_diff.app
                                    ? project.ocp_adopt_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.ocp_adopt_diff.month
                                    ? project.ocp_adopt_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Development Permit</strong></td>
                              <td class="status-col">
                                <span>{{ project.dp_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.dp_sub_date
                                    ? project.dp_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.dp_app_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Approval</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.dp_app_diff.app
                                    ? project.dp_app_diff.app
                                    : "-"
                                }}
                                test
                              </td>
                              <td>
                                {{
                                  project.dp_app_diff.month
                                    ? project.dp_app_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.dp_issuance_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Issuance</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.dp_issuance_diff.app
                                    ? project.dp_issuance_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.dp_issuance_diff.month
                                    ? project.dp_issuance_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="
                              project.dvp_sub_date || project.dvp_app_date
                            ">
                              <td>
                                <strong>Development Variance Application</strong>
                              </td>
                              <td class="status-col">
                                <span>{{ project.dvp_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.dvp_sub_date
                                    ? project.dvp_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.dvp_app_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Approval</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.dvp_app_diff.app
                                    ? project.dvp_app_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.dvp_app_diff.month
                                    ? project.dvp_app_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="project.dvp_issuance_diff">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Issuance</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.dvp_issuance_diff.app
                                    ? project.dvp_issuance_diff.app
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.dvp_issuance_diff.month
                                    ? project.dvp_issuance_diff.month
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="
                              ['admin', 'developer', 'developerbc'].includes(
                                current_user.role
                              )
                            ">
                              <td><strong>Building Permit</strong></td>
                              <td class="status-col">
                                <span>{{
                                  !["Not Submitted"].includes(project.bp_status)
                                    ? project.bp_status
                                    : "-"
                                }}</span>
                              </td>
                              <td>
                                {{
                                  project.bp_sub_date
                                    ? project.bp_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr v-if="project.bp_status == 'Issued'">
                              <td>
                                <span class="st-symbol">⤷</span>
                                <span class="st-label">Issuance</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {{
                                  project.bp_app_date
                                    ? project.bp_app_date
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  project.bp_range && project.bp_sub_date
                                    ? project.bp_range
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr v-if="
                              project.demolition_sub_date ||
                              project.demolition_app_date
                            ">
                              <td><strong>Demolition Permit</strong></td>
                              <td class="status-col">
                                <span class="status-cell" :class="statusSwitch(project.demolition_status)
                                  ">⬤ {{ project.demolition_status }}</span>
                              </td>
                              <td>
                                {{
                                  project.demolition_sub_date
                                    ? project.demolition_sub_date
                                    : "-"
                                }}
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Planning Process">
                    <div class="row mt-5">
                      <div class="col-md-12">
                        <section class="d-inline-flex justify-content-between align-items-center my-3">
                          <div>
                            <span class="btn btn-primary-reverse hidden-lg" v-b-modal="'planning-docs'">Planning
                              Docs</span>
                          </div>
                        </section>

                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead class="table text-light text-center" style="
                                background: rgba(18, 40, 63, 1);
                                top: 0;
                                position: sticky;
                                z-index: 999;
                              ">
                              <th>Date</th>
                              <th>Application Type</th>
                              <th>Application Stage</th>
                              <th>Application Stage 2</th>
                              <th>Application Stage 3</th>
                              <th>Application Stage 4</th>
                              <th>CBA Status</th>
                            </thead>
                            <tbody class="fp-body fp-border">
                              <tr class="planning-table-cell" v-for="(val, key) in permitSort" :key="'ak_' + key">
                                <td class="text-center">
                                  <a v-if="val.file" :href="val.file" target="_blank">{{ val.time }}</a>
                                  <div v-else>{{ val.time }}</div>
                                </td>
                                <td>
                                  {{ val.col_1 }}
                                </td>
                                <!-- <td class="text-center">{{val.col_1}}</td> -->
                                <td class="text-center">{{ val.col_2 }}</td>
                                <!-- <td class="text-center" v-html="(val.col_3 ? val.col_3 : '') + (val.col_4 ? '<br>'+val.col_4: '') + (val.col_5 ? '<br>'+val.col_5: '') + (val.col_6 ? '<br>'+val.col_6: '')"></td> -->

                                <td>
                                  {{ val.col_3 }}
                                </td>
                                <td>
                                  {{ val.col_4 }}
                                </td>
                                <td>
                                  {{ val.col_5 }}
                                </td>
                                <td>
                                  <div v-if="val.rz">REZ: {{ val.rz }}</div>
                                  <div v-if="val.dp">DP: {{ val.dp }}</div>
                                  <div v-if="val.dvp">DVP: {{ val.dvp }}</div>
                                  <div v-if="val.sub">Sub: {{ val.sub }}</div>
                                  <div v-if="val.srv">Serv: {{ val.srv }}</div>
                                  <div v-if="val.demo">
                                    Demo: {{ val.demo }}
                                  </div>
                                  <div v-if="val.ocp">OCP: {{ val.ocp }}</div>
                                  <div v-if="val.bp">BP: {{ val.bp }}</div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
              <b-modal id="planning-docs" hide-footer title="Planning Docs">
                <table class="table">
                  <thead class="fp-header">
                    <th>File Type</th>
                    <th>Date</th>
                  </thead>
                  <tbody class="fp-body">
                    <tr v-for="(d, key) in project.city_app" :key="'plan' + key">
                      <td>
                        <a :href="d.planning_doc_file.uri" target="_blank">{{
                          d.planning_doc_file.filename
                        }}</a>
                      </td>
                      <td>{{ d.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-modal>
            </b-tab>
            <b-tab title="Notes" :active="openTab.value === 'notes'">
              <h2 class="content-utc-body text-left mx-auto text-decoration-none mt-30">
                NOTES
              </h2>
              <div class="content-utc-body row mx-auto">
                <div class="col-lg-4 col-md-6 p-3" v-for="(note, key) in project.note" :key="'am_' + key">
                  <div class="note-item">
                    <div class="text-left note-date mb-3">
                      Date: {{ note.date }}
                    </div>
                    <div class="text-left note-body" v-html="note.note"></div>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 mt-5">
                  <b-button class="border-1 border-secondary btn btn-light btn-secondary round_btn"><font-awesome-icon
                      :icon="['fas', 'arrow-left']" class="text-black-50" /></b-button>

                  <b-button class="border-1 border-secondary btn btn-light btn-secondary round_btn"><font-awesome-icon
                      :icon="['fas', 'arrow-right']" class="text-black-50" /></b-button>
                </div>
              </div>
            </b-tab>
            <!-- <b-tab title="Upload"  v-if="project.is_admin"> -->
            <b-tab title="Upload" :active="openTab.value === 'upload'">
              <template>
                <img class="upload-spinner" v-if="upload_is_loading" src="/images/spinner.gif" />
                <div class="text-left">
                  <b-form v-on:submit.prevent="mlsUpload">
                    <label class="typo__label">Transfer:</label>
                    <b-form-group id="input-group-6">
                      <b-form-file v-model="uploadForm.importUnitTransfer"
                        :state="Boolean(uploadForm.importUnitTransfer)" placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."></b-form-file>
                    </b-form-group>
                    <label class="typo__label">CSV Import:</label>
                    <b-form-group id="input-group-6">
                      <b-form-file v-model="uploadForm.importCSV" :state="Boolean(uploadForm.importCSV)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."></b-form-file>
                    </b-form-group>
                    <label class="typo__label">Floor plan upload:</label>
                    <b-form-group id="input-group-5">
                      <b-form-file v-model="uploadForm.floorPlan" :state="Boolean(uploadForm.floorPlan)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."></b-form-file>
                    </b-form-group>
                    <b-form-group id="input-group-list-pid" label="PID:" label-for="upload-list-pid">
                      <b-form-input v-model="uploadForm.pid" id="upload-list-pid" type="text"
                        placeholder="PID"></b-form-input>
                    </b-form-group>
                    <div class="row">
                      <div class="col-3">
                        <b-form-group id="input-group-list-unit" label="Unit:" label-for="upload-list-unit">
                          <b-form-input v-model="uploadForm.unit" id="upload-list-unit" type="text"
                            placeholder="Unit Number"></b-form-input>
                        </b-form-group>
                      </div>
                      <div v-if="project.is_admin" class="col-9 pt-4">
                        {{ project.short_address }}
                      </div>
                    </div>
                    <b-form-group id="input-group-list-plan-name" label="Plan Name:" label-for="upload-list-plan-name">
                      <b-form-input v-model="uploadForm.planName" id="upload-list-plan-name" type="text"
                        placeholder="Plan Name"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-list-bed" label="Beds:" label-for="upload-list-bed">
                      <b-form-input v-model="uploadForm.bed" id="upload-list-bed" type="text"
                        placeholder="Beds"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-list-bath" label="Bath:" label-for="upload-list-bath">
                      <b-form-input v-model="uploadForm.bath" id="upload-list-bath" type="text"
                        placeholder="Bath"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-list-unit-size" label="Unit Size:" label-for="upload-list-unit-size">
                      <b-form-input v-model="uploadForm.unitSize" id="upload-list-unit-size" type="text"
                        placeholder="Unit Size"></b-form-input>
                    </b-form-group>
                    <label class="typo__label">FP Specs:</label>
                    <multiselect v-model="uploadForm.fp" :options="mlsFP" :multiple="true" :close-on-select="false"
                      :clear-on-select="false" :preserve-search="true" placeholder="" label="name" track-by="value">
                      <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                          v-if="values.length && !isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>
                    <b-form-group id="input-group-orientation" label="View Orientation:" label-for="upload-orientation">
                      <b-form-select id="upload-orientation" v-model="uploadForm.orientation"
                        :options="mlsOrientation"></b-form-select>
                    </b-form-group>
                    <b-form-group id="input-group-floor-level" label="Floor Level:" label-for="upload-floor-level">
                      <b-form-select id="upload-floor-level" v-model="uploadForm.fl"
                        :options="mlsFloorLevel"></b-form-select>
                    </b-form-group>
                    <label for="upload-list-date">List Date</label>
                    <b-form-datepicker id="upload-list-date" v-model="uploadForm.listDate" reset-button
                      class="mb-2"></b-form-datepicker>
                    <b-form-group id="input-group-list-price" label="List Price:" label-for="upload-list-price">
                      <b-form-input v-model="uploadForm.listPrice" id="upload-list-price" type="text"
                        placeholder="List Price"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-price-backup" label="Price Backup:" label-for="upload-price-backup">
                      <b-form-select id="upload-price-backup" v-model="uploadForm.priceBackup"
                        :options="priceBackupOption"></b-form-select>
                    </b-form-group>
                    <label for="upload-list-price-date">List Price Date</label>
                    <b-form-datepicker id="upload-list-price-date" v-model="uploadForm.listPriceDate" reset-button
                      class="mb-2"></b-form-datepicker>
                    <label for="upload-backup-file" style="font-size: 1.8rem">Back-up File:</label>
                    <b-form-group id="upload-backup-file">
                      <b-form-file v-model="uploadForm.backupfile" :state="Boolean(uploadForm.backupfile)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."></b-form-file>
                    </b-form-group>
                    <b-form-group id="input-group-balcony" label="Balcony:" label-for="upload-balcony">
                      <b-form-select id="upload-balcony" v-model="uploadForm.balcony"
                        :options="balconyOrientation"></b-form-select>
                    </b-form-group>
                    <b-form-group id="input-group-balcony-area" label="Balcony Area:" label-for="upload-balcony-area">
                      <b-form-input v-model="uploadForm.balconyArea" id="upload-balcony-area" type="text"
                        placeholder="Balcony Area"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-parking" label="Parking:" label-for="upload-parking">
                      <b-form-input v-model="uploadForm.parking" id="upload-parking" type="text"
                        placeholder="Parking"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-parking" label="Parking:" label-for="upload-parking">
                      <b-form-select id="upload-parking" v-model="uploadForm.pr" :options="mlsParking"></b-form-select>
                    </b-form-group>
                    <b-form-group id="input-group-locker" label="Locker:" label-for="locker">
                      <b-form-input v-model="uploadForm.locker" id="upload-locker" type="text"
                        placeholder="Locker"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-gst" label="GST Included:" label-for="upload-gst">
                      <b-form-input v-model="uploadForm.gst" id="upload-gst" type="text"
                        placeholder="GST Included"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-buyer-incentives" label="Buyer Incentives:"
                      label-for="upload-buyer-incentives">
                      <b-form-input v-model="uploadForm.buyerIncentives" id="upload-buyer-incentives" type="text"
                        placeholder="Buyer Incentives"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-realtor-incentives" label="Realtor Incentives:"
                      label-for="upload-realtor-incentives">
                      <b-form-input v-model="uploadForm.realtorIncentives" id="upload-realtor-incentives" type="text"
                        placeholder="Realtor Incentives"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-status" label="Status:" label-for="upload-status">
                      <b-form-select id="upload-status" v-model="uploadForm.status"
                        :options="mlsStatus"></b-form-select>
                    </b-form-group>
                    <label for="upload-sold-date">Sold Date</label>
                    <b-form-datepicker id="upload-sold-date" v-model="uploadForm.soldDate" reset-button
                      class="mb-2"></b-form-datepicker>
                    <b-form-group id="input-group-sold-price" label="Sold Price:" label-for="upload-sold-price">
                      <b-form-input v-model="uploadForm.soldPrice" id="upload-sold-price" type="text"
                        placeholder="Sold Price"></b-form-input>
                    </b-form-group>
                    <b-form-group id="upload-group-assignment">
                      <b-form-checkbox-group id="update-assignment">
                        <b-form-checkbox v-model="uploadForm.assignment">Assignment</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group id="upload-group-new-entry">
                      <b-form-checkbox-group id="update-new-entry">
                        <b-form-checkbox v-model="uploadForm.newEntry">New Entry</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group id="upload-group-original-entry">
                      <b-form-checkbox-group id="update-original-entry">
                        <b-form-checkbox v-model="uploadForm.originalEntry">Original Entry</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>

                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-form>
                </div>
              </template>
            </b-tab>
            <b-tab title="Mls Rental Upload" v-if="showFlag || isAdmin" :active="openTab.value === 'uploadnew'">
              <div>
                <MlsForm :mlsCid="mlsCid" :mlsUnit="mlsUnit" :embedded="true" v-on:fetchData="fetchData" />
              </div>
            </b-tab>
            <b-tab title="Project History" :active="openTab.value === 'history'">
              <HistoryTable :row_data="formattedProjectHistory" :project_status="project.status"
                v-on:getHistoryNote="getHistoryNote" v-on:reloadData="fetchProjectHistory"
                v-if="formattedProjectHistory && isAdmin">
              </HistoryTable>
              <OverviewHistoryTable :unitData="historyOverView" v-if="isAdmin" />
              <div class="row mt-4 align-items-center">
                <div class="col-md-5">
                  <b-table hover small striped thead-class="bg-vb-secondary text-light position-sticky" caption-top
                    :items="soldLastQuarter" :fields="soldLastQuarterFields">
                    <template #cell(note)="data">
                      <b-button variant="vb-primary" v-if="data.value != null && data.value.length > 0"
                        v-b-modal.history_note @click="history_note = data.value">View</b-button>
                    </template>
                    <template #cell(confirmed_sold)="data">
                      <span class="font-weight-bold" @click="getUnits(data.item.units)"
                        style="cursor: pointer; text-decoration: underline">{{ data.value }}</span>
                    </template>
                    <template #custom-foot="data">
                      <b-tr class="bg-vb-accent text-vb-primary">
                        <b-td class="border-right-0 font-weight-bold">Total:
                        </b-td>
                        <b-td class="font-weight-bold">
                          <span v-if="isMarketStrata">{{
                            unitComponent.find((item) =>
                              item.hasOwnProperty("Rept Sold")
                            )["Rept Sold"]
                          }}</span>
                          <span v-else>{{
                            unitComponent.find((item) =>
                              item.hasOwnProperty("Rept Lsd")
                            )["Rept Lsd"]
                          }}</span>
                        </b-td>
                        <b-td class="font-weight-bold" v-if="isAdmin">
                          <span>
                            {{
                              soldLastQuarter.reduce(
                                (acc, item) => acc + (item.confirmed_sold || 0),
                                0
                              )
                            }}
                          </span>
                        </b-td>
                        <b-td class="font-weight-bold" v-if="isAdmin">
                          <span>
                            {{
                              soldLastQuarter.reduce(
                                (acc, item) =>
                                  acc + (item.total_confirmed_sold || 0),
                                0
                              )
                            }}
                          </span>
                        </b-td>
                        <b-td>
                          <b-button v-if="
                            projectHistory.length == 1 &&
                            project.note.length > 0
                          " variant="vb-primary" v-b-modal.history_note
                            @click="history_note = project.note">View</b-button>
                        </b-td>
                      </b-tr>
                    </template>
                    <template #table-caption>
                      <span class="font-weight-bold" v-if="quarterSalesStartDate">{{
                        isMarketStrata
                          ? "Sales Start Date"
                          : "Lease Start Date"
                      }}: {{ project.sales_start_date }} ({{
                          quarterSalesStartDate.quarter
                        }})</span>
                    </template>
                  </b-table>
                </div>
                <div class="col-md-7" v-if="isAdmin && isLoadedChart">
                  <div style="max-width: 800px" class="m-auto">
                    <canvas ref="myChart"></canvas>
                  </div>
                </div>
              </div>

              <b-modal id="confirmed-sold-modal" title="Confirmed Sold" ok-only>
                <b-table :items="confirmed_sold_units" :fields="confirmed_sold_unit_fields" striped hover bordered small
                  thead-class="position-sticky" head-variant="dark">
                </b-table>
              </b-modal>
            </b-tab>
            <b-tab title="Project Features" v-if="
              ['admin', 'developer', 'developerbc'].includes(
                current_user.role
              )
            " :active="openTab.value === 'features'">
              <h2 class="text-decoration-none text-vb-primary" v-if="
                !['selling soon', 'in planning', 'leasing soon'].includes(
                  project.status.toLowerCase()
                )
              ">
                Project Features
              </h2>
              <div class="row" v-if="
                !['selling soon', 'in planning', 'leasing soon'].includes(
                  project.status.toLowerCase()
                )
              ">
                <div class="col-md-6 mt-5">
                  <div id="accordion">
                    <!-- Accordion Item 1 -->
                    <div class="card">
                      <div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseOne"
                        aria-expanded="true" aria-controls="collapseOne" style="cursor: pointer">
                        <span class="mb-0 text-vb-primary"> Amenities </span>
                        <!-- <font-awesome-icon :icon="accordion_arrow.split(' ')" class="float-right"/> -->
                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body">
                          <div v-for="(item, index) in amenities" :key="index" class="my-1 text-vb-primary">
                            <font-awesome-icon :icon="item.icon.split(' ')" class="mr-2" />
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseTwo"
                        aria-expanded="true" aria-controls="collapseOne" style="cursor: pointer">
                        <span class="mb-0 text-vb-primary">
                          Finishing Type
                        </span>
                        <!-- <font-awesome-icon :icon="accordion_arrow.split(' ')" class="float-right"/> -->
                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body"></div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseThree"
                        aria-expanded="true" aria-controls="collapseOne" style="cursor: pointer">
                        <span class="mb-0 text-vb-primary"> Appliances </span>
                        <!-- <font-awesome-icon :icon="accordion_arrow.split(' ')" class="float-right"/> -->
                      </div>

                      <div id="collapseThree" class="collapse show" aria-labelledby="headingOne"
                        data-parent="#accordion">
                        <div class="card-body"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <b-table :items="feature_items" striped hover bordered small head-variant="dark"></b-table>
                  <b-button class="mx-2" variant="vb-primary" v-b-modal="'feature-files'" v-if="
                    project.date_based_features &&
                    project.date_based_features.length > 0
                  " pill>Features</b-button>
                </div>
              </div>
              <div class="mt-30" v-if="mergedGallery.length > 0">
                <div class="justify-content-between px-3 row align-items-end">
                  <b-form-select v-model="selectedGalleryType" :options="galleryOptions"
                    style="max-width: max-content"></b-form-select>
                  <div class="h4 m-0">Featured Gallery</div>
                </div>
                <div class="masonry-div mt-30 border border-1 border-vb-accent masonry-div mt-10 p-3 rounded-lg"
                  v-if="mergedGallery.length > 0">
                  <div class="card-columns" style="cursor: pointer">
                    <div class="card" v-for="(image, m_gallery_index) in mergedGallery"
                      @click="$bvModal.show('media' + image.url)" :key="m_gallery_index">
                      <img :src="image.url" class="card-img-top" alt="..." />
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Amenity Details" :active="openTab.value === 'amenity_details'">
              <AmenityDetails :amenity-details="project.amenity_details" v-on:fetchData="fetchData"
                :is_approve_amenities="project.is_approve_amenities" />
            </b-tab>
            <b-tab title="Project timeline" :active="openTab.value === 'timeline'">
              <ProjectTimeline :construction_photo_timeline_result="project.construction_photo_timeline_result"
                v-on:fetchData="fetchData">
              </ProjectTimeline>
            </b-tab>
          </b-tabs>
        </div>
        <b-modal id="history_note" title="Note" hide-footer style="max-width: 40rem" class="mx-0-auto">
          <div v-if="history_note && history_note.length > 0" class="card card-body bg-vb-accent">
            <span v-html="history_note[0].note" class="font-weight-normal"></span>
            <span v-html="history_note[0].date" class="font-italic font-weight-bold"></span>
          </div>
        </b-modal>
        <b-modal v-for="(image, index) in mergedGallery" :id="'media' + image.url" hide-footer hide-header :key="index">
          <div>
            <img :src="image.url" class="card-img-top" alt="..." />
          </div>
        </b-modal>
        <b-modal id="feature-files" size="lg" hide-footer>
          <template #modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <h5>FEATURE FILES</h5>
            <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal" />
            <button type="button" aria-label="Close" class="close modal-close" @click="close()">
              ×
            </button>
          </template>
          <div class="row my-30">
            <div class="col-xs-6 text-left">
              <a :href="project.web_link ? project.web_link[0] : '#'" target="_blank">
                <h2>
                  <strong>{{ project.project_name }}</strong>
                </h2>
              </a>
            </div>
            <div class="col-xs-6 text-right">
              <div class="modal-address">{{ project.address }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 d-block text-center" v-for="(file, file_k) in project.date_based_features"
              :key="'ao_' + file_k">
              <a target="_blank" :href="file.link"><img class="floorplan-pdf" :src="file.preview" /></a>
            </div>
          </div>
        </b-modal>
        <b-modal id="site-plan-files" hide-footer>
          <template #modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <h5 class="m-0 text-center w-100">SITE PLAN</h5>
            <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
            <button type="button" aria-label="Close" class="close modal-close" @click="close()">
              ×
            </button>
          </template>
          <div class="row my-30">
            <div class="col-xs-6 text-left">
              <a :href="project.web_link ? project.web_link[0] : '#'" target="_blank">
                <h2>
                  <strong>{{ project.project_name }}</strong>
                </h2>
              </a>
            </div>
            <div class="col-sm-6 text-right">
              <div class="modal-address">{{ project.address }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 d-block text-center site-plan-bg" v-for="(file, file_k) in project.site_plan_features"
              :key="'ap_' + file_k">
              <a target="_blank" :href="file.link"><img class="floorplan-pdf" :src="file.preview" /></a>
            </div>
          </div>
        </b-modal>
        <b-modal id="modal-incentives" hide-footer no-stacking>
          <template #modal-header="{ close }">
            <!-- Incentives Modal -->
            <h5 class="m-0 text-center w-100">INCENTIVES</h5>
            <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
            <button type="button" aria-label="Close" class="close modal-close" @click="close()">
              ×
            </button>
          </template>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="border bg-light">
                <th>
                  <b-button v-if="isAdmin" class="btn-vb-primary" v-b-modal.add-entry-modal>Add Entry</b-button>
                </th>
                <th class="font-weight-bold">Buyer Incentives</th>
                <th class="font-weight-bold">Realtor Incentives</th>
                <th class="font-weight-bold">Realtor Commission</th>
                <th class="font-weight-bold">Assignment Fee</th>
                <th class="font-weight-bold">Deposit</th>
                <th class="font-weight-bold" v-if="isAdmin">Backup File</th>
                <th class="font-weight-bold" v-if="isAdmin">Action</th>
              </thead>
              <tbody>
                <template v-for="(item, index) in project.utc_attr_history">
                  <tr v-if="item.buyer_incentives || item.realtor_incentives" :key="index + '_incentive'">
                    <td>{{ item.date != "null" ? item.date : "" }}</td>
                    <td>
                      {{
                        !["null", null].includes(item.buyer_incentives)
                          ? item.buyer_incentives
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        !["null", null].includes(item.realtor_incentives)
                          ? item.realtor_incentives
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        !["null", null].includes(item.realtor_commission)
                          ? item.realtor_commission
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        !["null", null].includes(item.assignment_fee)
                          ? item.assignment_fee
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        !["null", null].includes(item.deposit)
                          ? item.deposit
                          : ""
                      }}
                    </td>
                    <td>
                      <a v-if="
                        !['null', null].includes(item.backupfile) && isAdmin
                      " :href="item.backupfile.uri">File</a>
                    </td>
                    <td v-if="isAdmin">
                      <span class="btn p-0" @click="setIncentiveData(item)"
                        v-b-modal.update-entry-modal><font-awesome-icon :icon="['fas', 'edit']" /></span>
                      |
                      <span class="btn p-0 text-vb-red" @click="deleteIncentive(item.did)"><font-awesome-icon
                          :icon="['fas', 'trash']" /></span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-modal>

        <b-modal id="update-entry-modal" @ok="updateIncentive(incentiveDataToBeUpdated)" @cancel="cancelEntry">
          <template #modal-header="{ close }">
            <!-- Incentives Modal -->
            <h5 class="m-0 text-center w-100">Update Incentive</h5>
            <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
            <button type="button" aria-label="Close" class="close modal-close" @click="close()">
              ×
            </button>
          </template>
          <template>
            <div class="row">
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Date</label>
                <b-form-datepicker id="example-datepicker" v-model="incentiveDataToBeUpdated.date"
                  class="mb-2"></b-form-datepicker>
              </div>
              <div class="col-md-6 d-flex align-items-center">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Buyer Incentives</label>
                <b-form-input v-model="incentiveDataToBeUpdated.buyer_incentives" id="inc_buyer_incentives"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Realtor
                  Incentives</label>
                <b-form-input v-model="incentiveDataToBeUpdated.realtor_incentives" id="inc_realtor_incentives"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Assignment Fee</label>
                <b-form-input v-model="incentiveDataToBeUpdated.assignment_fee" id="inc_assignment_fee"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Deposit</label>
                <b-form-input v-model="incentiveDataToBeUpdated.deposit" id="inc_deposit" placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Realtor
                  Commission</label>
                <b-form-input v-model="incentiveDataToBeUpdated.realtor_commission" id="inc_realtor_commission"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <b-form-group id="mls-input-group-5">
                  <b-form-file size="sm" v-model="incentiveDataToBeUpdated.backupfile"
                    :state="Boolean(incentiveDataToBeUpdated.backupfile)" :placeholder="incentiveDataToBeUpdated.backupfile
                      ? incentiveDataToBeUpdated.backupfile.filename
                      : 'Choose a file'
                      " drop-placeholder="Drop file here..."></b-form-file>
                </b-form-group>
              </div>
            </div>
          </template>
          <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" variant="vb-primary" @click="ok()">
              Submit
            </b-button>
            <b-button size="sm" variant="vb-seconday" @click="cancel()">
              Cancel
            </b-button>
          </template>
        </b-modal>
        <b-modal id="add-entry-modal" @ok="addEntry" @cancel="cancelEntry">
          <template #modal-header="{ close }">
            <!-- Incentives Modal -->
            <h5 class="m-0 text-center w-100">Add Entry</h5>
            <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
            <button type="button" aria-label="Close" class="close modal-close" @click="close()">
              ×
            </button>
          </template>
          <template>
            <div class="row">
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Date</label>
                <b-form-datepicker id="example-datepicker" v-model="incentivesData.date"
                  class="mb-2"></b-form-datepicker>
              </div>
              <div class="col-md-6 d-flex align-items-center">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Buyer Incentives</label>
                <b-form-input v-model="incentivesData.buyer_incentives" id="inc_buyer_incentives"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Realtor
                  Incentives</label>
                <b-form-input v-model="incentivesData.realtor_incentives" id="inc_realtor_incentives"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Assignment Fee</label>
                <b-form-input v-model="incentivesData.assignment_fee" id="inc_assignment_fee"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Deposit</label>
                <b-form-input v-model="incentivesData.deposit" id="inc_deposit" placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <label class="mr-sm-2 _text-no-wrap my-0" for="inline-form-custom-select-pref">Realtor
                  Commission</label>
                <b-form-input v-model="incentivesData.realtor_commission" id="inc_realtor_commission"
                  placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 d-flex align-items-center my-2">
                <b-form-group id="mls-input-group-5">
                  <b-form-file v-model="incentivesData.backup_file" size="sm"
                    :state="Boolean(incentivesData.backup_file)" placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."></b-form-file>
                </b-form-group>
              </div>
            </div>
          </template>
          <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" variant="vb-primary" @click="ok()">
              Submit
            </b-button>
            <b-button size="sm" variant="vb-seconday" @click="cancel()">
              Cancel
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <b-modal id="backupTextModal" title="Backup Text" ok-only>
      {{ backupModalText }}
    </b-modal>
    <b-modal id="consultant" hide-footer :title="'Consultant Information'">
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 class="m-0 text-center w-100">Consultant Information</h5>
        <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal mr-3" />
        <button type="button" aria-label="Close" class="close modal-close" @click="close()">
          ×
        </button>
      </template>
      <div class="row my-30">
        <div class="col-xs-6 text-left">
          <a :href="project.web_link ? project.web_link[0] : '#'" target="_blank">
            <h2>
              <strong>{{ project.project_name }}</strong>
            </h2>
          </a>
        </div>
        <div class="col-sm-6 text-right">
          <div class="modal-address">{{ project.address }}</div>
        </div>
      </div>
      <table class="table text-left modal-table">
        <tbody style="border-top: 2px #545454 solid">
          <tr v-for="(consultant, key_c) in project.consultant" :key="'aq_' + key_c">
            <td>{{ consultant.type }}</td>
            <td>{{ consultant.name }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <b-modal id="feedback-modal" size="md" hide-header hide-footer no-close-on-backdrop
      class="_modal-wrapper feed_back-modal" scrollable>
      <UserFeedback v-on:hideFeedbackModal="hideFeedbackModal" :form-data="formData" />
    </b-modal>
  </section>
  <section v-else-if="isMobile && isAdmin">
    <MobileView :mls-data="allMlsData" :rental-data="mlsRentalData" :header_fields="rpdTableList1"
      :custom_headers="rpdTableList2" />
  </section>
  <section v-else class="d-flex align-items-center justify-content-center" style="height: 80vh">
    <h2 class="text-center">Please switch to Desktop View.</h2>
  </section>
</template>
<script>
import { useWebWorkerFn } from "@vueuse/core";
import MobileView from "./layouts/MobileView.vue";
import {
  BTabs,
  BTab,
  BModal,
  BModalDirective,
  VBModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
  BFormFile,
  BFormDatepicker,
  BBadge,
} from "bootstrap-vue";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import VueGallery from "vue-gallery";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBuilding } from "@fortawesome/free-regular-svg-icons";
import {
  faRulerVertical,
  faHome,
  faStore,
  faBed,
  faShareSquare,
  faArrowCircleRight,
  faArrowCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { BACKEND_URL, FILES } from "../variables.js";
import { appendField } from "../utilities/formData";
import { Carousel, Slide } from "vue-carousel";
import Multiselect from "vue-multiselect";
import { LightGallery } from "vue-light-gallery";
import { ProjectTypeUTC } from "../shared/components";
import { useUserStore } from "../store/UserStore";
import { useProjectStore } from "../store/ProjectStore";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useRequestCounter } from "../store/RequestCounter";
import CustomSlider from "./common/CustomSlider.vue";
import { mapStores, mapState } from "pinia";
import draggable from "vuedraggable";
import RpdTable from "./common/RpdTable.vue";
import axios from "axios";
import numFormat from "vue-filter-number-format";
import SummaryPopUp from "./common/SummaryPopUp.vue";
import { Bar, generateChart } from "vue-chartjs";
import ProjectTimeline from "./ProjectTimeline.vue"
import AmenityDetails from "./AmenityDetails.vue";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  BarController,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import SummaryTable from "../components/common/SummaryTable.vue";
import HistoryTable from "./RpdTables/HistoryTable.vue";
import OverviewHistoryTable from "./RpdTables/OverviewHistoryTable.vue";
import { onClickOutside } from "@vueuse/core";
import { ref, getCurrentInstance } from "vue";
import UserFeedback from "./common/UserFeedback.vue";
import { PDFDocument } from "pdf-lib";
import MlsForm from "./Forms/MlsForm.vue";
import EditRentalForm from "./Forms/EditRentalForm.vue";
import Notes from "./common/Notes.vue";
import BulkUpload from "./Forms/BulkUpload.vue";
async function workerImageRatio(imgUrl) {
  const max = { height: 190, width: 133 };

  return new Promise(async (resolve) => {
    let image = new Image();
    image.src = imgUrl;

    image.onload = async function () {
      const ratio = image.height / image.width;

      if (image.height > max.height || image.width > max.width) {
        if (image.height > image.width) {
          image.height = max.height;
          image.width = image.height * (1 / ratio);
          // Making reciprocal of ratio because ration of height as width is no valid here needs width as height
        } else if (image.width > image.height) {
          image.width = max.width;
          image.height = image.width * ratio;
          // Ratio is valid here
        }
      }
      resolve({
        status: "success",
        image: image,
      });
    };
  });
}
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  BarController,
  ChartDataLabels
);

library.add(
  faBuilding,
  faRulerVertical,
  faHome,
  faStore,
  faBed,
  faShareSquare,
  faArrowCircleRight,
  faArrowCircleLeft
);

export default {
  setup() {
    const temp_role = useUserStore();
    const initClass = temp_role.current_user.role == "admin" ? "" : "d-none";
    const target_custom_header_field = ref(null);
    const currentInstance = ref(getCurrentInstance());
    onClickOutside(
      target_custom_header_field,
      (event) => (currentInstance.value.proxy.custom_header_field = false)
    );
    return {
      initClass,
      temp_role,
      target_custom_header_field,
      currentInstance,
    };
  },
  components: {
    AmenityDetails,
    ProjectTimeline,
    gallery: VueGallery,
    "b-modal": BModal,
    "b-tabs": BTabs,
    "b-tab": BTab,
    "b-form": BForm,
    "b-form-group": BFormGroup,
    "b-form-input": BFormInput,
    "b-form-select": BFormSelect,
    "b-form-checkbox": BFormCheckbox,
    "b-form-checkbox-group": BFormCheckboxGroup,
    "b-button": BButton,
    "b-form-file": BFormFile,
    "b-form-datepicker": BFormDatepicker,
    "b-badge": BBadge,
    UserFeedback,
    Notes,
    Carousel,
    Slide,
    Multiselect,
    LightGallery,
    Bar,
    ProjectTypeUTC,
    VueperSlides,
    VueperSlide,
    CustomSlider,
    draggable,
    RpdTable,
    SummaryPopUp,
    SummaryTable,
    HistoryTable,
    MlsForm,
    EditRentalForm,
    BulkUpload,
    OverviewHistoryTable,
    MobileView
  },
  directives: {
    "b-modal": VBModal,
  },
  data: function () {
    return {
      fileAmenitySelected: null,
      processedUnits: [],
      loadingMls: false,
      rawHistoryNodes: [],
      selectedCidsForBulk: [],
      mlsData: null,
      editableRentalData: null,
      mlsRentalData: [],
      mlsRentalHistory: [],
      mlsCid: null,
      mlsUnit: null,
      allMlsData: [],
      exportedData: [],
      field_selected: [],
      custom_field: [],
      queryParams: "",
      currentSort: "", // Stores the key of the column to sort by
      currentSortDir: "asc", // 'asc' or 'desc'
      formData: {
        name: "",
        email: "",
        subject: "",
        contact: "",
        content: "",
        url: "",
        files: [],
      },
      confirmed_sold_units: [],
      confirmed_sold_unit_fields: [],
      currentAvailability: null,
      selectedGalleryType: null,
      quarterSalesStartDate: null,
      history_note: null,
      feature_items: null,
      accordion_arrow: "fas chevron-down",
      history_header_fields: null,
      listingTab: "",
      unitPreviewSummary: null,
      unitPreviewSummaryHeader: null,
      arrayOfImages: [],
      rowOptions: [
        { value: 15, text: "15 rows" },
        { value: 25, text: "25 rows" },
        { value: 50, text: "50 rows" },
        { value: 100, text: "100 rows" },
        { value: 500, text: "500 rows" },
      ],
      incentiveDataToBeUpdated: {},
      isModalVisible: false,
      isEditMode: false,
      modalData: {
        isOpen: false,
        data: Object,
        action: String,
      },
      confirmedSold: null,
      numFormat: numFormat,
      salesStartDate: null,
      editSalesStartDate: true,
      incentivesData: {
        uid: null,
        date: null,
        buyer_incentives: null,
        realtor_incentives: null,
        assignment_fee: null,
        deposit: null,
        realtor_commission: null,
        backup_file: null,
      },
      backupModalText: "",
      totalRows: {
        active: 1,
        sold: 1,
        other: 1,
        all: 1,
      },
      currentPage: {
        active: 1,
        sold: 1,
        other: 1,
        all: 1,
      },
      perPage: 15,
      activePerPage: 15,
      soldPerPage: 15,
      otherPerPage: 15,
      rpdTableList1: [],
      rpdTableList2: [],
      list1: [
        // { name: "Project", field: 'project_name', id: 1 },
        { name: "Unit #", field: "mls_address", id: 1 },
        { name: "Plan Name", field: "mls_plan_name", id: 6 },
        { name: "Beds", field: "mls_beds", id: 8 },
        { name: "Baths", field: "mls_baths", id: 9 },
        { name: "FP Specs", field: "fp_specs", id: 7 },
        { name: "List Price", field: "mls_list_price", id: 2 },
        { name: "$PSF", field: "mls_psf", id: 4 },
        { name: "Price Date", field: "mls_price_date", id: 5 },
      ],
      list2: [
        { name: "Unit Size", field: "mls_unit_size", id: 10 },
        { name: "Parking", field: "stalls", id: 11 },
        { name: "Stalls", field: "mls_parking", id: 12 },
        { name: "List Date", field: "mls_list_date", id: 3 },
      ],
      custom_header_field: false,
      developer: "-",
      isLoadedChart: false,
      chartDataSale: {
        labels: [],
        datasets: [
          {
            label: "Sales History",
            backgroundColor: "#f87979",
            data: [],
          },
        ],
      },
      chartDataPSF: {
        labels: [],
        datasets: [
          {
            label: "PSF History",
            backgroundColor: "#2596be",
            data: [],
            barThickness: 10, // Specify a fixed width for bars
            maxBarThickness: 15,
          },
        ],
      },
      chartDataOptions: {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          mode: "nearest", // Show tooltips only on nearest points
          intersect: true, // Ensure the tooltip appears only when exactly over the bar
        },
      },
      chartId: "Sold History",
      datasetIdKey: "sold history key",
      chartStyle: {
        width: 800,
        height: 300,
      },
      orderAsc: true,
      activeSortBy: "mls_address",
      soldSortBy: "mls_address",
      otherSortBy: "mls_address",
      project_id: this.$route.query.project,
      collection_ids: this.$route.query.fid,
      type_id: this.$route.query.typeid,
      project: [],
      project_link: "",
      index: null,
      floorPlanPick: "",
      image_lists: [],
      cidSelected: 0,
      uploadForm: {
        planName: "",
        fp: [],
        orientation: 11105,
        unit: "",
        bed: "",
        bath: "",
        unitSize: "",
        listPrice: "",
        pr: "",
        locker: "",
        gst: "",
        buyerIncentives: "",
        realtorIncentives: "",
        status: 11482,
        soldDate: null,
        listDate: null,
        listPriceDate: null,
        fl: "",
        files: null,
        owner: "",
        purchaser: "",
        pid: "",
        assignment: 0,
        newEntry: 0,
        originalEntry: 0,
        backupfile: null,
        balcony: "",
        balconyArea: "",
      },
      MLSuploadForm: {
        listPrice: "",
        listPriceDate: null,
        buyerIncentives: "",
        realtorIncentives: "",
        backupText: "",
        files: null,
        priceBackup: "",
        soldDate: null,
      },
      openTab: { title: "Overview", value: "overview" },
      userStore: useUserStore(),
      projectStore: useProjectStore(),
      mlsOrientation: [
        { text: "None", value: 11105 },
        { text: "East", value: 11033 },
        { text: "North", value: 11030 },
        { text: "North East", value: 11035 },
        { text: "North West", value: 11034 },
        { text: "South", value: 11032 },
        { text: "South East", value: 11037 },
        { text: "South West", value: 11036 },
        { text: "West", value: 11031 },
      ],
      balconyOrientation: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" },
      ],
      priceBackupOption: [
        { text: "", value: "" },
        { text: "Verified", value: "Verified" },
        { text: "Semi-Verified", value: "Semi-Verified" },
        { text: "Educated Estimated", value: "Educated Estimated" },
      ],
      mlsFP: [],
      mlsParking: [],
      mlsFloorLevel: [],
      // mlsStatus: [{text: 'Active', value: 8197}, {text: 'Cancel Protected', value: 8206}, {text: 'Collapsed', value: 8201}, {text: 'Expired', value: 8202}, , {text: 'Withdrawn', value: 8203}
      // , {text: 'Hold All Action', value: 8204}, {text: 'Leased', value: 8208}, {text: 'Rented', value: 8207}, {text: 'Sold', value: 8198}, {text: 'Terminated', value: 8205}],
      mlsStatus: [
        { text: "", value: 11482 },
        { text: "Active", value: 8197 },
        { text: "Sold", value: 8198 },
        { text: "Unreleased", value: 23440 },
      ],
      project_icons: {
        "Market Strata":
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4167 0.75H2.58333C1.575 0.75 0.75 1.575 0.75 2.58333V15.4167C0.75 16.425 1.575 17.25 2.58333 17.25H15.4167C16.425 17.25 17.25 16.425 17.25 15.4167V2.58333C17.25 1.575 16.425 0.75 15.4167 0.75ZM15.4167 15.4167H2.58333V2.58333H15.4167V15.4167ZM6.25 7.16667H4.41667V13.5833H6.25V7.16667ZM8.08333 4.41667H9.91667V13.5833H8.08333V4.41667ZM13.5833 9.91667H11.75V13.5833H13.5833V9.91667Z" fill="black" fill-opacity="0.54"/></svg>',
        "Below-Market Rental":
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
        "Market Rental":
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
        "Below-Market Strata":
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
        "Fee Simple":
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
        Commercial:
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 3.04169V8.54169H17.25V17.7084H0.75V4.87502H6.25V3.04169L9 0.291687L11.75 3.04169ZM2.58333 15.875H4.41667V14.0417H2.58333V15.875ZM4.41667 12.2084H2.58333V10.375H4.41667V12.2084ZM2.58333 8.54169H4.41667V6.70835H2.58333V8.54169ZM8.08333 15.875V14.0417H9.91667V15.875H8.08333ZM8.08333 10.375V12.2084H9.91667V10.375H8.08333ZM8.08333 8.54169V6.70835H9.91667V8.54169H8.08333ZM8.08333 3.04169V4.87502H9.91667V3.04169H8.08333ZM15.4167 15.875H13.5833V14.0417H15.4167V15.875ZM13.5833 12.2084H15.4167V10.375H13.5833V12.2084Z" fill="black" fill-opacity="0.54"/></svg>',
        Industrial:
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 3.04169V8.54169H17.25V17.7084H0.75V4.87502H6.25V3.04169L9 0.291687L11.75 3.04169ZM2.58333 15.875H4.41667V14.0417H2.58333V15.875ZM4.41667 12.2084H2.58333V10.375H4.41667V12.2084ZM2.58333 8.54169H4.41667V6.70835H2.58333V8.54169ZM8.08333 15.875V14.0417H9.91667V15.875H8.08333ZM8.08333 10.375V12.2084H9.91667V10.375H8.08333ZM8.08333 8.54169V6.70835H9.91667V8.54169H8.08333ZM8.08333 3.04169V4.87502H9.91667V3.04169H8.08333ZM15.4167 15.875H13.5833V14.0417H15.4167V15.875ZM13.5833 12.2084H15.4167V10.375H13.5833V12.2084Z" fill="black" fill-opacity="0.54"/></svg>',
        "Fee-Simple":
          '<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 0.75V4.41667H19.1668V17.25H0.833496V0.75H10.0002ZM2.66683 15.4167H4.50016V13.5833H2.66683V15.4167ZM4.50016 11.75H2.66683V9.91667H4.50016V11.75ZM2.66683 8.08333H4.50016V6.25H2.66683V8.08333ZM4.50016 4.41667H2.66683V2.58333H4.50016V4.41667ZM6.3335 15.4167H8.16683V13.5833H6.3335V15.4167ZM8.16683 11.75H6.3335V9.91667H8.16683V11.75ZM6.3335 8.08333H8.16683V6.25H6.3335V8.08333ZM8.16683 4.41667H6.3335V2.58333H8.16683V4.41667ZM17.3335 15.4167V6.25H10.0002V8.08333H11.8335V9.91667H10.0002V11.75H11.8335V13.5833H10.0002V15.4167H17.3335ZM15.5002 8.08333H13.6668V9.91667H15.5002V8.08333ZM13.6668 11.75H15.5002V13.5833H13.6668V11.75Z" fill="black" fill-opacity="0.54"/></svg>',
      },
      bed_icons: {
        Studio:
          '<svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.478604 15C0.727478 15 0.918917 14.8504 0.918917 14.656V12.0538H16.1194V14.656C16.1194 14.8504 16.3108 15 16.5597 15C16.8086 15 17 14.8504 17 14.656V11.6949V8.95813C17 8.88335 16.9617 8.80857 16.9043 8.74875L13.152 4.96511V0.343969C13.152 0.149552 12.9606 0 12.7117 0H4.28829C4.03941 0 3.84797 0.149552 3.84797 0.343969V4.96511L0.0957207 8.74875C0.0382883 8.80857 0 8.88335 0 8.95813V11.6949V14.656C0.0382883 14.8355 0.22973 15 0.478604 15ZM4.53716 5.42871H6.58559H8.51915H10.4527H12.5011L15.6599 8.61416H1.37838L4.53716 5.42871ZM6.06869 4.30708V2.43769C6.06869 2.21336 6.29842 2.01894 6.60473 2.01894H10.4718C10.759 2.01894 11.0079 2.19841 11.0079 2.43769V4.32203C11.0079 4.54636 10.7782 4.74078 10.4718 4.74078H8.53829H6.60473C6.29842 4.72582 6.06869 4.54636 6.06869 4.30708ZM0.918917 9.30209H16.1194V11.336H0.918917V9.30209ZM4.76689 0.687937H12.2905V4.72582H11.7737C11.8311 4.59123 11.8694 4.45663 11.8694 4.30708V2.43769C11.8694 1.82453 11.2376 1.33101 10.4527 1.33101H6.58559C5.80067 1.33101 5.16892 1.82453 5.16892 2.43769V4.32203C5.16892 4.47159 5.20721 4.60618 5.26464 4.74078H4.76689V0.687937Z" fill="#606060"/></svg>',
        "1-bed":
          '<svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.615 5.65421H16.0541V5.26693C16.0541 5.01521 15.902 4.82157 15.7041 4.82157H9.75422C9.5564 4.82157 9.40423 5.01521 9.40423 5.26693V5.65421H6.83252V5.34439C6.83252 4.37621 6.20862 3.60166 5.44776 3.60166H4.07821C3.31735 3.60166 2.69344 4.39557 2.69344 5.34439V5.71231C2.5717 5.75104 2.46519 5.80912 2.35867 5.88658V1.43291C2.35867 0.638997 1.8565 0 1.23259 0H1.12607C0.502167 0 0 0.638997 0 1.43291V13.5546C0 13.8064 0.15217 14 0.349994 14H2.00867C2.20649 14 2.35867 13.8064 2.35867 13.5546V11.4246H9.73901H15.6889H18.6411V13.5546C18.6411 13.8064 18.7932 14 18.9911 14H20.6497C20.8476 14 20.9997 13.8064 20.9997 13.5546V10.9792V7.43568C21.015 6.44813 20.3758 5.65421 19.615 5.65421ZM19.615 6.54495C19.9954 6.54495 20.315 6.93222 20.315 7.43568V10.5145H19.0063H16.0541V6.54495H19.615ZM3.40865 5.34439C3.40865 4.87966 3.71299 4.49238 4.07821 4.49238H5.44776C5.81297 4.49238 6.11731 4.87966 6.11731 5.34439V5.65421H3.40865V5.34439ZM1.65867 13.0899H0.715206V1.43291C0.715206 1.14246 0.897814 0.910088 1.12607 0.910088H1.24781C1.47607 0.910088 1.65867 1.14246 1.65867 1.43291V7.43568V10.9792V13.0899ZM2.35867 7.43568C2.35867 6.95158 2.66301 6.54495 3.05866 6.54495H6.48253H9.40423V10.5145H2.37388V7.43568H2.35867ZM10.1042 10.5145V5.71231H15.3542V10.5145H10.1042ZM20.2997 13.0899H19.3563V11.4246H20.2997V13.0899Z" fill="#606060"/></svg>',
        "2-bed":
          '<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6915 5.47036H17.4472V0.444591C17.4472 0.193302 17.3074 0 17.1257 0H1.88732C1.70558 0 1.56578 0.193302 1.56578 0.444591V5.47036H0.321542C0.1398 5.47036 0 5.66366 0 5.91495V11.2113V14.5554C0 14.8067 0.1398 15 0.321542 15C0.503284 15 0.643084 14.8067 0.643084 14.5554V11.6559H18.3559V14.5554C18.3559 14.8067 18.4957 15 18.6775 15C18.8592 15 18.999 14.8067 18.999 14.5554V11.2113V5.91495C19.013 5.66366 18.8732 5.47036 18.6915 5.47036ZM2.22285 0.889176H16.8041V5.47036H15.7417C15.8116 5.18042 15.8395 4.89047 15.8395 4.60052C15.8395 3.0348 14.9168 1.75902 13.7844 1.75902H11.5896C10.4572 1.75902 9.53447 3.0348 9.53447 4.60052C9.53447 4.9098 9.57641 5.19975 9.63233 5.47036H9.40864C9.47854 5.18042 9.50651 4.89047 9.50651 4.60052C9.50651 3.0348 8.58381 1.75902 7.45142 1.75902H5.25654C4.12414 1.75902 3.20146 3.0348 3.20146 4.60052C3.20146 4.9098 3.24339 5.19975 3.29931 5.47036H2.23682V0.889176H2.22285ZM10.3313 5.47036C10.2335 5.19975 10.1776 4.9098 10.1776 4.60052C10.1776 3.51804 10.8067 2.6482 11.5896 2.6482H13.7844C14.5673 2.6482 15.1964 3.51804 15.1964 4.60052C15.1964 4.9098 15.1405 5.19975 15.0426 5.47036H10.3313ZM3.98434 5.47036C3.88648 5.19975 3.83057 4.9098 3.83057 4.60052C3.83057 3.51804 4.45967 2.6482 5.24256 2.6482H7.43744C8.22033 2.6482 8.84944 3.51804 8.84944 4.60052C8.84944 4.9098 8.79352 5.19975 8.69566 5.47036H3.98434ZM0.657069 6.35953H3.78862H8.79352C8.82148 6.35953 8.84944 6.37887 8.8774 6.37887C8.90536 6.37887 8.93332 6.37886 8.96128 6.35953H10.0657C10.0937 6.37886 10.1216 6.37887 10.1496 6.37887C10.1776 6.37887 10.2055 6.37886 10.2335 6.35953H15.2384H18.3839V10.7668H0.657069V6.35953Z" fill="#606060"/></svg>',
        "3-bed":
          '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
        "4-bed":
          '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
        "5-bed":
          '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
      },
      landInfo: {},
      selectedDateMap: {},
      upload_is_loading: false,
      projectImgindex: null,
      interiorImgindex: null,
      amenityImgindex: null,
      presentationImgindex: null,
      siteImgindex: null,
      constructionImgindex: null,
      typeGroup: null,
      utcExtra: null,
      // view: this.$route.query.view,
      // index: null
    };
  },
  mounted: function () {
    const vm = this;
    let jqueryGetRequestCount = 0;
    const originalJQueryGet = $.get;
    this.getConfirmedSold();
    this.fetchProjectHistory();
    $.get = function () {
      jqueryGetRequestCount++;

      return originalJQueryGet.apply(this, arguments);
    };

    this.fetchData()
    $.get(
      {
        url:
          BACKEND_URL +
          "api/get_single_project?pid=" +
          this.project_id +
          "&fid=" +
          this.$route.query.fid,
      },
      (data, status) => {
        if (status === "success") {
          vm.typeGroup = data.type_group ? data.type_group : {};
          vm.utcExtra = data.utc_extra ? data.utc_extra : [];
        }

        useRequestCounter().incrementCompletedRequest();
      }
    );

    $.get(
      {
        url: BACKEND_URL + "api/get_fp_specs",
      },
      (data, status) => {
        if (status === "success") {
          vm.mlsFP = data.fp_specs;
          vm.mlsParking = data.parking;
          vm.mlsFloorLevel = data.floor_level;
          vm.projectStore.setOptions({
            mlsFp: data.fp_specs,
            mlsParking: data.parking,
            mlsFloorLevel: data.floor_level,
          });
        }

        useRequestCounter().incrementCompletedRequest();
      }
    );
    useRequestCounter().setRequestCounter(jqueryGetRequestCount);
  },
  computed: {
    ...mapState(useUserStore, ["current_user"]),
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 500) {
        return true
      } else {
        return false
      }
    },
    historyOverView() {
      var res = {}
      if (!this.loadingMls) {
        var history = this.formattedProjectHistory.length > 0 ? this.formattedProjectHistory.at(-1) : [];
        var weighted_average_size = 0;
        var weighted_average_price = 0;
        var weighted_net_psf = 0;
        var total_units = this.mlsTotalSummary.totalNum || 0;
        let filteredMls = this.allMlsData.filter(item => ['Active', 'Sold'].includes(item.mls_status));
        weighted_average_size = Number(this.mlsTotalSort.reduce((acc, curr) => {
          let total_size = curr.custom_avg_size && curr.num ? Math.round(curr.custom_avg_size) : 0;
          return acc += (curr.num * total_size);
        }, 0) / total_units) || 0;
        weighted_average_price = Math.round(this.mlsTotalSummary.avgOverallPrice / total_units) || 0;
        weighted_net_psf = Math.round(weighted_average_price / weighted_average_size) || 0;
        var custom_psf = this.isMarketStrata ? Math.round(this.mlsTotalSummary.avgOverallPricePsf) : Number(this.mlsTotalSummary.avgOverallPricePsf).toFixed(2)
        if (history.length <= 0)
          return null
        res = {
          fe_avg_size: filteredMls.length > 0 ? Math.round(filteredMls.reduce((acc, curr) => acc + Number(curr.mls_unit_size || 0), 0) / filteredMls.length) : null,
          fe_total_units: this.allMlsData.length > 0 ? this.allMlsData.length : null,
          fe_filtered_units: filteredMls.length,
          unitmix_total_units: this.currentAvailability ? this.currentAvailability.units : null,
          unitmix_avg_size: history.currentAvailability_avg_size,
          unitmix_avg_psf: history.currentAvailability_avg_psf,
          unitmix_net_psf: history.currentAvailability_net_psf,
          sum_product_avg_size: history.field_system_total_avg_size,
          sum_product_psf: history.field_system_psf,
          sum_product_total_net_psf: history.total_net_psf,
          default_field_total_avg_size: history.default_field_total_avg_size,
          default_field_total_avg_psf: history.avg_psf,
          default_field_total_net_psf: null,
          weighted_average_size: weighted_average_size || null,
          weighted_average_price: custom_psf || null,
          weighted_net_psf: null,
        };
      }

      return res
    },
    formattedProjectHistory() {
      const currentAvailability = this.getAvailablePricing(this.allMlsData.filter(item => item.custom_sold_psf))
      let filteredMls = this.allMlsData.filter(item => ['Active', 'Sold'].includes(item.mls_status));
      return this.rawHistoryNodes.map((item, index) => {
        var system_size = item.field_system_total_avg_size?.und?.[0].value ? item.field_system_total_avg_size?.und?.[0].value : item.field_total_avg_size?.und?.[0].value
        const currentAvgSize = parseFloat(item.field_total_avg_size?.und?.[0]?.value) || 0;
        const currentPsf = parseFloat(item.field_total_avg_psf?.und?.[0]?.value) || 0;
        const currentAvgPrice = parseFloat(item.field_total_avg_price?.und?.[0]?.value) || 0;
        const currentNetPsf = parseFloat(item.field_total_net_psf?.und?.[0]?.value) || 0;
        const currentNetPrice = Number(currentAvgSize * currentNetPsf) || 0;

        const rowAbove = index > 0 ? this.rawHistoryNodes[index - 1] : null;
        let prevData = { system_price: 0, system_psf: 0 };

        if (rowAbove) {
          prevData.system_price = parseFloat(rowAbove.field_system_total_avg_price?.und?.[0]?.value) || 0;
          prevData.system_psf = parseFloat(rowAbove.field_system_psf?.und?.[0]?.value) || 0;
        }

        const rawFiles = item.field_update_files?.und || [];
        const filesArray = rawFiles.filter(files => files.uri != 'https://www.realpropertydata.ca/backend/').map((f, i) => ({
          ...f,
          url: `${f.uri}`,
          name: f.filename,
          index: i + 1
        }));

        return {
          nid: item.nid,
          date: this.formatUnixToCustom(item.field_inline_date?.und?.[0]?.value),
          avg_size: item.field_total_avg_size?.und?.[0].value || null,
          total: item.field_total_units?.und?.[0]?.value || null,
          rlsd_units: item.field_rlsd_units?.und?.[0]?.value || null,
          sold_total: item.field_sold?.und?.[0]?.value || null,
          available: item.field_available_units?.und?.[0]?.value || null,
          avg_price: currentAvgPrice || null,
          avg_psf: currentPsf || null,
          total_net_psf: currentNetPsf || null,
          current_total_net_price: currentNetPrice > 0 ? currentNetPrice : null,
          prev_avg_price: index === 0 ? 0 : prevData.avg_price,
          prev_avg_psf: index === 0 ? 0 : prevData.prev_avg_psf,
          prev_total_net_psf: index === 0 ? 0 : prevData.net_psf,
          prev_total_net_price: index === 0 ? 0 : prevData.net_price,
          field_sold_update: item.field_sold_update?.und?.[0]?.value || null,
          note: item.field_sold_update_notes?.und?.[0]?.value || null,
          field_update_files: filesArray,
          field_update_notes: item.field_update_notes?.und?.[0]?.value,
          field_deposit_: item.field_deposit_?.und?.[0]?.value || 0,
          isEdited: false,
          isNew: false,
          field_system_total_avg_size: item.field_system_total_avg_size?.und?.[0].value || null,
          field_system_total_avg_price: item.field_system_total_avg_price?.und?.[0].value || null,
          field_need_approval: item.field_need_approval?.und?.[0].value || null,
          field_system_psf: item.field_system_psf?.und?.[0].value || null,
          prev_system_avg_price: prevData.system_price,
          prev_system_avg_psf: prevData.system_psf,
          field_total_net_psf: item.field_total_net_psf?.und?.[0]?.value || null,
          currentAvailability_avg_price: currentAvailability ? currentAvailability.list_price : null,
          currentAvailability_avg_psf: currentAvailability ? currentAvailability.psf : null,
          currentAvailability_net_price: currentAvailability ? currentAvailability.net_price : null,
          currentAvailability_net_psf: currentAvailability ? currentAvailability.net_psf : null,
          currentAvailability_avg_size: currentAvailability ? currentAvailability.size : null,
          default_field_total_avg_size: item.field_total_avg_size?.und?.[0].value || null,
          default_field_inline_date: item.field_inline_date?.und?.[0].value || null,
          default_field_total_units: item.field_total_units?.und?.[0]?.value || null,
          default_field_rlsd_units: item.field_rlsd_units?.und?.[0]?.value || null,
          default_field_sold: item.field_sold?.und?.[0]?.value || null,
          default_field_available_units: item.field_available_units?.und?.[0]?.value || null,
          default_field_total_avg_size: item.field_total_avg_size?.und?.[0]?.value || null,
          default_field_system_total_avg_price: item.field_system_total_avg_price?.und?.[0]?.value || null,
          default_field_total_net_psf: item.field_total_net_psf?.und?.[0]?.value || null,
          fe_avg_size: filteredMls.length > 0 ? Math.round(filteredMls.reduce((acc, curr) => acc + Number(curr.mls_unit_size || 0), 0) / filteredMls.length) : null,
        };
      });
    },
    showMessage() {
      const unitComponent = this.unitComponent.reduce((acc, item) => {
        const key = Object.keys(item)[0];
        const newKey = key.toLowerCase().replace(/\s+/g, '_').replace(/[^\w_]/g, '');
        acc[newKey] = item[key];
        return acc;
      }, {});
      const unitBreakDownTotalUnits = this.mlsTotalSort.reduce((acc, curr) => acc += curr.num, 0)
      return {
        haveDiscrepancy: unitBreakDownTotalUnits != unitComponent.rlsd_units,
        rlsd_units: unitComponent.rlsd_units,
        total_units: unitBreakDownTotalUnits
      };
    },
    isSuperAdmin() {
      return [
        "mark.wang+urban@devradius.com",
        "darcysrai@gmail.com",
        "erloucabilan94@gmail.com",
      ].includes(this.current_user.mail);
    },
    showFlag() {
      return [
        "darcysrai@gmail.com",
        "mark.wang+urban@devradius.com",
        "erloucabilan94@gmail.com",
        "Erl@devbc.com",
        "darcy@gmail.com",
        "jopenshaw@bosaproperties.com",
        "djackson@bosaproperties.com",
        "andrew.vandermay@gmail.com",
      ].includes(this.current_user.mail);
    },
    soldLastQuarterFields() {
      if (this.isAdmin) {
        return [
          { label: "Quarter", key: "quarter" },
          { label: "Units Sold", key: "total_sold" },
          { label: "Confirmed Sold", key: "confirmed_sold" },
          { label: "Total Confirmed Sold", key: "total_confirmed_sold" },
          { label: "Sold Report", key: "sold_update" },
          { label: "Notes", key: "note" },
        ];
      } else {
        if (this.isMarketStrata) {
          return [
            { label: "Quarter", key: "quarter" },
            { label: "Units Sold", key: "total_sold" },
            { label: "Notes", key: "note" },
          ];
        } else {
          return [
            { label: "Quarter", key: "quarter" },
            { label: "Units Leased", key: "total_sold" },
            { label: "Notes", key: "note" },
          ];
        }
      }
    },
    summaryTitle() {
      const vm = this;

      var result = "";
      if (vm.listingTab == "active") {
        switch (vm.project.status.toLowerCase()) {
          case "now leasing":
            result = "Active Pricing";
            break;
          case "leased out":
            result = "Active Pricing";
            break;
          case "now selling":
            result = "Active Pricing";
            break;
          default:
            result = "Active Pricing";
        }
      } else {
        switch (vm.project.status.toLowerCase()) {
          case "now leasing":
            result = "Leased Pricing";
            break;
          case "now selling":
            result = "Sold Pricing";
            break;
          default:
            result = "Sold Pricing";
        }
      }

      return result;
    },
    isMarketStrata() {
      if (this.project)
        return this.project.status &&
          ["now selling", "now selling 2", "sold out", "sold out 2"].includes(
            this.project.status.toLowerCase()
          )
          ? true
          : false;
    },
    lastUpdate() {
      return new Date(this.project.last_update).getFullYear() <= 2000
        ? "No date"
        : this.project.last_update;
    },
    soldLastQuarter() {
      const vm = this;
      let mappedHistory = [];
      let res = [];
      var custom_confirmed_sold = 0;
      if (vm.projectHistory && vm.projectHistory.length > 0) {
        vm.projectHistory.forEach((history, index) => {
          let month = new Date(history.date).getMonth() + 1;
          month = Math.ceil(month / 3);

          let note = this.project.note.reduce((acc, curr) => {
            if (curr.date == history.date) {
              acc.push(curr);
            }
            return acc;
          }, []);
          if (vm.isAdmin) {
            mappedHistory.push({
              quarter: `Q${month}-${new Date(history.date).getFullYear()}`,
              total_sold: history.sold_total,
              origin: history,
              sold_update: history.sold_update,
              confirmed_sold: history.confirmed_sold,
              total_confirmed_sold: custom_confirmed_sold,
              units: history.units,
              note: note.length > 0 ? note : null,
              ignore: index <= 0 ? true : false,
            });
          } else {
            mappedHistory.push({
              quarter: `Q${month}-${new Date(history.date).getFullYear()}`,
              total_sold: history.sold_total,
              origin: history,
              sold_update: history.sold_update,
              units: history.units,
              note: note.length > 0 ? note : null,
              ignore: index <= 0 ? true : false,
            });
          }
        });

        vm.quarterSalesStartDate = mappedHistory[0];
        const map = new Map();
        for (const item of mappedHistory) {
          map.set(item.quarter, item);
        }
        res = [...map.values()];

        res.map((val, index) => {
          if (index <= 0 && res.length <= 1) {
            let prevSold =
              mappedHistory[0].origin.sold_total == "-"
                ? 0
                : mappedHistory[0].origin.sold_total;
            let currentSold = ["-", 0].includes(val.total_sold)
              ? 0
              : val.total_sold;
            val.total_sold = Number(currentSold) - Number(prevSold);
          }

          if (index > 0 && res.length > 1) {
            val.total_confirmed_sold = custom_confirmed_sold +=
              val.confirmed_sold && index >= 1 ? val.confirmed_sold : 0;
            let prevSold =
              res[index - 1].origin.sold_total == "-"
                ? 0
                : res[index - 1].origin.sold_total;

            let currentSold = ["-", 0].includes(val.total_sold)
              ? 0
              : val.total_sold;
            val.total_sold = Number(currentSold) - Number(prevSold);
          }
          return {
            ...val,
          };
        });
      }

      return res.filter((item) => !item.ignore);
    },
    isInCurrentQuarter(date) {
      const now = new Date();
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
      const salesDate = new Date(date);
      const salesQuarter = Math.floor(salesDate.getMonth() / 3) + 1;

      return (
        salesDate.getFullYear() === now.getFullYear() &&
        salesQuarter === currentQuarter
      );
    },
    lastUpdated() {
      const vm = this;
      let lastUpdated = null;
      let res;
      let allListingData = [...vm.allMlsData];
      const options = {
        day: "2-digit",
        month: "short",
        year: "2-digit",
      };
      function latestTimeStamp(dates) {
        return Math.max(
          ...dates.filter((d) => !isNaN(d)).map((d) => d.getTime())
        );
      }
      if (allListingData.length > 0) {
        const priceDates = allListingData.map((item) => {
          return item.mls_price_date
            ? new Date(item.mls_price_date)
            : new Date(0);
        });

        const soldDates = allListingData.map((item) => {
          return item.mls_sold_date
            ? new Date(item.mls_sold_date)
            : new Date(0);
        });
        lastUpdated =
          latestTimeStamp(priceDates) > latestTimeStamp(soldDates)
            ? latestTimeStamp(priceDates)
            : latestTimeStamp(soldDates);

        let latestDate = new Date(lastUpdated);

        const day = latestDate.getDate().toString().padStart(2, "0");
        const month = latestDate.toLocaleString("en-GB", { month: "short" });
        const year = latestDate.getFullYear().toString().slice(-2);
        res = `${day}-${month}-${year}`;
      }
      return new Date(res) > new Date(vm.project.last_update) ? res : vm.project.last_update;
    },
    amenities() {
      let amenities = this.project.amenities ? this.project.amenities : [];
      let res = [];
      let facilities = [
        { name: "Bike Room", icon: "fas fa-bicycle" },
        { name: "Co-Working Space", icon: "fas fa-users" },
        { name: "Cold Plunge Pool", icon: "fas fa-tint" },
        { name: "Community Garden", icon: "fas fa-seedling" },
        { name: "Dog Wash Station", icon: "fas fa-paw" },
        { name: "Fitness Centre", icon: "fas fa-dumbbell" },
        { name: "Fitness Studio", icon: "fas fa-running" },
        { name: "Golf Simulator", icon: "fas fa-golf-ball" },
        { name: "Gymnasium", icon: "fas fa-futbol" },
        { name: "Indoor Basketball Court", icon: "fas fa-basketball-ball" },
        { name: "Indoor Hot Tub", icon: "fas fa-hot-tub" },
        { name: "Indoor Pickleball Court", icon: "fas fa-table-tennis" },
        { name: "Indoor Pool", icon: "fas fa-swimmer" },
        { name: "Music Room", icon: "fas fa-music" },
        { name: "Outdoor Basketball Court", icon: "fas fa-basketball-ball" },
        { name: "Outdoor Hot Tub", icon: "fas fa-hot-tub" },
        { name: "Outdoor Pickleball Court", icon: "fas fa-table-tennis" },
        { name: "Outdoor Pool", icon: "fas fa-swimmer" },
        { name: "Party Room", icon: "fas fa-cocktail" },
        { name: "Private Meeting Rooms", icon: "fas fa-user-tie" },
        { name: "Putting Green", icon: "fas fa-golf-ball" },
        { name: "Rooftop Patio", icon: "fas fa-cloud-sun" },
        { name: "Sauna/Steam Room", icon: "fas fa-bath" },
        { name: "Steam Room / Sauna", icon: "fas fa-bath" },
        { name: "Study Lounge", icon: "fas fa-book" },
        { name: "Theatre", icon: "fas fa-theater-masks" },
        { name: "Yoga Studio", icon: "fas fa-spa" },
      ];

      res = facilities.filter((facility) => amenities.includes(facility.name));

      return res;
    },
    allListingData() {
      const vm = this;
      let allData = [...vm.allMlsData];
      function calculatePsf(row) {
        if ([row["mls_list_price"], row["mls_unit_size"]].includes("-"))
          return "-";
        return Number(row["mls_list_price"] / row["mls_unit_size"]).toFixed(2) >
          0
          ? Number(row["mls_list_price"] / row["mls_unit_size"]).toFixed(2)
          : "-";
      }

      return allData.map((row, index) => {
        let clonedRow = { ...row, origin_bed: row.mls_beds };

        Object.keys(clonedRow).forEach((key) => {
          clonedRow[key] = !["-", 0, null, NaN, "0"].includes(clonedRow[key])
            ? clonedRow[key]
            : "-";
        });

        if (clonedRow["mls_beds"] && !vm.isAdmin) {
          let bed = "";
          let fpSpecs = "";
          bed = `${clonedRow["mls_beds"]}-bed`;

          if (!["None", ""].includes(clonedRow["fp_specs"]))
            fpSpecs = `${clonedRow["fp_specs"]}`;

          if (clonedRow["mls_beds"] == "s") bed = "Studio";

          clonedRow["mls_beds"] = fpSpecs ? bed + " + " + fpSpecs : bed;
        }

        if (
          typeof clonedRow["mls_psf"] == "string" &&
          clonedRow["mls_psf"].includes(",")
        ) {
          clonedRow["mls_psf"] = clonedRow["mls_psf"].replace(/,/g, "");
        } else {
          clonedRow["mls_psf"] = clonedRow["mls_psf"];
        }

        if (clonedRow["mls_psf"] !== "-") {
          clonedRow["mls_psf"] = !["now leasing", "leased out"].includes(
            vm.project.status.toLowerCase()
          )
            ? Math.round(clonedRow["mls_psf"])
            : calculatePsf(clonedRow);
        }

        return clonedRow;
      });
    },
    shouldBeRounded() {
      let res = false;

      if (
        ["leased out", "now leasing"].includes(
          this.project.status.toLowerCase()
        )
      )
        res = true;

      return res;
    },
    projectHistory() {
      const vm = this;
      let history = vm.project.attr_history
        ? Object.values(vm.project.attr_history)
        : [];
      if (history.length > 1) {
        history = history.map((val, index) => {
          let initial = 0;
          let confirmedSold = vm.mlsSoldSort.reduce((acc, curr) => {
            if (index > 0) {
              return new Date(curr.mls_sold_date) >
                new Date(history[index - 1].date) &&
                new Date(curr.mls_sold_date) <= new Date(val.date)
                ? initial++
                : initial;
            } else {
              return new Date(curr.mls_sold_date) <= new Date(val.date)
                ? initial++
                : initial;
            }
          }, initial);

          let note = this.project.note.reduce((acc, curr) => {
            if (curr.date == val.date) {
              acc.push(curr);
            }
            return acc;
          }, []);
          return {
            ...val,
            prev_avg_psf: index > 0 ? history[index - 1].avg_psf : "-",
            prev_avg_price: index > 0 ? history[index - 1].avg_price : "-",
            prev_avg_size: index > 0 ? history[index - 1].avg_size : "-",
            prev_total_net_psf:
              index > 0 && val.total_net_psf != null
                ? history[index - 1].total_net_psf
                : "-",
            prev_total_net_price:
              index > 0 && val.total_net_psf
                ? history[index - 1].total_net_psf * history[index - 1].avg_size
                : "-",
            current_total_net_price: val.total_net_psf
              ? val.avg_size * val.total_net_psf
              : "-",
            confirmed_sold: confirmedSold,
            note: note.length > 0 ? note : null,
          };
        });
      }

      return history;
    },
    totalListingSummary() {
      const vm = this;

      let leasing = vm.project.status
        ? ["now leasing", "leased out"].includes(
          vm.project.status.toLowerCase()
        )
        : false;
      let additionalSoldUnits = vm.mlsActiveSort.reduce((acc, curr) => {
        if (
          ["resale", "re-lease", "assignment"].includes(
            curr.custom_listing_type.toLowerCase()
          )
        )
          acc++;
        return acc;
      }, 0);
      let res = new Array(); //erl here
      let activeUnits = vm.allMlsData.filter(data => data.custom_status == 'Active')
      let soldUnits = vm.allMlsData.filter(data => data.custom_status == 'Sold')
      let unreleasedUnits = vm.allMlsData.filter(data => data.custom_status == 'Unreleased')
      let noneUnits = vm.allMlsData.filter(data => data.custom_status == 'None')
      if (vm.isAdmin) {
        res.splice(0, 0, {
          "Total Units": [...vm.allMlsData,
          ].length,
        });
        res.splice(1, 0, {
          "Active Units": vm.mlsActiveSort ? vm.mlsActiveSort.length : "0",
        });
        res.splice(2, 0, {
          "Sold Units": vm.mlsSoldSort ? vm.mlsSoldSort.length : "0",
        });
        res.splice(3, 0, {
          "Unreleased Units": unreleasedUnits ? unreleasedUnits.length : "0",
        });
        res.splice(4, 0, {
          "None": noneUnits ? noneUnits.length : "0",
        });

        if (leasing)
          res.splice(5, 0, {
            "Confirmed Leased Units by Developer": vm.mlsSoldSort
              ? vm.mlsSoldSort.length + additionalSoldUnits
              : "0",
          });
        else
          res.splice(5, 0, {
            "Confirmed Sold Units by Developer": vm.mlsSoldSort
              ? vm.mlsSoldSort.length + additionalSoldUnits
              : "0",
          });
      } else if (
        ["developerbc", "developer"].includes(vm.current_user.role.toLowerCase()) &&
        vm.project.status &&
        !["sold out", "leased out"].includes(vm.project.status.toLowerCase())
      ) {
        res.splice(0, 0, {
          "Total Units": [...vm.allMlsData,
          ].length,
        });
        res.splice(1, 0, {
          "Active Units": vm.mlsActiveSort ? vm.mlsActiveSort.length : "0",
        });
        if (leasing) {
          res.splice(4, 0, {
            "Confirmed Leased": vm.mlsSoldSort
              ? vm.mlsSoldSort.length + additionalSoldUnits
              : "0",
          });
          res.splice(5, 0, {
            "Unreleased/Unidentified": this.combinedUnreleasedUnidentified ? this.combinedUnreleasedUnidentified.length : "0",
          });
        }
        else {
          res.splice(4, 0, {
            "Confirmed Sold": vm.mlsSoldSort
              ? vm.mlsSoldSort.length + additionalSoldUnits
              : "0",
          });
          res.splice(5, 0, {
            "Unreleased/Unidentified": this.combinedUnreleasedUnidentified ? this.combinedUnreleasedUnidentified.length : "0",
          });
        }
      }

      return res;
    },
    mappedUtcExtra() {
      let res = [];
      for (let key in this.utcExtra) {
        if (this.utcExtra[key]) {
          for (let item in this.utcExtra[key]) {
            if (this.utcExtra[key][item]) {
              res.push(this.utcExtra[key][item]);
            }
          }
        }
      }

      return res;
    },
    overViewData: function () {
      const vm = this;
      let mappedData = {};

      mappedData["Project Type"] =
        vm.project.new_p_type && vm.project.new_p_storey != null
          ? vm.project.new_p_type + "(" + vm.project.new_p_storey + ")"
          : vm.project.new_p_type && vm.project.new_p_storey == null
            ? vm.project.new_p_type + "(-)"
            : "-";

      let project_developer = vm.project.consultant
        ? vm.project.consultant.filter((row) => row.type == "Developer")
        : [];

      if (vm.isAdmin) mappedData["Product Type"] = vm.project.product_type;
      else {
        if (
          ["Apartment", "Mixed-Use Apartment"].includes(vm.project.new_p_type)
        ) {
          mappedData["Product Type"] = vm.project.product_type;
        }
      }

      mappedData["Developer"] = project_developer;
      if (vm.project.status) {
        switch (vm.project.status.toLowerCase()) {
          case "selling soon":
            if (vm.current_user.role.toLowerCase() == "developerbc") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Units"] = vm.project.total_units;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }
            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Units"] = vm.project.total_units;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              // mappedData["unitCollection"] = Object.entries(vm.project.unit_collection).filter(x => !['5-bed'].includes(x[0]))
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Sales Start Date"] = vm.project.formatSalesStartDate;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["unitCollection"] = Object.entries(
                vm.project.unit_collection
              ).filter((x) => !["5-bed"].includes(x[0]));
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }
            break;

          case "leasing soon":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
              mappedData["Construction Status"] =
                vm.project.construction_status;
            }
            break;

          case "now leasing":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
            }
            break;

          case "now leasing 2":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
            }
            break;

          case "leased out":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
            }
            break;

          case "leased out 2":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.floor_area;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Parking"] = vm.project.deposit;
              mappedData["Lease Start Date"] = vm.formatSalesStartDate;
              mappedData["Leased Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
            }
            break;

          case "now selling":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
            }
            break;

          case "now selling 2":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit + "%";
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit + "%";
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit + "%";
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit + "%";
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
            }
            break;

          case "sold out":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
            }
            break;

          case "sold out 2":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "admin") {

              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
              mappedData["Occupancy Date"] =
                vm.project.construction_complete_date;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Deposit"] = vm.project.deposit;
              mappedData["Sales Start Date"] = vm.formatSalesStartDate;
              mappedData["Sold Out Date"] = vm.project.sold_out_date;
            }
            break;

          case "in planning":
            if (vm.current_user.role.toLowerCase() == "developerbc") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.type_total_units[
                "Market Strata"
              ]
                ? Number(
                  vm.project.type_total_units["Market Strata"].sqft
                ).toLocaleString()
                : "-";
            }

            if (vm.current_user.role.toLowerCase() == "developer") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.type_total_units[
                "Market Strata"
              ]
                ? Number(
                  vm.project.type_total_units["Market Strata"].sqft
                ).toLocaleString()
                : "-";
            }

            if (vm.current_user.role.toLowerCase() == "admin") {
              mappedData["Units"] = vm.project.total_units;
              mappedData["Unit Type"] = vm.project.utc_specified.gut;
              mappedData["Floor Area"] = vm.project.type_total_units[
                "Market Strata"
              ]
                ? Number(
                  vm.project.type_total_units["Market Strata"].sqft
                ).toLocaleString()
                : "-";
              mappedData["Neighbourhood"] = vm.project.neighbor;
            }

            if (vm.current_user.role.toLowerCase() == "realtor") {

              mappedData["Construction Status"] =
                vm.project.construction_status;
              mappedData["Neighbourhood"] = vm.project.neighbor;
              mappedData["Site Area"] = vm.project.site_area;
              mappedData["Existing Use"] = vm.project.existing_use;
            }
            break;
        }
      }
      return mappedData;
    },
    unitComponent: function () {
      const vm = this;
      let data = vm.project;
      let res = [];
      const historyObj = this.project.attr_history;
      const largestKey = Math.max(...Object.keys(historyObj)) != 0 ? Math.max(...Object.keys(historyObj)) : historyObj[""];
      const lastHistory = historyObj[largestKey] != undefined ? historyObj[largestKey] : historyObj[""];
      var bcNetPsf = lastHistory && lastHistory.total_net_psf && lastHistory.avg_size ? Number(lastHistory.total_net_psf * lastHistory.avg_size) : 0
      var lastEntry = this.formattedProjectHistory.length > 0 ? this.formattedProjectHistory[this.formattedProjectHistory.length - 1] : []
      var historyNetPsf = this.isAdmin ? this.formattedProjectHistory.length > 0 ? lastEntry.total_net_psf : '' : lastHistory.total_net_psf
      var calculatedNetPrice = this.isAdmin ? this.formattedProjectHistory.length > 0 ? Number(data.unit_component.avg_size * lastEntry.total_net_psf) : '' : bcNetPsf
      var historyGrossPrice = data && data.unit_component.avg_psf && data.unit_component.avg_size ? Number(data.unit_component.avg_psf * data.unit_component.avg_size) : 0

      const promise = new Promise((resolve) => {
        Object.entries(data.unit_component).forEach(([key, value]) => {
          switch (key) {
            case "total":
              res.splice(0, 0, { "Total Units": value ? value : "-" });
              break;

            case "rlsd_units":
              res.splice(1, 0, { "Rlsd Units": value ? value : "-" });
              break;

            case "sold_total":
              if (
                ["admin", "developer", "developerbc"].includes(
                  vm.current_user.role
                ) &&
                [
                  "now leasing",
                  "now leasing 2",
                  "leased out",
                  "leased out 2",
                ].includes(vm.project.status.toLowerCase())
              )
                res.splice(3, 0, { "Rept Lsd": value ? value : "-" });
              else res.splice(3, 0, { "Rept Sold": value ? value : "-" });

              if (
                vm.project.status.toLowerCase() == "now selling" &&
                ["admin"].includes(vm.current_user.role)
              )
                res.splice(4, 0, {
                  "Conf Sold": vm.confirmedSold ? vm.confirmedSold : "-",
                });
              else if (
                [
                  "now leasing",
                  "now leasing 2",
                  "leased out",
                  "leased out 2",
                ].includes(vm.project.status.toLowerCase()) &&
                ["admin"].includes(vm.current_user.role)
              )
                res.splice(4, 0, {
                  "Conf Lsd": vm.confirmedSold ? vm.confirmedSold : "-",
                });
              else if (
                ![
                  "now leasing",
                  "now leasing 2",
                  "leased out",
                  "leased out 2",
                  "now selling",
                  "now selling 2",
                  "sold out",
                  "sold out 2",
                ].includes(vm.project.status.toLowerCase())
              )
                res.splice(4, 0, { DOM: vm.getDom ? vm.getDom : "-" });
              break;

            case "avg_size":
              if (["admin"].includes(vm.current_user.role))
                res.splice(6, 0, {
                  "Avg Size": Number(value)
                    ? Number(value).toLocaleString()
                    : "-",
                });
              else
                res.splice(6, 0, {
                  "Avg SF": Number(value)
                    ? Number(value).toLocaleString()
                    : "-",
                });
              break;

            case "avg_price":
              if (
                ["admin", "developer", "developerbc"].includes(
                  vm.current_user.role
                ) &&
                [
                  "now leasing",
                  "now leasing 2",
                  "leased out",
                  "leased out 2",
                ].includes(vm.project.status.toLowerCase())
              )
                res.splice(7, 0, {
                  "Gross Rent": historyGrossPrice
                    ? "$" + historyGrossPrice.toLocaleString()
                    : "-",
                });
              else
                res.splice(7, 0, {
                  "Gross Price": historyGrossPrice
                    ? "$" + historyGrossPrice.toLocaleString()
                    : "-",
                });

              break;

            case "avg_psf":
              if (
                ["admin", "developer", "developerbc"].includes(
                  vm.current_user.role
                ) &&
                [
                  "now leasing",
                  "now leasing 2",
                  "leased out",
                  "leased out 2",
                ].includes(vm.project.status.toLowerCase())
              )
                res.splice(8, 0, {
                  "Gross $PSF": Number(value)
                    ? "$" +
                    Number(value)
                      .toFixed(2)
                      .toLocaleString("en-US", { maximumFractionDigits: 2 })
                    : "-",
                });
              else
                res.splice(8, 0, {
                  "Gross $PSF":
                    Number(value) > 0
                      ? "$" + Math.round(Number(value)).toLocaleString()
                      : "-",
                });
              break;
          }
        });
        if (!this.isMarketStrata)
          res.splice(10, 0, {
            "Net Rent":
              vm.isRealValue(calculatedNetPrice)
                ? `$${Math.round(calculatedNetPrice).toLocaleString()}`
                : "-",
          });
        else
          res.splice(10, 0, {
            "Net Price":
              vm.isRealValue(calculatedNetPrice)
                ? `$${calculatedNetPrice.toLocaleString()}`
                : "-",
          });

        if (
          ["admin", "developer", "developerbc"].includes(
            vm.current_user.role
          ) &&
          [
            "now leasing",
            "now leasing 2",
            "leased out",
            "leased out 2",
          ].includes(vm.project.status.toLowerCase())
        ) {

          res.splice(12, 0, {
            "Net $PSF":
              this.isRealValue(historyNetPsf)
                ? `$${Number.parseFloat(historyNetPsf)
                  .toFixed(2)
                  .toLocaleString()}`
                : "-",
          });
        }

        else
          res.splice(12, 0, {
            "Net $PSF":
              this.isRealValue(historyNetPsf)
                ? `$${Math.round(historyNetPsf).toLocaleString()}`
                : "-",
          });

        resolve("unit component data loaded");
      });

      promise.then((onFulfilled) => { });
      return res;
    },
    formatSalesStartDate: {
      get() {
        const vm = this;

        if (vm.project.sales_start_date.length == 0) return "-";

        let sales_start_date = new Date(vm.project.sales_start_date);

        return sales_start_date;
      },
      set(newVal) {
        this.project.sales_start_date = newVal;
      },
    },
    getDom: function () {
      const vm = this;

      if (vm.project.sales_start_date.length == 0) return "-";

      let sales_start_date = new Date(vm.project.sales_start_date);
      let curr_date = new Date();
      const diffTime = Math.abs(curr_date - sales_start_date);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    isAdmin: {
      get() {
        return this.current_user.role == "admin";
      },
    },
    mlsHeaderFields: {
      get() {
        let res = [];
        if (this.current_user) {
          res = [
            { label: "Unit #", key: "mls_address" },
            { label: "Plan Name", key: "mls_plan_name" },
            { label: "Beds", key: "mls_beds" },
            { label: "Baths", key: "mls_baths" },
            { label: "FP Specs", key: "fp_specs" },
            {
              label: "List Price",
              key: "mls_list_price",
              formatter: this.roundToWholeNumber,
              sortable: true,
            },
            {
              label: "$PSF",
              key: "mls_psf",
              formatter: this.roundToWholeNumber,
              sortable: true,
            },
            { label: "Price Date", key: "mls_price_date" },
            {
              label: "Delete",
              key: "delete",
              thClass: { "d-none": this.current_user.role != "admin" },
              tdClass: { "d-none": this.current_user.role != "admin" },
            },
          ];
        }

        return res;
      },
      set(newValue) {
        return newValue;
      },
    },
    mlsHeaderFields2: {
      get() {
        let res = [];
        if (this.current_user) {
          res = [
            { label: "Unit Size", key: "mls_unit_size" },
            { label: "Parking", key: "stalls" },
            { label: "Stalls", key: "mls_parking" },
            { label: "List Date", key: "mls_list_date" },
          ];
        }

        return res;
      },
      set(newValue) {
        return newValue;
      },
    },
    showUnitMix: function () {
      const data = this;
      if (data.current_user) {
        let res = [
          data.project.mls_last_date_active,
          data.project.mls_last_date_sold,
          data.project.mls_last_date_other,
        ].some((value) => {
          return (
            typeof value !== "undefined" &&
            (Object.values(this.project.mls_last_date_active).length > 0 ||
              Object.values(this.project.mls_last_date_sold).length > 0)
          );
        });

        if (
          (res && data.project.is_admin) ||
          data.current_user.role === "developer" ||
          data.current_user.role === "developerbc" ||
          data.current_user.role === "realtor"
        ) {
          return true;
        }
      }

      return false;
    },
    permitSort: function () {
      var ob = [];
      if (Object.entries(this.project.permit_data || {}).length > 0) {
        Object.values(this.project.permit_data).forEach((el) => {
          ob.push(el);
        });
        ob = ob.sort(function (a, b) {
          if (a.timeUnix > b.timeUnix) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      return ob;
    },
    mlsTotalSort: function () {
      var vm = this;
      var result = [...vm.processedUnits];
      if (result.length === 0) return [];
      const sortObj = {
        Studio: 0,
        s: 0,
        jr: 1,
        Junior: 1,
        1: 2,
        2: 3,
        3: 4,
        4: 5,
        5: 6,
      };
      result.sort(function (a, b) {
        let weightA = sortObj[a["bed"]] || 0;
        let weightB = sortObj[b["bed"]] || 0;

        const addWeight = (specs) => {
          if (!specs) return 0;
          if (specs.includes("Lock-Off")) return 0.9;
          if (specs.includes("Live/Work")) return 0.8;
          if (specs.includes("Jr Bed")) return 0.7;
          if (specs.includes("TH")) return 0.6;
          if (specs.includes("Roof Deck")) return 0.5;
          if (specs.includes("Bonus Room")) return 0.4;
          if (specs.includes("Den(2)")) return 0.3;
          if (specs.includes("Den")) return 0.2;
          if (specs.includes("Loft")) return 0.1;
          return 0;
        };

        weightA += addWeight(a["fp_specs"]);
        weightB += addWeight(b["fp_specs"]);

        const addPHWeight = (specs) => {
          if (!specs) return 0;
          if (
            specs.includes("Sub-PH") &&
            specs.replace("Sub-PH", "").includes("PH")
          )
            return 9;
          if (specs.includes("PH") && !specs.includes("Sub-PH")) return 8;
          if (specs.includes("Sub-PH")) return 7;
          return 0;
        };

        const phWeightA = addPHWeight(a["fp_specs"]);
        const phWeightB = addPHWeight(b["fp_specs"]);

        if (
          (a["fp_specs"] && a["fp_specs"].includes("PH")) ||
          (b["fp_specs"] && b["fp_specs"].includes("PH"))
        ) {
          weightA += phWeightA;
          weightB += phWeightB;

          if (weightA === weightB) {
            if (a["bed"] === b["bed"] && a["bath"] === b["bath"]) {
              return a["total_size"] / a["num"] - b["total_size"] / b["num"];
            }
            if (a["bed"] === b["bed"]) {
              return a["bath"] - b["bath"];
            }
            return (sortObj[a["bed"]] || 0) - (sortObj[b["bed"]] || 0);
          } else {
            return weightA - weightB;
          }
        }

        if (a["bed"] === b["bed"] && a["bath"] === b["bath"]) {
          return a["total_size"] / a["num"] - b["total_size"] / b["num"];
        }
        if (a["bed"] === b["bed"]) {
          return a["bath"] - b["bath"];
        }
        return weightA - weightB;
      });

      if (vm.currentSort) {
        result.sort((a, b) => {
          let modifier = 1;
          if (vm.currentSortDir === "desc") modifier = -1;

          const isEmpty = (value) => {
            return (
              value === null ||
              value === undefined ||
              value === "" ||
              (typeof value === "number" && isNaN(value)) ||
              (Array.isArray(value) && value.length === 0) ||
              (typeof value === "object" && Object.keys(value).length === 0)
            );
          };

          let aValue, bValue;

          switch (vm.currentSort) {
            case "avgSf":
              aValue = a.total_size && a.num ? a.total_size / a.num : null;
              bValue = b.total_size && b.num ? b.total_size / b.num : null;
              break;
            case "avgPricePsf":
              aValue =
                a.avgPrice && a.total_size && a.num
                  ? a.avgPrice / (a.total_size / a.num)
                  : null;
              bValue =
                b.avgPrice && b.total_size && b.num
                  ? b.avgPrice / (b.total_size / b.num)
                  : null;
              break;
            case "percentage":
              const totalUnits = result.reduce(
                (acc, unit) => acc + unit.num,
                0
              );
              aValue = totalUnits > 0 ? (a.num / totalUnits) * 100 : null;
              bValue = totalUnits > 0 ? (b.num / totalUnits) * 100 : null;
              break;
            case "stall.final":
              aValue = a.stall ? a.stall.final : null;
              bValue = b.stall ? b.stall.final : null;
              break;
            // Add more cases for nested properties if needed
            default:
              aValue = a[vm.currentSort];
              bValue = b[vm.currentSort];
              break;
          }

          const aIsEmpty = isEmpty(aValue);
          const bIsEmpty = isEmpty(bValue);

          if (aIsEmpty && bIsEmpty) {
            return 0;
          }
          if (aIsEmpty) {
            return 1;
          }
          if (bIsEmpty) {
            return -1;
          }

          if (typeof aValue === "string" && typeof bValue === "string") {
            return aValue.localeCompare(bValue) * modifier;
          } else if (
            typeof aValue === "number" &&
            typeof bValue === "number"
          ) {
            return (aValue - bValue) * modifier;
          } else if (
            typeof aValue === "boolean" &&
            typeof bValue === "boolean"
          ) {
            // Assuming false < true for boolean sorting
            return (aValue === bValue ? 0 : aValue ? -1 : 1) * modifier;
          }

          // Fallback for other types or mixed types
          return (aValue > bValue ? 1 : aValue < bValue ? -1 : 0) * modifier;
        });
      }


      return result.filter((i) => i.bed != "");
    },
    mlsTotalSummary() {
      const vm = this;
      const units = vm.mlsTotalSort;

      if (!units || units.length === 0) {
        return {
          totalNum: 0,
          totalConfirmedSold: 0,
          totalParking: 0,
          totalStalls: 0,
          minOverallSize: null,
          maxOverallSize: null,
          avgOverallSize: 0,
          minOverallPrice: null,
          maxOverallPrice: null,
          avgOverallPrice: 0,
          avgOverallPricePsf: 0,
          overallPercentage: 0,
        };
      }

      let totalNum = 0;
      let totalConfirmedSold = 0;
      let totalParking = 0;
      let totalStalls = 0;
      let totalSizeSum = 0;
      let totalPriceSum = 0;
      let unitsWithPrices = 0;
      let unitsWithSize = 0;
      let unitsWithPriceAndSize = 0;

      let minOverallSize = Infinity;
      let maxOverallSize = -Infinity;
      let minOverallPrice = Infinity;
      let maxOverallPrice = -Infinity;

      units.forEach((unit) => {
        totalNum += unit.num || 0;
        totalConfirmedSold += unit.confirmed_sold || 0;
        totalParking += unit.parking || 0;
        totalStalls +=
          (unit.stall && typeof unit.stall.final === "number"
            ? unit.stall.final
            : 0) * (unit.num || 1);

        if (unit.minSize !== undefined && unit.minSize !== null) {
          minOverallSize = Math.min(minOverallSize, unit.minSize);
        }
        if (unit.maxSize !== undefined && unit.maxSize !== null) {
          maxOverallSize = Math.max(maxOverallSize, unit.maxSize);
        }
        if (unit.total_size !== undefined && unit.total_size !== null) {
          totalSizeSum += unit.total_size;
          unitsWithSize += unit.num;
        }

        if (unit.minPrice !== undefined && unit.minPrice !== null) {
          minOverallPrice = Math.min(minOverallPrice, unit.minPrice);
        }
        if (unit.maxPrice !== undefined && unit.maxPrice !== null) {
          maxOverallPrice = Math.max(maxOverallPrice, unit.maxPrice);
        }
        if (this.isRealValue(unit.custom_avg_price)) {
          totalPriceSum += unit.custom_avg_price * unit.num;
          unitsWithPrices += unit.num;
        }

        if (
          unit.avgPrice !== undefined &&
          unit.avgPrice !== null &&
          unit.total_size !== undefined &&
          unit.total_size !== null
        ) {
          unitsWithPriceAndSize += unit.num;
        }
      });

      const avgOverallSize =
        unitsWithSize > 0 ? totalSizeSum / unitsWithSize : 0;
      const avgOverallPrice =
        unitsWithPrices > 0 ? totalPriceSum / unitsWithPrices : 0;
      const avgOverallPricePsf =
        avgOverallPrice > 0 && avgOverallSize > 0
          ? avgOverallPrice / avgOverallSize
          : 0;

      return {
        totalNum: totalNum,
        totalConfirmedSold: totalConfirmedSold,
        totalParking: totalParking,
        totalStalls: totalStalls,
        minOverallSize: minOverallSize === Infinity ? null : minOverallSize,
        maxOverallSize: maxOverallSize === -Infinity ? null : maxOverallSize,
        avgOverallSize: avgOverallSize,
        minOverallPrice: minOverallPrice === Infinity ? null : minOverallPrice,
        maxOverallPrice: maxOverallPrice === -Infinity ? null : maxOverallPrice,
        avgOverallPrice: totalPriceSum,
        avgOverallPricePsf: avgOverallPricePsf,
      };
    },
    mlsAvailTotalSort: function () {
      var vm = this;
      var activeResult = [];
      if (typeof vm.project.unit_component.activeBed != "undefined") {
        Object.values(vm.project.unit_component.activeBed).forEach((el) => {
          Object.values(el).forEach((single) => {
            activeResult.push(single);
          });
        });
        activeResult.sort(function (a, b) {
          if (a["bed"] == b["bed"]) {
            if (a["bath"] == b["bath"]) {
              if (a["total_size"] / a["num"] < b["total_size"] / b["num"]) {
                return -1;
              } else {
                return 1;
              }
            } else {
              return a["bath"] - b["bath"];
            }
          } else {
            return a["bed"] - b["bed"];
          }
        });
      }
      return activeResult.filter((i) => i.bed != "");
    },
    mlsSoldTotalSort: function () {
      var vm = this;
      if (typeof vm.project.unit_component.bedSold != "undefined") {
        var ob = Object.values(vm.project.unit_component.bedSold).sort(
          function (a, b) {
            if (a["bed"] == b["bed"]) {
              if (a["bath"] == b["bath"]) {
                if (a["total_size"] / a["num"] < b["total_size"] / b["num"]) {
                  return -1;
                } else {
                  return 1;
                }
              } else {
                return a["bath"] - b["bath"];
              }
            } else {
              return a["bed"] - b["bed"];
            }
          }
        );
        return ob.filter((i) => i.bed != "");
      }
    },
    floorPlanSort: function () {
      return _.orderBy(
        this.project.date_based_floor_plan_ref[this.floorPlanPick],
        "fp_weight"
      );
    },
    avgPlan: function () {
      return this.project.avg_result[this.floorPlanPick];
    },
    combinedUnreleasedUnidentified: function () {
      if (this.project != null) {
        if (this.allMlsData.length <= 0) return []
        return this.allMlsData
          ? this.allMlsData.filter(i => ["Unreleased", "None"].includes(i.custom_status))
          : [];
      }
    },
    mlsSoldSort: function () {
      if (this.project != null) {
        if (this.project.mls_last_date_sold.length <= 0) return []
        return this.project.mls_last_date_sold
          ? this.project.mls_last_date_sold
          : [];
      }
    },
    mlsActiveSort: function () {
      if (this.project != null) {
        if (this.project.mls_last_date_active.length <= 0) return []
        return this.project.mls_last_date_active
          ? this.project.mls_last_date_active
          : [];
      }
    },
    mlsOtherSort: function () {
      if (this.project != null) {
        if (this.project.mls_last_date_other.length <= 0) return []
        return this.project.mls_last_date_other
          ? this.project.mls_last_date_other
          : [];
      }
    },
    picListConstruction: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "construction";
      });
    },
    picListSite: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        // return el.group == 'site';
        return el.group == "project";
      });
    },
    picListPresentation: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "presentation";
      });
    },
    picListAmenity: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "amenity";
      });
    },
    picListInterior: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "interior";
      });
    },
    picListProject: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "project";
      });
    },
    picListRender: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "rendering";
      });
    },
    picListConstruction: function () {
      if (this.project.pic_list == null) {
        return [];
      }
      return this.project.pic_list.filter(function (el) {
        return el.group == "construction";
      });
    },
    mergedGallery: {
      get() {
        let gallery = this.project.pic_list;

        if (gallery == null) {
          return [];
        }

        if (
          this.selectedGalleryType &&
          this.selectedGalleryType != null &&
          this.selectedGalleryType != "VIEW ALL"
        ) {
          gallery = gallery.filter(
            (pic) => pic.group == this.selectedGalleryType.toLowerCase()
          );
        }
        return gallery;
      },
      set(newVal) {
        return newVal;
      },
    },
    galleryOptions() {
      const map = new Map();
      if (!this.project || !this.project.pic_list) {
        return [];
      }
      let mappedGallery = this.project.pic_list.map((pic) => {
        return { value: pic.group, text: pic.group.toUpperCase() };
      });
      for (const item of mappedGallery) {
        map.set(item.value, item);
      }
      let res = [
        { value: "VIEW ALL", text: "SELECT GALLERY CATEGORY" },
        ...map.values(),
      ];
      this.selectedGalleryType = res[0].value;
      return res;
    },
  },
  methods: {
    goToNewView() {
      this.$router.push({ name: "project-detail", query: this.$route.query });
    },
    async fetchMlsData() {
      const vm = this;
      if (!vm.project?.unit_component?.bed) return;

      let units = [];
      Object.values(vm.project.unit_component.bed).forEach((bedGroup) => {
        Object.values(bedGroup).forEach((single) => {
          units.push(single);
        });
      });

      vm.loadingMls = true;

      const promises = units.map((single) => {
        if (single.floor_plan) {
          single.confirmed_sold = single.floor_plan.reduce((acc, curr) => {
            return curr.status === "Sold" ? acc + 1 : acc;
          }, 0);
        }

        return $.get(`${BACKEND_URL}api/get_unit_mix_group?uid=${this.$route.query.uid}&unit_key=${single.unit_key}&size_range=${single.size_range}`)
          .then(res => {
            let mapped = new Object(res);
            let merged = [...(mapped['mls_last_date_active'] || []), ...(mapped['mls_last_date_sold'] || [])];
            let filteredData = merged.filter(i => vm.isRealValue(i.mls_list_price));

            if (merged && merged.length > 0) {
              let avgPrice = Math.round(filteredData.reduce((acc, curr) => {
                return acc += vm.isRealValue(curr.mls_list_price) ? Number(curr.mls_list_price) : 0;
              }, 0) / (filteredData.length || 1));

              let avgSize = Math.round(merged.reduce((acc, curr) => {
                return acc += vm.isRealValue(curr.mls_unit_size) ? Number(curr.mls_unit_size) : 0;
              }, 0) / merged.length);

              vm.$set(single, 'custom_avg_price', vm.isRealValue(avgPrice) ? avgPrice : 0);
              vm.$set(single, 'custom_avg_size', avgSize);
            } else {
              vm.$set(single, 'custom_avg_price', 0);
              vm.$set(single, 'custom_avg_size', 0);
            }
            return single;
          })
          .catch(() => single);
      });

      const results = await Promise.all(promises);
      vm.processedUnits = results;
      vm.loadingMls = false;
    },
    formatCurrency(num) {
      if (!this.isRealValue(num))
        return '-'

      const formatterUs = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
        style: 'currency',
        currency: 'USD',
      })
      const value = Number(num)
      return formatterUs.format(value)
    },
    async fetchProjectHistory() {
      try {
        const uid = this.$route.query.uid;
        if (!uid) return;
        const res = await axios.get(`${BACKEND_URL}api/utc_date_based_attributes?uid=${uid}`);
        this.rawHistoryNodes = res?.data?.nodes || [];
      } catch (error) {
        console.error("Error fetching table data:", error);
      }
    },

    formatUnixToCustom(unix) {
      if (!unix) return null;
      const date = new Date(Number(unix) < 10000000000 ? unix * 1000 : unix);
      if (isNaN(date.getTime())) return unix;
      const day = String(date.getDate()).padStart(2, '0');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${day}-${months[date.getMonth()]}-${String(date.getFullYear()).slice(-2)}`;
    },
    handleBulkUpdateTrigger(cids) {
      this.selectedCidsForBulk = cids;
      this.openTab = { title: 'Bulk Update', value: 'bulk_update' };
    },
    getRentalMainData(item) {
      this.$nextTick(() => {
        console.log(item);
      });
    },
    fetchData() {
      const vm = this
      vm.project = null
      this.project_link = "/project?project=" + this.project_id;
      var queryString = "";
      if (typeof this.collection_ids != "object") {
        queryString += "&fid[]=" + this.collection_ids;
      } else {
        this.collection_ids.forEach((element) => {
          queryString += "&fid[]=" + element;
        });
      }

      if (this.$route.query["permit"]) {
        this.openTab.value = "permits";
      }
      if (this.$route.query.tab == "unit") {
        this.openTab.value = "unitmix";
      }
      this.queryParams =
        "pid=" +
        this.project_id +
        queryString +
        "&sid=" +
        this.$route.query.sid +
        "&uid=" +
        this.$route.query.uid;
      $.get(
        {
          url:
            BACKEND_URL +
            "api/get_utc?pid=" +
            this.project_id +
            queryString +
            "&sid=" +
            this.$route.query.sid +
            "&uid=" +
            this.$route.query.uid,
        },
        (data, status) => {
          if (status === "success") {
            if (data) {
              let mapped = new Object(data);
              mapped.unit_net_price = this.getUnitNetPrice(data);
              mapped.unit_net_psf = this.getUnitTotalNetPsf(data);
              function calculateCustomPsf(data) {
                let netPrice = Number(
                  data.mls_list_price - data.buyer_incentives
                );
                let res = !["leased out"].includes(mapped.status.toLowerCase())
                  ? Math.round(Number(netPrice / data.mls_unit_size))
                  : Number(netPrice / data.mls_unit_size).toFixed(2);
                return res > 0 ? res : "-";
              }
              function calculateListPriceNet(data) {
                let res = Number(data.mls_list_price - data.buyer_incentives);
                return res > 0 ? res : "-";
              }
              function calculateNetPrice(data) {
                let res = Number(
                  data.price_second - data.buyer_incentives_second
                );
                return res > 0 ? res : "-";
              }
              function setStatus(row, data) {
                return ["now leasing", "leased out", "leased out 2", "now leasing 2"].includes(
                  data.status.toLowerCase()
                ) && ["sold"].includes(row.mls_status.toLowerCase())
                  ? "Leased"
                  : row.mls_status;
              }

              for (const key in mapped) {
                if (
                  mapped.hasOwnProperty(key) &&
                  [
                    "mls_last_date_active",
                    "mls_last_date_sold",
                    "mls_last_date_other",
                  ].includes(key)
                ) {
                  var value = data[key];
                  value.forEach((mlsRow) => {
                    let priceGap = this.getPriceGap(mlsRow);
                    let priceNet = calculateListPriceNet(mlsRow);
                    mlsRow.history = Object.entries(mapped.mls_data).filter(
                      ([key, value]) => key == mlsRow.cid
                    )[0][1];
                    mlsRow.rowSelected = false;
                    mlsRow.favorite = false;
                    mlsRow.net_psf = !isNaN(Number(mlsRow.mls_list_price))
                      ? Math.round(
                        Number(mlsRow.mls_list_price) /
                        Number(mlsRow.mls_unit_size)
                      )
                      : "-";
                    mlsRow.custom_net_psf = calculateCustomPsf(mlsRow);
                    mlsRow.list_price_net = priceNet;
                    mlsRow.previous_net_price = calculateNetPrice(mlsRow);
                    mlsRow.custom_net_mls_sold_price = this.isRealValue(
                      mlsRow.mls_sold_price
                    )
                      ? Number(mlsRow.mls_sold_price - mlsRow.buyer_incentives)
                      : "-";
                    mlsRow.custom_listing_type = this.setListingType(
                      mlsRow,
                      mapped
                    );
                    mlsRow.custom_status = setStatus(mlsRow, mapped);
                    mlsRow.custom_mls_net_rent = Math.round(
                      mlsRow.mls_list_price - mlsRow.buyer_incentives
                    );
                    mlsRow.custom_mls_net_psf =
                      mlsRow.mls_list_price > 0
                        ? Number(mlsRow.net_price / mlsRow.mls_unit_size).toFixed(
                          2
                        )
                        : "-";
                    mlsRow.calc_sold_psf =
                      mlsRow.mls_sold_price > 0
                        ? Math.round(mlsRow.mls_sold_price / mlsRow.mls_unit_size)
                        : "-";
                    mlsRow.net_sold_psf =
                      mlsRow.mls_sold_price > 0
                        ? Math.round(
                          (mlsRow.mls_sold_price - mlsRow.buyer_incentives) /
                          mlsRow.mls_unit_size
                        )
                        : "-";
                    mlsRow.custom_sold_psf = [mlsRow.mls_list_price, mlsRow.mls_unit_size].every(item => vm.isRealValue(item)) ? Number(
                      mlsRow.mls_list_price / mlsRow.mls_unit_size
                    ) : 0;
                    mlsRow.custom_strata_fee = Number(
                      mlsRow.mls_unit_size * mapped.strata_fee
                    );
                    mlsRow.custom_parking_stall_cost = mapped.parking_stall_cost;
                    mlsRow.custom_storage_locker_cost =
                      mapped.storage_locker_cost;
                    mlsRow.custom_price_gap = priceGap;
                    if (this.isAdmin)
                      mlsRow._rowVariant =
                        ["None", "Unreleased"].includes(mlsRow.mls_status)
                          ? "light"
                          : mlsRow.mls_status == "Active"
                            ? "success"
                            : "danger";

                    mlsRow.custom_price_confidence =
                      this.getPriceConfidence(priceGap, mlsRow);
                    mlsRow.custom_price_change = this.getPriceChange(
                      mlsRow.previous_net_price,
                      priceNet
                    );
                    mlsRow.custom_field_mls_beds_value = {
                      type:
                        mlsRow.mls_beds == "s"
                          ? "Studio"
                          : mlsRow.mls_beds == "jr"
                            ? "Jr 1" + "-bed"
                            : mlsRow.mls_beds
                              ? mlsRow.mls_beds + "-bed"
                              : "",
                      fp_specs:
                        mlsRow.fp_specs.toLocaleLowerCase() != "none"
                          ? mlsRow.fp_specs
                          : "",
                    };
                  });
                }
              }
              vm.project = mapped;
              var allData = [
                ...mapped.mls_last_date_active,
                ...mapped.mls_last_date_sold,
                ...mapped.mls_last_date_other,
              ];
              this.projectStore.setProject(mapped);
              // Exclude None status on non-admin role
              allData = allData.filter((mls) => {
                if (vm.isAdmin) {
                  return true;
                } else {
                  return mls.mls_status != "None";
                }
              });
              vm.allMlsData = allData;
              if (mapped.mls_rental_data) {
                for (let key in mapped.mls_rental_data) {
                  let latestData =
                    mapped.mls_rental_data[key][
                    mapped.mls_rental_data[key].length - 1
                    ];

                  let mlsData = allData
                    .filter(
                      (mls) =>
                        mls.cid == key && mls.custom_listing_type != "Assignment"
                    )
                    .map((mlsRow) => {
                      return {
                        ...mlsRow,
                        custom_status: latestData.status,
                        mls_sold_price: latestData.sold_price,
                        mls_price_date: latestData.price_date,
                        mls_sold_date: latestData.sold_date,
                        mls_list_price: latestData.list_price,
                        list_price_net: latestData.list_price - 0,
                        mls_unit_size: mlsRow.mls_unit_size,
                        rid: latestData.rid,
                        mls_psf: Number(latestData.list_price / mlsRow.mls_unit_size).toFixed(2),
                        custom_net_psf: Number(latestData.list_price / mlsRow.mls_unit_size).toFixed(2),
                        _rowVariant: ["None", "Unreleased"].includes(latestData.status)
                          ? "light"
                          : latestData.status == "Active"
                            ? "success"
                            : "danger"
                      };
                    });
                  vm.mlsRentalData.push(mlsData[0]);
                }
              }

              let strata_fee = ![null, 0, "", "0"].includes(vm.project.strata_fee)
                ? `$${parseFloat(vm.project.strata_fee)}`
                : "-";

              if (vm.isMarketStrata) {
                vm.feature_items = [
                  {
                    strata_fee: strata_fee,
                    parking_stall_cost: vm.project.parking_stall_cost
                      ? `$${vm.project.parking_stall_cost}`
                      : "-",
                    storage_locker_cost: vm.project.storage_locker_cost
                      ? `$${vm.project.storage_locker_cost}`
                      : "-",
                  },
                ];
              } else {
                vm.feature_items = [
                  {
                    parking_stall_cost: vm.project.parking_stall_cost
                      ? `$${vm.project.parking_stall_cost}`
                      : "-",
                    storage_locker_cost: vm.project.storage_locker_cost
                      ? `$${vm.project.storage_locker_cost}`
                      : "-",
                  },
                ];
              }
              vm.salesStartDate = vm.project.sales_start_date;
            }

            vm.landInfo = data.ltsa_info;
            Object.keys(vm.landInfo).forEach((key) => {
              vm.selectedDateMap[key] = {
                selectedDate: Object.keys(vm.landInfo[key].reg)[0],
              };
            });
            vm.floorPlanPick = data.first_floor_plan_key;

            if (data.attr_history) {
              for (value in data.attr_history) {
                if (
                  !isNaN(Number(data.attr_history[value].sold_total)) &&
                  Number(data.attr_history[value].sold_total) > 0
                ) {
                  vm.chartDataSale.labels.push(data.attr_history[value].date);
                  vm.chartDataSale.datasets[0].data.push(
                    data.attr_history[value].sold_total
                  );
                }
              }
            }

            if (vm.project.pic_list) {
              vm.project.pic_list.forEach((element) => {
                vm.image_lists.push(element.url);
              });
            }
            if (vm.project.consultant) {
              vm.project.consultant.forEach((element) => {
                if (element.type == "Developer") {
                  vm.developer = element.name;
                }
              });
            }
            this.$nextTick(function () {
              // this.$emit('height', this.$el.clientHeight)
              if (typeof vm.project["geo_info"] != "undefined") {
                this.singleMap(
                  vm.project["geo_info"]["lat"],
                  vm.project["geo_info"]["lng"]
                );
              }

              this.setRpdHeaderFields();
            });

            vm.setUnitPreviewSummaryHeaderFields();
          }
          useRequestCounter().incrementCompletedRequest();

          vm.setHistoryTableHeaderFields();
        }
      );
    },
    formatTableData(data) {
      if (!this.isRealValue(data.value)) return "-";

      if (["list_price", "sold_price"].includes(data.field.key))
        return `$${Math.round(data.value).toLocaleString()}`;

      return data.value;
    },
    updateMls({ cid, unit }) {
      this.openTab.value = "uploadnew";
      this.mlsCid = cid;
      this.mlsUnit = unit;
    },
    resetHeaders() {
      this.setRpdHeaderFields()
    },
    isRealValue(value) {
      return !["zero", "", "-", null, 0, undefined, "0", "null"].includes(
        value
      );
    },
    formatStorageCost(value) {
      if (!this.isRealValue(value)) return "-";

      var stall_cost = value.split("-");

      return stall_cost
        .map((stall) => `$${Number(stall.replace(/,/g, "")).toLocaleString()}`)
        .join("-");
    },
    updateFields({ header_fields, custom_headers }) {
      this.rpdTableList1 = header_fields;
      this.rpdTableList2 = custom_headers;
    },
    numberWithCommasPrice(x) {
      if (x === null || x === undefined || isNaN(x)) return "-";
      return parseFloat(x).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    sortBy(key) {
      if (this.currentSort === key) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        this.currentSort = key;
        this.currentSortDir = "asc";
      }
    },
    filterSummary(data) {
      this.unitPreviewSummary = data.filter((row) => row.rowSelected);
    },
    toggleField() {
      this.custom_header_field = !this.custom_header_field;
    },
    getPriceChange(oldValue, newValue) {
      let oldToNum = Number(oldValue);
      let newToNum = Number(newValue);
      let result = {
        diffPercentage: "",
        color: "",
        icon: "",
      };

      if (newValue == "-" || !oldValue)
        return (result = {
          diffPercentage: "",
          color: "",
          icon: "",
        });
      if (oldValue == null) result.diffPercentage = 0;
      else
        result.diffPercentage = Number(
          ((newToNum - oldToNum) / oldToNum) * 100
        ).toFixed(2);

      if (Number(result.diffPercentage) > 0) {
        result.color = "green";
        result.icon = "fa-long-arrow-alt-up";
      } else if (Number(result.diffPercentage) < 0) {
        result.color = "red";
        result.icon = "fa-long-arrow-alt-down";
      } else {
        result.diffPercentage = 0;
        result.color = "black";
        result.icon = "minus";
      }

      return result;
    },
    hideFeedbackModal() {
      this.$bvModal.hide("feedback-modal");
    },
    getPriceConfidence(priceGap, mlsRow) {
      var priceConfidence = "Low";
      if (
        [mlsRow.mls_sold_price].some((data) =>
          this.isRealValue(data)
        ) || ([mlsRow.mls_price_date, mlsRow.mls_sold_date].every(date => this.isRealValue(date)) && priceGap == 0)
      )
        return "Verified";
      if (priceGap <= 91 && priceGap > 0) {
        priceConfidence = "High";
      } else if (priceGap >= 92 && priceGap <= 365) {
        priceConfidence = "Medium";
      } else if (priceGap >= 366) {
        priceConfidence = "Low";
      } else priceConfidence = "-";

      return priceConfidence;
    },
    getPriceGap(mlsRow) {
      const date1 = new Date(mlsRow.mls_price_date);
      const date2 = new Date(mlsRow.mls_sold_date);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if ([mlsRow.mls_price_date, mlsRow.mls_sold_date].some(date => !this.isRealValue(date))) return '-'
      return ![NaN, 0].includes(diffDays) && mlsRow.mls_status == "Sold"
        ? diffDays
        : 0;
    },
    getHistoryNote({ notes }) {
      this.history_note = notes;
      this.$bvModal.show("history_note");
    },
    getUnits(units) {
      this.confirmed_sold_units = units;
      this.confirmed_sold_unit_fields = [
        { label: "Unit #", key: "mls_address", sortable: true },
        { label: "Plan Name", key: "mls_plan_name", sortable: true },
        { label: "Beds", key: "mls_beds", sortable: true },
        { label: "Baths", key: "mls_baths", sortable: true },
        { label: "FP Specs", key: "fp_specs", sortable: true },
        {
          label: "List Price",
          key: "mls_list_price",
          formatter: this.roundToWholeNumber,
          sortable: true,
        },
        {
          label: "$PSF",
          key: "mls_psf",
          formatter: this.roundToWholeNumber,
          sortable: true,
        },
        { label: "Price Date", key: "mls_price_date" },
      ];
      this.$bvModal.show("confirmed-sold-modal");
    },
    updateTotalRows({ filtered_data, listingType }) {
      this.exportedData = filtered_data;
      switch (listingType) {
        case "active":
          this.totalRows.active = filtered_data.length;
          break;
        case "sold":
          this.totalRows.sold = filtered_data.length;
          break;
        case "other":
          this.totalRows.other = filtered_data.length;
          break;
        case "all":
          this.totalRows.all = filtered_data.length;
          break;
      }

      this.getAvailablePricing(filtered_data);
    },
    generateFloorPlanSummaryChart() {
      const vm = this;
      const ctx = vm.$refs.summaryChart;
      let graphData = vm.unitPreviewSummary.sort((a, b) => a.units - b.units);
      if (!ctx) {
        return;
      }
      if (ctx) {
        vm.$nextTick(function () {
          new ChartJS(ctx, {
            type: "bar",
            data: {
              labels: graphData.map((item) => {
                let fp_specs =
                  item.type.fp_specs != "None" ? item.type.fp_specs : "";
                let beds = !["s", "jr"].includes(item.type.mls_beds)
                  ? item.type.mls_beds + "-bed"
                  : item.type.mls_beds == "jr"
                    ? "Jr 1-bed"
                    : "Studio";
                return (
                  beds +
                  `${fp_specs ? "/" : ""}` +
                  fp_specs +
                  " | " +
                  item.mls_plan_name
                );
              }),
              datasets: [
                {
                  label: "Total Units",
                  data: vm.unitPreviewSummary.map((item) => item.units),
                  borderWidth: 1,
                  backgroundColor: "rgb(201, 203, 207)",
                  fontSize: 18,
                },
                {
                  label: "Confirmed Sold Units",
                  data: vm.unitPreviewSummary.map(
                    (item) => item.confirmed_sold
                  ),
                  borderWidth: 1,
                  backgroundColor: "rgba(255, 99, 132, 0.2)",
                  fontSize: 18,
                },
              ],
            },
            options: {
              indexAxis: "y",
              plugins: {
                legend: {
                  labels: {
                    color: "#000", // Change the color of the legend text
                    font: {
                      size: 18, // Change the font size of the legend text
                    },
                  },
                },
                tooltip: {
                  enabled: false,
                },
                // Enable datalabels and customize its appearance
                datalabels: {
                  anchor: "center", // Position of the label (e.g., 'end', 'center')
                  align: "center", // Alignment of the label (e.g., 'top', 'center')
                  color: "#000", // Text color for the labels
                  font: {
                    size: "15",
                  },
                },
              },
              scales: {
                y: {
                  display: true,
                  ticks: {
                    font: {
                      size: 18,
                      weight: "bold",
                    },
                  },
                  title: {
                    display: false,
                  },
                },
                x: {
                  display: true,
                  ticks: {
                    font: {
                      size: 18,
                      weight: "bold",
                    },
                  },
                  title: {
                    display: false,
                  },
                },
              },
            },
          });
        });
      }
    },
    getAvailablePricing(data) {
      const vm = this;
      let unitsWithListPrice = data.filter(
        (item) => item.mls_list_price && !isNaN(Number(item.mls_list_price))
      );
      let availability = unitsWithListPrice.reduce(
        (acc, curr) => {
          acc.units++;
          if (curr.mls_list_price && !isNaN(Number(curr.mls_list_price))) {
            acc.size += Math.round(Number(curr.mls_unit_size));
          }
          if (curr.mls_list_price && !isNaN(Number(curr.mls_list_price))) {
            acc.list_price += Math.round(Number(curr.mls_list_price));
          }
          if (curr.custom_sold_psf && !isNaN(Number(curr.custom_sold_psf))) {
            acc.psf += Number(curr.custom_sold_psf) / acc.units;
          }
          if (curr.buyer_incentives && !isNaN(Number(curr.buyer_incentives))) {
            acc.buyer_incentives += Number(curr.buyer_incentives);
          }
          if (curr.net_price && !isNaN(Number(curr.net_price))) {
            acc.net_price += Math.round(curr.net_price);
          }
          if (curr.net_psf && !isNaN(Number(curr.net_psf))) {
            acc.net_psf += Math.round(curr.net_psf);
          }
          return acc;
        },
        {
          units: 0,
          size: 0,
          list_price: 0,
          psf: 0,
          net_psf: 0,
          net_price: 0,
          buyer_incentives: 0,
        }
      );
      if (unitsWithListPrice.length <= 0) {
        vm.currentAvailability = {
          units: 0,
          size: 0,
          list_price: 0,
          psf: 0,
          net_psf: 0,
          net_price: 0,
          buyer_incentives: 0,
        };
        return;
      } else {
        availability.size = availability.size / unitsWithListPrice.length;
        availability.list_price = availability.list_price / availability.units;
        availability.buyer_incentives =
          availability.buyer_incentives / availability.units;
        availability.psf = vm.isMarketStrata
          ? Math.round(availability.list_price / availability.size)
          : Number(availability.list_price / availability.size).toFixed(2);
        availability.net_price =
          availability.list_price - availability.buyer_incentives;
        availability.net_psf = vm.isMarketStrata
          ? Math.round(availability.net_price / availability.size)
          : Number(availability.net_price / availability.size).toFixed(2);
      }
      vm.currentAvailability = availability;
      return availability;
    },
    formatData(value, key, item) {
      let res = null;

      if (["-", "", 0, "0", "$0", null, undefined, NaN].includes(value)) {
        return "-";
      }
      switch (key) {
        case "mls_sold_price":
          if (!this.isMarketStrata) res = `$${Number(value).toFixed(2)}`;
          else res = `$${Math.round(value)}`;
          break;
        default:
          if (["", 0, "0", "$0", null, undefined].includes(value)) {
            return "-";
          }
          if (!this.isMarketStrata) res = `$${Number(value).toFixed(2)}`;
          else res = `$${Math.round(value)}`;
          break;
      }

      return res;
    },
    async exportUnitBreakDownFloorPlans() {
      const vm = this;
      vm.$bvToast.toast(
        `Download is in progress. Please wait for a moment while we prepare everything for you.`,
        {
          title: "Downloading...",
          variant: "info",
          autoHideDelay: 5000,
        }
      );
      const pdfDoc = await PDFDocument.create();
      let floorPlanData = [];

      let uniqueFloorplans = vm.mlsTotalSort.map((item) => {
        return {
          floorplans: item.floor_plan.filter(
            (obj, index, self) =>
              index === self.findIndex((o) => o.plan_name === obj.plan_name)
          ),
        };
      });
      floorPlanData = uniqueFloorplans
        .map((fp) => fp.floorplans)
        .flat()
        .sort((a, b) => a.plan_name.localeCompare(b.plan_name));

      for (const item of floorPlanData) {
        const url = item.link;
        try {
          const existingPdfBytes = await fetch(url).then((res) =>
            res.arrayBuffer()
          );

          const donorPdfDoc = await PDFDocument.load(existingPdfBytes);

          const copiedPages = await pdfDoc.copyPages(
            donorPdfDoc,
            donorPdfDoc.getPageIndices()
          );
          copiedPages.forEach((page) => pdfDoc.addPage(page));
        } catch (error) {
          console.error(
            `Failed to load or add floor plan from URL: ${url}`,
            error
          );
        }
      }

      const pdfBytes = await pdfDoc.save().then((pdfBytes) => {
        vm.$bvToast.toast(`You can now view the downloaded file`, {
          title: "Success!",
          variant: "success",
          autoHideDelay: 5000,
        });
        return pdfBytes;
      });

      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(
        blobUrl,
        "_blank",
        "toolbar=no,status=no,menubar=no,scrollbars=yes,resizable=yes,modal=yes,top=100,left=500,width=1000,height=800"
      );
    },
    exportFloorPlans() {
      const vm = this;

      const doc = new jsPDF();
      vm.$bvToast.toast(
        `Download is in progress. Please wait for a moment while we prepare everything for you.`,
        {
          title: "Downloading...",
          variant: "info",
          autoHideDelay: 5000,
        }
      );

      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;
      var imagePromises = null;
      imagePromises = vm.unitPreviewSummary.map((item, index) => {
        let fp_specs = item.type.fp_specs != "None" ? item.type.fp_specs : "";
        let beds = item.type.beds != "s" ? item.type.beds : "Studio";
        let previewTextObject = [
          { label: "Plan Name", key: item.mls_plan_name },
        ];

        doc.setFont("helvetica", "normal");
        let previewY = 25;

        if (item.mls_floor_plan_feature.length <= 0) return;

        return vm
          .getImageRatio(item.mls_floor_plan_feature.preview)
          .then((res) => {
            doc.addPage();

            previewTextObject.forEach((x) => {
              doc.setFontSize(10);
              doc.setFont("Helvetica", "normal");
              doc.text(x.label, 15, previewY);
              doc.text(x.key ? x.key : "-", 35, previewY);
              previewY += 4.5;
            });
            doc.addImage(
              res.image,
              centerX - res.image.width / 2,
              centerY - res.image.height / 2,
              res.image.width,
              res.image.height
            );
          });
      });

      Promise.all(imagePromises).then((res) => {
        vm.$bvToast.toast(`You can now view the downloaded file`, {
          title: "Success!",
          variant: "success",
          autoHideDelay: 5000,
        });
        doc.deletePage(1);
        window.open(
          doc.output("bloburl"),
          "_blank",
          "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,modal=yes,top=100,left=500,width=1000,height=800"
        );
      });

    },
    getLastUpdated(data) {
      let listDate = new Date(data.mls_price_date);
      let soldDate = new Date(data.mls_sold_date);

      if (typeof listDate == "object" && soldDate == "Invalid Date")
        return data.mls_price_date;

      if (typeof soldDate == "object" && listDate == "Invalid Date")
        return data.mls_sold_date;

      if ([listDate, soldDate].every((date) => date != "Invalid Date")) {
        if (listDate > soldDate) return data.mls_price_date;

        return data.mls_sold_date;
      }

      return "-";
    },
    flipArrow() {
      if (this.accordion_arrow == "fas chevron-down")
        this.accordion_arrow = "fas chevron-up";
      else this.accordion_arrow = "fas chevron-down";
    },
    setListingData(row, header) {
      const vm = this;
      const res = row.map((item, index) => {
        let clonedRow = { ...item };
        return header.map((header) => {
          if (["mls_beds"].includes(header.key)) {
            let bed = "";
            let fpSpecs = "";
            bed = `${clonedRow[header.key]}-bed`;

            if (!["None", ""].includes(clonedRow["fp_specs"]))
              fpSpecs = `${clonedRow["fp_specs"]}`;

            if (clonedRow[header.key] == "s") bed = "Studio";

            return (clonedRow[header.key] = fpSpecs
              ? bed + " / " + fpSpecs
              : bed);
          }

          if (
            [
              "buyer_incentives",
              "mls_list_price",
              "net_psf",
              "custom_net_psf",
              "list_price_net",
              "net_price",
              "custom_mls_net_rent",
            ].includes(header.key)
          ) {
            let formatPrice = vm.roundToWholeNumber(clonedRow[header.key]);

            return (clonedRow[header.key] = formatPrice);
          }

          if (["mls_psf", "custom_mls_net_psf", "custom_sold_psf"].includes(header.key)) {
            if (
              this.project.status &&
              [
                "now leasing",
                "now leasing 2",
                "leased out",
                "leased out 2",
              ].includes(this.project.status.toLowerCase())
            ) {
              let formatPrice = Number(clonedRow[header.key]).toFixed(2);
              return clonedRow[header.key] &&
                !["NaN", "0.00", 0, null, ""].includes(formatPrice)
                ? `$${formatPrice}`
                : "-";
            } else {
              let formatPrice = Math.round(
                Number(clonedRow[header.key])
              ).toLocaleString();

              return clonedRow[header.key] && formatPrice != "NaN"
                ? `$${formatPrice}`
                : "-";
            }
          }
          if (header.key == "custom_price_change") {
            return clonedRow[header.key].diffPercentage != 0
              ? clonedRow[header.key]
              : "-";
          }
          return clonedRow[header.key] ? clonedRow[header.key] : "-";
        });
      });

      return res;
    },
    setUnitPreviewSummaryHeaderFields() {
      if (
        ["now leasing", "leased out"].includes(
          this.project.status.toLowerCase()
        )
      ) {
        this.unitPreviewSummaryHeader = [
          { label: "", key: "checkbox", thClass: "w-small" },
          {
            key: "mls_plan_name",
            label: "Plan Name",
            tdClass: "border-right-0",
            sortable: true,
          },
          { key: "type", label: "Type", sortable: true },
          {
            key: "baths",
            label: "Baths",
            formatter: (value, row, key) => {
              return `${Math.round(Number(key.baths / key.units))}`;
            },
            sortable: true,
          },
          { key: "avg_size", label: "Avg Size", sortable: true },
          { key: "units", label: "Total Units", sortable: true },
          { key: "units_percentage", label: "% of Units", sortable: true },
          { key: "confirmed_sold", label: "Conf. Leased", sortable: true },
          { key: "sold_percentage", label: "Leased %", sortable: true },
          { key: "available_pricing", label: "Avail. Pricing", sortable: true },
          { key: "average_net_price", label: "Net Price", sortable: true },
          { key: "average_net_psf", label: "Net $PSF", sortable: true },
          { key: "view_unit_mix", label: "" },
        ];
      } else {
        this.unitPreviewSummaryHeader = [
          { label: "", key: "checkbox", thClass: "w-small" },
          {
            key: "mls_plan_name",
            label: "Plan Name",
            tdClass: "border-right-0",
            sortable: true,
          },
          { key: "type", label: "Type", sortable: true },
          {
            key: "baths",
            label: "Baths",
            formatter: (value, row, key) => {
              return `${Math.round(Number(key.baths / key.units))}`;
            },
            sortable: true,
          },
          { key: "avg_size", label: "Avg Size", sortable: true },
          { key: "units", label: "Total Units", sortable: true },
          {
            key: "units_percentage",
            label: "% of Units",
            formatter: (value, row, key) => {
              return `${Math.round(key.units_percentage)}`;
            },
            sortable: true,
          },
          { key: "confirmed_sold", label: "Conf. Sold", sortable: true },
          { key: "sold_percentage", label: "Sold %", sortable: true },
          { key: "available_pricing", label: "Avail. Pricing", sortable: true },
          { key: "average_net_price", label: "Net Price", sortable: true },
          { key: "average_net_psf", label: "Net $PSF", sortable: true },
          { key: "view_unit_mix", label: "" },
        ];
      }
    },
    getMlsHistory(data, type) {
      const openTab = this.openTab.value;
      let listing_type;
      switch (openTab) {
        case "unitmix":
          listing_type = this.allMlsData.filter(
            (item) => item.cid == data[0].cid
          );
          return listing_type > 0 ? data.map((item, index) => {
            return {
              ...item,
              custom_listing_type: listing_type[0].custom_listing_type,
              rowIndex: index,
            };
          }) : []

        case "unitmixrental":
          return this.project.mls_rental_data[data.cid] || [];
      }

      // return listing_type.length > 0
      //   ? data.map((item, index) => {
      //       return {
      //         ...item,
      //         custom_listing_type: listing_type[0].custom_listing_type,
      //         rowIndex: index,
      //       };
      //     })
      //   : [];
    },
    getUnitTotalNetPsf(data) {
      let totalNetPsf = 0;

      if (data.attr_history.length <= 0) return 0;

      const entries = Object.entries(data.attr_history);
      const lastEntry = entries[entries.length - 1];
      totalNetPsf = lastEntry[1].total_net_psf;

      return totalNetPsf;
    },
    getUnitNetPrice(data) {
      let totalNetPrice = 0;
      let isLeasing = data.status.toLowerCase() == "now leasing";
      totalNetPrice = isLeasing
        ? Math.round(
          Number(data.unit_component.avg_size) * this.getUnitTotalNetPsf(data)
        )
        : Number(data.unit_component.avg_size) * this.getUnitTotalNetPsf(data);

      return totalNetPrice;
    },
    toggleFavorite(item) {
      item.favorite = !item.favorite;
    },
    setListingType(row, project) {
      let res = "";
      let priceDate = new Date(row.mls_price_date);
      let soldDate = new Date(row.mls_sold_date);
      let constructionCompletionDate = new Date(project.occupancy_date);
      let soldOutDate = new Date(project.sold_out_date);
      let mlsObject = project.mls_data[row.cid];
      let hasSoldStatusBeforeEntry = mlsObject.some(
        (val, index) =>
          val["mls_status"] == "Sold" && index < mlsObject.length - 1
      );
      project.mls_data[row.cid].forEach(
        (item) => (item.has_sold = hasSoldStatusBeforeEntry)
      );
      res = "Presale";
      if (hasSoldStatusBeforeEntry) {
        if (
          [priceDate, soldDate].some(
            (date) => date < constructionCompletionDate
          )
        )
          res = "Assignment";

        if (
          [priceDate, soldDate].some(
            (date) => date > constructionCompletionDate
          )
        )
          res = "Resale";
      } else {
        if (
          [priceDate, soldDate].some(
            (date) => date > soldOutDate && date < constructionCompletionDate
          )
        )
          res = "Assignment";

        if (
          [priceDate, soldDate].some(
            (date) => date > soldOutDate && date > constructionCompletionDate
          )
        )
          res = "Resale";

      }

      if (
        ["now leasing", "leased out"].includes(project.status.toLowerCase())
      ) {
        switch (res) {
          case "Presale":
            res = "New Lease";
            break;

          case "Resale":
            res = "Re-Lease";
            break;
        }
      }

      return res;
    },
    percentageChange(oldValue, newValue) {
      let result = {
        diffPercentage: "",
        color: "",
        icon: "",
      };

      if (!oldValue && newValue) result.diffPercentage = 100;
      else
        result.diffPercentage = Number(
          ((newValue - oldValue) / oldValue) * 100
        ).toFixed(2);

      if (Number(result.diffPercentage) > 0) {
        result.color = "green";
        result.icon = "fa-long-arrow-alt-up";
      } else if (Number(result.diffPercentage) < 0) {
        result.color = "red";
        result.icon = "fa-long-arrow-alt-down";
      } else {
        result.color = "black";
        result.icon = "minus";
      }

      return result;
    },
    setIncentiveData(incentive) {
      const vm = this;
      let inc = incentive;
      const dateObj = new Date(inc.date);
      // Format it as YYYY-MM-DD
      const formattedDate = dateObj.toISOString().split("T")[0];
      inc.date = formattedDate;
      vm.incentiveDataToBeUpdated = inc;
    },
    popHistory(data) {
      this.mlsData = [];
      this.mlsData = this.project.mls_rental_data[data.cid].map(item => {
        return {
          ...item,
          mls_floor_plan_feature: data.mls_floor_plan_feature,
          ...data
        }
      })
      this.$bvModal.show('rental-mls-popup');
    },
    tabularRowHistory(data) {
      this.mlsData = this.project.mls_data[data.cid].map((item, index) => {
        return {
          ...item,
          rowIndex: index
        }
      })
      this.cidSelected = data.cid;
      this.$bvModal.show('tabular-history-modal');
    },
    showUnitPreview(tableData) {
      const vm = this;
      let mergedData = tableData;
      let grouped = mergedData.reduce(
        (
          acc,
          {
            mls_sold_price,
            mls_plan_name,
            net_psf,
            mls_status,
            mls_unit_size,
            fp_specs,
            mls_beds,
            mls_baths,
            cid,
            mls_floor_plan_feature,
            mls_list_price,
            net_price,
            buyer_incentives,
          }
        ) => {
          if (!acc[mls_plan_name]) {
            acc[mls_plan_name] = {
              mls_plan_name,
              cid: "",
              mls_sold_price: 0,
              net_price: 0,
              net_psf: 0,
              units: 0,
              available_pricing: 0,
              confirmed_sold: 0,
              total_size: 0,
              avg_size: 0,
              type: {},
              baths: 0,
              units_percentage: 0,
              mls_floor_plan_feature: {},
              buyer_incentives: 0,
              mls_list_price: 0,
              net_psf: 0,
            };
          }

          if (mls_status !== "" && mls_status.toLowerCase() == "sold") {
            acc[mls_plan_name].confirmed_sold += 1;
          }
          acc[mls_plan_name].cid = cid;
          acc[mls_plan_name].units += 1;

          acc[mls_plan_name].total_size += Number(mls_unit_size);

          acc[mls_plan_name].avg_size = Math.round(
            Number(acc[mls_plan_name].total_size / acc[mls_plan_name].units)
          );

          acc[mls_plan_name].baths = Number(mls_baths);
          acc[mls_plan_name].type = {
            mls_beds: mls_beds,
            fp_specs: fp_specs,
          };
          acc[mls_plan_name].mls_floor_plan_feature = mls_floor_plan_feature;
          acc[mls_plan_name].units_percentage =
            tableData.length > 0
              ? Number(
                (acc[mls_plan_name].units / mergedData.length) * 100
              ).toFixed(2)
              : "-";
          acc[mls_plan_name].available_pricing += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(mls_list_price))
            ? 1
            : 0;
          acc[mls_plan_name].net_price += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(net_price))
            ? Number(net_price)
            : 0;
          acc[mls_plan_name].net_psf += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(net_psf))
            ? Number(net_psf)
            : 0;
          acc[mls_plan_name].mls_list_price += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(mls_list_price))
            ? Number(mls_list_price)
            : 0;
          acc[mls_plan_name].buyer_incentives += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(buyer_incentives))
            ? Number(buyer_incentives)
            : 0;
          acc[mls_plan_name].mls_sold_price += ![
            "-",
            "",
            0,
            "0",
            "$0",
            null,
            undefined,
            NaN,
          ].includes(Number(mls_sold_price))
            ? Number(mls_sold_price)
            : 0;
          return acc;
        },
        {}
      );
      this.unitPreviewSummary = Object.values(grouped).map((item) => {
        let net_price =
          (item.mls_list_price - item.buyer_incentives) /
          item.available_pricing;
        return {
          ...item,
          confirmed_sold: item.confirmed_sold > 0 ? item.confirmed_sold : "-",
          sold_percentage:
            item.confirmed_sold > 0
              ? `${Math.round(
                Number((item.confirmed_sold / item.units) * 100)
              )}`
              : "-",
          units_percentage: Math.round(item.units_percentage),
          rowSelected: false,
          average_net_price:
            item.mls_list_price > 0 ? Math.round(net_price) : "-",
          average_net_psf:
            item.net_psf > 0
              ? vm.isMarketStrata
                ? Math.round(net_price / item.avg_size)
                : Number(net_price / item.avg_size).toFixed(2)
              : "-",
          net_sold_price:
            item.mls_sold_price > 0 ? Math.round(item.mls_sold_price) : "-",
        };
      });
      this.$refs["summary-table-modal"].show();
    },
    checkMove(event) {
      let res = ["checkbox", "delete"].includes(
        event.draggedContext.element.key
      );

      if (res) return false;
      else return true;
    },
    getAverageUnits(mlsData, unitTotal) {
      let totalUnits = 0;
      mlsData.forEach((x) => (totalUnits += x.num));
      return Math.round((Number(unitTotal) / Number(totalUnits)) * 100);
    },
    loadChart() {
      const vm = this;
      this.isLoadedChart = true;
      this.$nextTick(function () {
        const ctx = this.$refs.myChart;
        new ChartJS(ctx, {
          type: "bar",
          data: {
            labels: vm.chartDataSale.labels,
            datasets: [
              {
                label: vm.chartDataSale.datasets[0].label,
                data: vm.chartDataSale.datasets[0].data,
                borderWidth: 1,
                backgroundColor: "#495F74",
              },
            ],
          },
          options: {
            plugins: {
              tooltip: {
                enabled: false,
              },
              // Enable datalabels and customize its appearance
              datalabels: {
                anchor: "center", // Position of the label (e.g., 'end', 'center')
                align: "center", // Alignment of the label (e.g., 'top', 'center')
                formatter: (value) => `${value}`, // Custom formatter to display the value
                color: "#fff", // Text color for the labels
                font: {
                  weight: "bold",
                  size: "20px",
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
              x: {
                beginAtZero: true,
              },
            },
          },
        });
      });
    },
    formatPsf(mlsPrice, unitSize) {
      if (Number(mlsPrice) > 0 && Number(unitSize) > 0)
        return "$" + Number(mlsPrice / unitSize).toFixed(2);

      return "-";
    },
    async getConfirmedSold() {
      try {
        let res = await axios.get(
          BACKEND_URL + "api/get_utc_sold_count?uid=" + this.$route.query.uid
        );

        if (res) this.confirmedSold = res.data.count;
      } catch (error) {
        console.log(error);
      }
    },
    async updateSalesStartDate() {
      const date = Math.floor(this.formatSalesStartDate.getTime() / 1000);
      this.editSalesStartDate = true;
      try {
        let res = await axios.post(
          BACKEND_URL + "api/update_utc_sales_start_date",
          JSON.stringify({
            date: date,
            uid: this.$route.query.uid,
          })
        );
        if (res) {
        }
      } catch (error) {
        throw error;
      }
    },
    showMessageBox(message, status) {
      this.boxTwo = "";
      this.$bvToast.toast(message, {
        variant: "info",
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
    cancelEntry() {
      this.$bvModal.show("modal-incentives");
    },
    async reloadData() {
      var queryString = "";
      const vm = this;
      if (typeof this.collection_ids != "object") {
        queryString += "&fid[]=" + this.collection_ids;
      } else {
        this.collection_ids.forEach((element) => {
          queryString += "&fid[]=" + element;
        });
      }

      if (this.$route.query["permit"]) {
        this.openTab.value = "permits";
      }
      if (this.$route.query.tab == "unit") {
        this.openTab.value = "unitmix";
      }

      let result = await axios.get(
        BACKEND_URL +
        "api/get_utc?pid=" +
        this.project_id +
        queryString +
        "&sid=" +
        this.$route.query.sid +
        "&uid=" +
        this.$route.query.uid
      );

      if (result.status == 200) {
        let mapped = new Object(result.data);

        for (const key in mapped) {
          if (
            mapped.hasOwnProperty(key) &&
            [
              "mls_last_date_active",
              "mls_last_date_sold",
              "mls_last_date_other",
            ].includes(key)
          ) {
            var value = result.data[key];
            value.forEach((mlsRow) => {
              mlsRow.rowSelected = false;
            });
          }
        }

        vm.project = mapped;

        vm.landInfo = result.data.ltsa_info;
        Object.keys(vm.landInfo).forEach((key) => {
          vm.selectedDateMap[key] = {
            selectedDate: Object.keys(vm.landInfo[key].reg)[0],
          };
        });
        vm.floorPlanPick = result.data.first_floor_plan_key;

        if (vm.project.pic_list) {
          vm.project.pic_list.forEach((element) => {
            vm.image_lists.push(element.url);
          });
        }
        if (vm.project.consultant) {
          vm.project.consultant.forEach((element) => {
            if (element.type == "Developer") {
              vm.developer = element.name;
            }
          });
        }
        this.$nextTick(function () {
          // this.$emit('height', this.$el.clientHeight)
          if (typeof vm.project["geo_info"] != "undefined") {
            this.singleMap(
              vm.project["geo_info"]["lat"],
              vm.project["geo_info"]["lng"]
            );
          }
          // this.singleMapSecond(vm.project['geo_info']['lat'], vm.project['geo_info']['lng']);
          // setTimeout(this.$refs.carousel.computeCarouselWidth, 2000)
        });
      }

      return result;
    },
    async addEntry() {
      const vm = this;
      let data = vm.incentivesData;
      const entryDate = new Date(data.date + "T00:00:00Z");
      const timestamp = Math.floor(entryDate.getTime() / 1000).toString();

      data.uid = vm.$route.query.uid;

      let formData = new FormData();
      formData.append("uid", data.uid);
      formData.append("date", timestamp);
      formData.append("buyer_incentives", data.buyer_incentives);
      formData.append("realtor_incentives", data.realtor_incentives);
      formData.append("assignment_fee", data.assignment_fee);
      formData.append("deposit", data.deposit);
      formData.append("realtor_commission", data.realtor_commission);
      formData.append("backupfile", data.backup_file);

      let result = await axios.post(
        BACKEND_URL + "api/create_date_attribute_utc",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      vm.showMessageBox(result.data.message, result.data.status);

      let loadData = await vm.reloadData();

      if (loadData) {
        vm.$bvModal.show("modal-incentives");
      }
    },
    async deleteIncentive(did) {
      var vm = this;
      if (confirm("Please confirm to delete?")) {
        let result = await axios.post(
          BACKEND_URL + "api/delete_date_attribute_utc",
          JSON.stringify({
            did: did,
          })
        );

        vm.showMessageBox(result.data.message, result.data.status);

        let loadData = await vm.reloadData();

        if (loadData) {
          vm.$bvModal.show("modal-incentives");
        }
      }
    },
    async updateIncentive(incentive) {
      let vm = this;
      let data = incentive;
      // const [day, month, year] = data.date.split('-');
      // const fullYear = `20${year}`; // Assuming '24' refers to 2024
      // const parsedDate = new Date(`${month} ${day}, ${fullYear} 00:00:00 GMT`);

      // Convert to Vancouver time
      const options = { timeZone: "America/Vancouver", timeZoneName: "short" };
      const vancouverDate = new Date(
        data.date.toLocaleString("en-US", options)
      );

      // Convert Vancouver time to Unix timestamp (in seconds)
      const unixTimestamp = Math.floor(vancouverDate.getTime() / 1000);

      let formData = new FormData();
      formData.append("did", data.did);
      formData.append("date", unixTimestamp);
      formData.append("buyer_incentives", data.buyer_incentives);
      formData.append("realtor_incentives", data.realtor_incentives);
      formData.append("assignment_fee", data.assignment_fee);
      formData.append("deposit", data.deposit);
      formData.append("realtor_commission", data.realtor_commission);
      formData.append("backupfile", data.backupfile);
      let result = await axios.post(
        BACKEND_URL + "api/edit_date_attribute_utc",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      vm.showMessageBox(result.data.message, result.data.status);

      let loadData = await vm.reloadData();

      if (loadData) {
        vm.$bvModal.show("modal-incentives");
      }
    },
    setHistoryTableHeaderFields() {
      const vm = this;
      switch (vm.current_user.role) {
        case "developer":
          vm.history_header_fields = [
            { label: "Date", key: "date" },
            { label: "Total Units", key: "total" },
            { label: "Rlsd Units", key: "rlsd_units" },
            { label: "Total Sold", key: "sold_total" },
            { label: "Avail", key: "available" },
            { label: "Sold Update", key: "sold_update" },
          ];
          break;
        case "developerbc":
          vm.history_header_fields = [
            { label: "Date", key: "date" },
            { label: "Total Units", key: "total" },
            { label: "Rlsd Units", key: "rlsd_units" },
            { label: "Total Sold", key: "sold_total" },
            { label: "Avail", key: "available" },
            { label: "Sold Update", key: "sold_update" },
          ];
          break;
        //admin role
        case "admin":
          vm.history_header_fields = [
            { label: "Date", key: "date" },
            { label: "Total Units", key: "total" },
            { label: "Rlsd Units", key: "rlsd_units" },
            { label: "Total Sold", key: "sold_total" },
            { label: "Avail", key: "available" },
            { label: "Total Avg Size", key: "avg_size" },
            { label: "Total Avg Price", key: "avg_price" },
            { label: "Total $PSF", key: "avg_psf" },
            { label: "Net Price", key: "current_total_net_price" },
            { label: "Net $PSF", key: "total_net_psf" },
            { label: "Files", key: "files" },
          ];

          if (!["editor", "admin"].includes(this.current_user.role)) {
            let toInsert = [
              { label: "Buyer Incentives", key: "buyer_incentives" },
              { label: "Realtor Incentives", key: "realtor_incentives" },
              { label: "Assignment Fee", key: "assignment_fee" },
              { label: "Deposit", key: "deposit" },
              { label: "Realtor commission", key: "realtor_commission" },
            ];

            toInsert.forEach((item, index) => {
              vm.history_header_fields.splice(10 + index, 0, item);
            });
          }
          break;
      }
    },
    setRpdHeaderFields() {
      const statusKey = this.project.status.toLowerCase();
      const roleKey = this.current_user.role;

      const allConfigs = this.openTab.value === 'unitmixrental' ? this.getUnitMixRentalConfigs() : this.getUnitMixConfigs();
      const statusGroup = allConfigs[statusKey] || allConfigs['default'];

      const config = statusGroup[roleKey] || statusGroup['default'];

      this.rpdTableList1 = config.common;

      this.field_selected = JSON.parse(JSON.stringify(config.common));

      this.rpdTableList2 = config.custom;
      this.custom_field = config.custom;
    },
    getUnitMixConfigs() {
      const createConfig = (common, custom) => ({ common, custom });
      return {
        "now leasing": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Conf. Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "net_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "Leased Price", key: "mls_sold_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", formatter: this.setDecimal, sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "now leasing 2": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Conf. Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Leased Price", key: "mls_sold_price", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "net_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", formatter: this.setDecimal, sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "leased out": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "Leased Price", key: "mls_sold_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Net Rent", key: "list_price_net", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "leased out 2": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Leased Price", key: "mls_sold_price" },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Leased Price", key: "mls_sold_price" },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Leased Price", key: "mls_sold_price", formatter: this.formatData, sortable: true },
              { label: "Net Sold $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "sold out 2": {
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "custom_field_mls_beds_value", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Net List Price", key: "list_price_net", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Net List Price", key: "list_price_net", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        },
        "sold out": {
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Net List Price", key: "list_price_net", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net List Price", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        },
        default: {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Buyer Incentives", key: "buyer_incentives", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_net_psf", sortable: true },
              { label: "Net Price Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net Price Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Sold Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        }
      };
    },
    getUnitMixRentalConfigs() {
      const createConfig = (common, custom) => ({ common, custom });
      return {
        "now leasing": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Conf. Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", formatter: this.setDecimal, sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "leased out": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "list_price_net", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Net Leased Price", key: "mls_sold_price", sortable: true },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "leased out 2": {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Leased Price", key: "mls_sold_price" },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Realtor Incentives", key: "realtor_incentives", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Leased Price", key: "mls_sold_price" },
              { label: "Net Leased $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Leased $PSF", key: "calc_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Rent", key: "custom_mls_net_rent", sortable: true },
              { label: "Net Rent Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_mls_net_psf", formatter: this.setDecimal, sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Leased Date", key: "mls_sold_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Leased Price", key: "mls_sold_price", formatter: this.formatData, sortable: true },
              { label: "Net Sold $PSF", key: "net_sold_psf", sortable: true, formatter: this.roundToWholeNumber },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
            ]
          )
        },
        "sold out 2": {
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "custom_field_mls_beds_value", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Net List Price", key: "list_price_net", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        },
        "sold out": {
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net List Price", sortable: true },
              { label: "Net List $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        },
        default: {
          realtor: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          admin: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "align-content-center" },
              { label: "Update MLS", key: "updatemls", thClass: "w-small" },
              { label: "Favorite", key: "favorite", thClass: "align-content-center" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan Name", key: "mls_plan_name", sortable: true },
              { label: "Beds", key: "mls_beds", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Size", key: "mls_unit_size", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true },
              { label: "Balcony Area", key: "balcony_area", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true, tdClass: "_no-wrap" },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Net Price Change", key: "custom_price_change", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true, tdClass: "_no-wrap" },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
              { label: "Price Gap", key: "custom_price_gap", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "PID", key: "mls_pid", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          ),
          default: createConfig(
            [
              { label: "Selected", key: "checkbox", thClass: "w-small" },
              { label: "Unit #", key: "mls_address", sortable: true },
              { label: "Plan", key: "mls_plan_name", sortable: true },
              { label: "Type", key: "mls_beds", sortable: true },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Unit Size", key: "mls_unit_size", sortable: true },
              { label: "List Price", key: "mls_list_price", sortable: true },
              { label: "$PSF", key: "custom_sold_psf", sortable: true },
              { label: "Incentives", key: "buyer_incentives", sortable: true },
              { label: "Net Price", key: "list_price_net", sortable: true },
              { label: "Net Price Change", key: "custom_price_change", sortable: true },
              { label: "Net $PSF", key: "custom_net_psf", sortable: true },
              { label: "Price Date", key: "mls_price_date", sortable: true },
              { label: "Listing Type", key: "custom_listing_type", sortable: true },
              { label: "Status", key: "custom_status", sortable: true },
              { label: "Sold Date", key: "mls_sold_date", sortable: true },
            ],
            [
              { label: "Leased Price Confidence", key: "custom_price_confidence", sortable: true },
              { label: "Sold Price", key: "mls_sold_price", sortable: true },
              { label: "Balcony", key: "balcony", sortable: true, thClass: "_w-15-rem" },
              { label: "Balcony Area", key: "balcony_area", sortable: true, thClass: "_w-15-rem" },
              { label: "Baths", key: "mls_baths", sortable: true },
              { label: "Parking", key: "stalls", sortable: true },
              { label: "Stalls", key: "mls_parking", sortable: true },
              { label: "List Date", key: "mls_list_date", sortable: true },
              { label: "View", key: "orientation", sortable: true },
              { label: "Levels", key: "levels", sortable: true },
              { label: "FP Specs", key: "fp_specs", sortable: true },
              { label: "Price Status", key: "price_back_up", sortable: true },
              { label: "Parking Cost", key: "custom_parking_stall_cost", sortable: true },
              { label: "Strata Fee", key: "custom_strata_fee", sortable: true },
              { label: "Storage Cost", key: "custom_storage_locker_cost", sortable: true, formatter: this.formatStorageCost },
            ]
          )
        }
      };
    },
    formatTypeText(value) {
      switch (value) {
        case "s":
          return "Studio";
          break;

        default:
          return value;
          break;
      }
    },
    showBackupTextModal({ backupText }) {
      this.backupModalText = backupText;
      this.$root.$emit("bv::show::modal", "backupTextModal");
    },
    selectAllRows({ selectAll }) {
      this.allMlsData = this.allMlsData.map((data) => {
        return {
          ...data,
          rowSelected: selectAll,
        };
      });
    },
    refreshResults(listingType) {
      switch (listingType) {
        case "active":
          if (
            this.project.mls_last_date_active.filter(
              (row) => row.rowSelected === true
            ).length > 0
          )
            this.project.mls_last_date_active =
              this.project.mls_last_date_active.filter(
                (row) => row.rowSelected === true
              );

          this.totalRows.active = this.project.mls_last_date_active.length;
          break;

        case "sold":
          if (
            this.project.mls_last_date_sold.filter(
              (row) => row.rowSelected === true
            ).length > 0
          )
            this.project.mls_last_date_sold =
              this.project.mls_last_date_sold.filter(
                (row) => row.rowSelected === true
              );
          this.totalRows.sold = this.project.mls_last_date_sold.length;
          break;

        case "other":
          if (
            this.project.mls_last_date_other.filter(
              (row) => row.rowSelected === true
            ).length > 0
          )
            this.project.mls_last_date_other =
              this.project.mls_last_date_other.filter(
                (row) => row.rowSelected === true
              );
          this.totalRows.other = this.project.mls_last_date_other.length;
          break;

        case "all":
          if (
            this.allListingData.filter((row) => row.rowSelected === true)
              .length > 0
          )
            this.allMlsData = this.allMlsData.filter(
              (row) => row.rowSelected === true
            );
          this.totalRows.all = this.allListingData.length;
          break;

        default:
          break;
      }
    },
    roundToWholeNumber(value) {
      console.log(value)
      return Number(value) && !["", "-", 0, null, "0"].includes(value)
        ? "$" + Math.round(value).toLocaleString()
        : "-";
    },
    setDecimal(value) {
      return this.isRealValue(value) ? value.toLocaleString() : "-";
    },
    formatToUnixTimetamp(date) {
      return Math.floor(new Date(date).getTime() / 1000);
    },
    mlsEntryUpload() {
      let formData = new FormData();

      var urlEndpoint = "";
      if (['elly.yschung@gmail.com', 'angelicastefania103@gmail.com', 'trevor.sidhu@hotmail.com', 'vikrandhawa@hotmail.com', 'pritikag21@gmail.com', 'mark.wang+urban@devradius.com', 'erloucabilan94@gmail.com'].includes(this.current_user.mail)) {
        formData.append("cid", this.cidSelected);
        formData.append("field_custom_mls_list_price", this.MLSuploadForm.listPrice);
        formData.append("field_custom_mls_buyer_incentive", this.MLSuploadForm.buyerIncentives);
        formData.append("field_custom_mls_sold_price", this.MLSuploadForm.soldPrice);

        if (this.MLSuploadForm.soldDate)
          formData.append("field_custom_mls_sold_date", this.formatToUnixTimetamp(this.MLSuploadForm.soldDate));

        if (this.MLSuploadForm.listPriceDate)
          formData.append("field_custom_mls_price_date", this.formatToUnixTimetamp(this.MLSuploadForm.listPriceDate));

        formData.append("field_custom_mls_status", this.MLSuploadForm.status);
        formData.append("backupfile", this.MLSuploadForm.floorPlan);
        urlEndpoint = 'api/custom_mls/create';
      }
      else {
        formData.append("status", this.MLSuploadForm.status);
        formData.append("listPrice", this.MLSuploadForm.listPrice);
        formData.append("listPriceDate", this.MLSuploadForm.listPriceDate);
        formData.append("files", this.MLSuploadForm.floorPlan);
        formData.append("backupText", this.MLSuploadForm.backupText);
        formData.append("buyerIncentives", this.MLSuploadForm.buyerIncentives);
        formData.append(
          "realtorIncentives",
          this.MLSuploadForm.realtorIncentives
        );
        formData.append("priceBackup", this.MLSuploadForm.priceBackup);
        formData.append("cid", this.cidSelected);
        formData.append("soldDate", this.MLSuploadForm.soldDate);
        formData.append("soldPrice", this.MLSuploadForm.soldPrice);
        formData.append("uid", this.$route.query.uid);
        urlEndpoint = this.openTab.value === 'unitmixrental' ? 'api/presale_mls_rental_creation' : 'api/presale_mls_entry_add_entry';
      }
      if (this.openTab.value === 'unitmixrental') {
        formData.append("newEntry", true);
      }
      try {
        $.ajax({
          type: "POST",
          url: BACKEND_URL + urlEndpoint,
          data: formData,
          processData: false,
          contentType: false,
        }).done((response) => {
          this.$bvToast.toast(`MLS Entry Uploaded Successfully`, {
            title: "Success!",
            autoHideDelay: 5000,
            variant: "success",
          });
          this.$bvModal.hide('mls-entry-new');
          this.$bvModal.hide('tabular-history-modal');
          this.reloadData();

        });
      } catch (error) {
        console.error("Error uploading MLS entry:", error);
        this.$bvToast.toast(
          `An error occurred while uploading the MLS entry. Please try again later.`,
          {
            title: "Error",
            autoHideDelay: 5000,
            variant: "danger",
          }
        );
      }
    },

    setColor(data) {
      let color = "";
      if (data) {
        switch (data.toLowerCase()) {
          case "verified":
            color = "#0b36dc";
            break;

          case "educated estimated":
            color = "#dc3545";
            break;

          case "semi-verified":
            color = "#FF6F16";
            break;

          default:
            color = "#000";
            break;
        }
      }
      return color;
    },
    // logout() {
    //     $.get(BACKEND_URL + 'api/api_logout_user', (data, status) => {
    //         this.$router.push({ path: '/'});
    //         this.$router.go();
    //     });
    // },
    numberWithCommas: function (x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    selectedDate: function (value, propertyName) {
      this.selectedDateMap = Object.assign({}, this.selectedDateMap, {
        [propertyName]: { selectedDate: value },
      });
    },
    classStatus(status) {
      switch (status) {
        case "Now Selling":
          return "utc-now-selling-color";
        case "Now Leasing":
          return "utc-now-leasing-color";
        case "Selling Soon":
          return "utc-selling-soon-color";
        case "In Planning":
          return "utc-in-planning-color";
        case "Sold Out":
        case "Sold Out 2":
          return "utc-sold-out-color";
        case "Leasing Soon":
          return "utc-leasing-soon-color";
        case "Leased Out":
          return "utc-leased-out-color";
      }
    },
    activeSort(column) {
      if (this.activeSortBy == column) {
        this.orderAsc = !this.orderAsc;
      }
      this.activeSortBy = column;
    },
    soldSort(column) {
      if (this.soldSortBy == column) {
        this.orderAsc = !this.orderAsc;
      }
      this.soldSortBy = column;
    },
    otherSort(column) {
      if (this.otherSortBy == column) {
        this.orderAsc = !this.orderAsc;
      }
      this.otherSortBy = column;
    },
    approveMLSEntry(cid, entry, k1, k2) {
      if (this.project.is_admin) {
        // if (true) {
        var vm = this;
        $.ajax({
          type: "POST",
          url: "https://www.realpropertydata.ca/backend/api/presale_mls_approve",
          data: { cid: cid, entry: entry },
        }).done(function (response) {
          if (response.success) {
            vm.project.mls_data[k1][k2].mls_need_approval = 0;
          }
        });
      }
    },
    editMLSEntryNew({ projectId, projectEntry, listingType, rowData }) {
      // if (this.project.is_admin) {
      if (listingType == 'all') {
        let link =
          "mls_entry_edit?cid=" +
          projectId +
          "&entry=" +
          projectEntry +
          "&project=" +
          this.$route.query.project +
          "&fid=" +
          this.$route.query.fid +
          "&uid=" +
          this.$route.query.uid +
          "&sid=" +
          this.$route.query.sid;
        window.open(link, "_blank");
      } else {
        this.editableRentalData = rowData
        this.$refs['editRentalModal'].show()
      }
    },
    editMLSEntry(cid, entry) {
      // if (this.project.is_admin) {
      if (true) {
        let link =
          "mls_entry_edit?cid=" +
          cid +
          "&entry=" +
          entry +
          "&project=" +
          this.$route.query.project +
          "&fid=" +
          this.$route.query.fid +
          "&uid=" +
          this.$route.query.uid +
          "&sid=" +
          this.$route.query.sid;
        window.open(link, "_self");
      }
    },
    unApproveMLSEntry(cid, entry, k1, k2) {
      if (this.project.is_admin) {
        // if (true) {
        var vm = this;
        $.ajax({
          type: "POST",
          url: "https://www.realpropertydata.ca/backend/api/presale_mls_unapprove",
          data: { cid: cid, entry: entry },
        }).done(function (response) {
          if (response.success) {
            vm.project.mls_data[k1][k2].mls_need_approval = 1;
          }
        });
      }
    },
    deleteMlsRentalRow({ rid, rowData }) {
      const vm = this
      if (confirm(`Are you sure you want to delete Unit# ${rowData.mls_address} ?`)) {
        $.ajax({
          type: "POST",
          url: BACKEND_URL + "api/presale_mls_rental_delete",
          data: { rid: rid },
        }).done(function (response) {
          vm.$bvToast.toast(
            `1 Entry Deleted`,
            {
              title: "Success!",
              autoHideDelay: 5000,
              variant: "success",
            }
          );

          setTimeout(() => {
            window.location.reload()
          }, 3000);
        }).fail(function (failResponse) {
          vm.$bvToast.toast(
            `Something went wrong. Try again later or contact administrator.`,
            {
              title: "Fail!",
              autoHideDelay: 5000,
              variant: "danger",
            }
          );
        });
      }
    },
    deleteMLSEntry({ projectId, projectEntry, rowData, listingType }) {
      var vm = this;
      if (this.project.is_admin) {
        if (confirm("Do you really want to delete this MLS Entry?")) {
          if (listingType == 'all') {
            $.ajax({
              type: "POST",
              url: "https://www.realpropertydata.ca/backend/api/presale_mls_entry_delete",
              data: { cid: projectId, entry: projectEntry },
            }).done(function (response) {
              if (response.success) {
                vm.project.mls_data[projectEntry].splice(projectEntry, 1);
                this.$bvToast.toast(
                  `1 Entry Deleted`,
                  {
                    title: "Success!",
                    autoHideDelay: 5000,
                    variant: "success",
                  }
                );
              }
            });
          } else if (listingType == 'rental') {
            $.ajax({
              type: "POST",
              url: BACKEND_URL + "/api/presale_mls_rental_entry_delete",
              data: { rid: rowData.rid, entry: rowData.entry },
            }).done(function (response) {
              if (response.success) {
                this.$bvToast.toast(
                  `1 Entry Deleted`,
                  {
                    title: "Success!",
                    autoHideDelay: 5000,
                    variant: "success",
                  }
                );
              }
            });
          }
        }
      }
    },
    deleteMLS(cid) {
      if (this.project.is_admin) {
        // if (true) {
        if (confirm("Do you really want to delete this MLS Data?")) {
          var vm = this;
          $.ajax({
            type: "POST",
            url: "https://www.realpropertydata.ca/backend/api/presale_mls_delete",
            data: { cid: cid },
          }).done(function (response) {
            if (response.success) {
              this.$bvToast.toast(
                `1 Entry Deleted`,
                {
                  title: "Success!",
                  autoHideDelay: 5000,
                  variant: "success",
                }
              );
            }
          });
        }
      }
    },
    uploadMLSEntry(cid) {
      if (this.project.is_admin) {
        // if (true) {
        let link =
          "mls_entry_update?cid=" +
          cid +
          "&project=" +
          this.$route.query.project +
          "&fid=" +
          this.$route.query.fid +
          "&uid=" +
          this.$route.query.uid +
          "&sid=" +
          this.$route.query.sid;
        window.open(link, "_blank");
      }
    },
    mlsUpload() {
      this.upload_is_loading = true;
      let formData = new FormData();
      appendField(formData, "planName", this.uploadForm.planName);
      let fpArray = [];
      this.uploadForm.fp.forEach((element) => fpArray.push(element.value));
      appendField(formData, "fp", fpArray);
      appendField(formData, "pr", this.uploadForm.pr);
      appendField(formData, "fl", this.uploadForm.fl);
      appendField(formData, "orientation", this.uploadForm.orientation);
      appendField(formData, "unit", this.uploadForm.unit);
      appendField(formData, "address", this.project.short_address);
      appendField(formData, "bed", this.uploadForm.bed);
      appendField(formData, "bath", this.uploadForm.bath);
      appendField(formData, "unitSize", this.uploadForm.unitSize);
      appendField(formData, "listPrice", this.uploadForm.listPrice);
      appendField(formData, "parking", this.uploadForm.parking);
      appendField(formData, "locker", this.uploadForm.locker);
      appendField(formData, "gst", this.uploadForm.gst);
      appendField(formData, "backupfile", this.uploadForm.backupfile);
      appendField(formData, "buyerIncentives", this.uploadForm.buyerIncentives);
      appendField(formData, "realtorIncentives", this.uploadForm.realtorIncentives);
      appendField(formData, "status", this.uploadForm.status);
      appendField(formData, "soldPrice", this.uploadForm.soldPrice);
      appendField(formData, "files", this.uploadForm.floorPlan);
      appendField(formData, "transfer", this.uploadForm.importUnitTransfer);
      appendField(formData, "csv", this.uploadForm.importCSV);
      appendField(formData, "soldDate", this.uploadForm.soldDate);
      appendField(formData, "listDate", this.uploadForm.listDate);
      appendField(formData, "listPriceDate", this.uploadForm.listPriceDate);
      appendField(formData, "uid", this.$route.query.uid);
      appendField(formData, "fid", this.$route.query.fid);
      appendField(formData, "owner", this.$route.query.owner);
      appendField(formData, "purchaser", this.$route.query.purchaser);
      appendField(formData, "pid", this.uploadForm.pid);
      appendField(formData, "assignment", this.uploadForm.assignment);
      appendField(formData, "newEntry", this.uploadForm.newEntry);
      appendField(formData, "originalEntry", this.uploadForm.originalEntry);
      appendField(formData, "balcony", this.uploadForm.balcony);
      appendField(formData, "balconyArea", this.uploadForm.balconyArea);
      appendField(formData, "priceBackup", this.uploadForm.priceBackup);

      var vm = this;
      $.ajax({
        type: "POST",
        url: "https://www.realpropertydata.ca/backend/api/presale_mls_creation",
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(function (response) {
          vm.upload_is_loading = false;
          vm.uploadForm = {
            planName: "",
            fp: [],
            orientation: 11105,
            unit: "",
            bed: "",
            bath: "",
            unitSize: "",
            listPrice: "",
            pr: "",
            locker: "",
            gst: "",
            buyerIncentives: "",
            realtorIncentives: "",
            status: 11482,
            soldDate: null,
            listDate: null,
            listPriceDate: null,
            fl: "",
            files: null,
            owner: "",
            purchaser: "",
            pid: "",
            assignment: 0,
            newEntry: 0,
            originalEntry: 0,
            balconyArea: "",
            balcony: "",
            priceBackup: "",
            soldPrice: 0,
          };
        })
        .always(function () {
          vm.upload_is_loading = false;
        });
    },
    projectTypeIcon(type) {
      if (type.startsWith("Apartment")) {
        return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0061 19.9948C6.88731 19.9948 3.7768 19.9948 0.662134 20C0.230696 20 -0.0219286 19.7104 0.000942779 19.3374C0.0165369 19.0926 0.000942779 18.8467 0.000942779 18.6009C-0.00796501 18.4583 0.0393371 18.3179 0.132667 18.21C0.225996 18.1021 0.35789 18.0351 0.499955 18.0237C0.634065 18.0049 0.667332 17.9497 0.665253 17.8216C0.650871 17.5844 0.654694 17.3465 0.676689 17.11C0.692389 16.985 0.749484 16.869 0.838829 16.7804C0.928174 16.6918 1.0446 16.6358 1.16946 16.6214C1.30978 16.6037 1.45147 16.5995 1.59258 16.6089C1.71838 16.6162 1.7558 16.5735 1.7558 16.4464C1.75164 15.0753 1.75164 13.7043 1.7558 12.3332V2.50876C1.7558 2.35978 1.74229 2.3504 1.58947 2.35144C1.23704 2.35144 0.882531 2.37332 0.530104 2.34206C0.384851 2.33293 0.248988 2.26699 0.151767 2.15846C0.0545469 2.04992 0.00374478 1.90747 0.0102993 1.76176C0.0102993 1.37837 0.0102993 0.996367 0.0102993 0.615752C0.00407119 0.534195 0.0153393 0.452246 0.0433459 0.375416C0.0713525 0.298586 0.115449 0.228655 0.172669 0.170325C0.22989 0.111995 0.298909 0.0666179 0.375087 0.0372445C0.451264 0.00787118 0.532834 -0.00481765 0.614312 3.11468e-05H19.3522C19.7681 3.11468e-05 19.9937 0.222983 19.9968 0.638673C19.9968 0.997062 19.9968 1.35545 19.9968 1.71384C19.9968 2.09619 19.7972 2.31706 19.4198 2.34623C19.079 2.36342 18.7376 2.36342 18.3968 2.34623C18.2357 2.34623 18.2357 2.33998 18.2357 2.4973V16.437C18.2357 16.6037 18.2357 16.6026 18.3999 16.6047C18.5387 16.5998 18.6776 16.604 18.8158 16.6172C18.9588 16.6308 19.0915 16.6976 19.1878 16.8044C19.284 16.9113 19.3368 17.0504 19.3356 17.1944C19.3408 17.4225 19.3356 17.6528 19.3356 17.881C19.3356 17.9643 19.3616 18.0008 19.4468 18.0081C19.5263 18.0112 19.6042 18.0308 19.6757 18.0658C19.7472 18.1007 19.8106 18.1502 19.8619 18.2111C19.9133 18.2719 19.9514 18.3428 19.9739 18.4193C19.9964 18.4957 20.0028 18.576 19.9926 18.655C19.9791 18.8999 19.9926 19.1468 19.9926 19.3926C19.9926 19.7708 19.7712 19.9907 19.3959 19.9907H10.0061V19.9948ZM2.3411 9.68071V16.8443C2.3411 17.1048 2.23714 17.21 1.98036 17.2121C1.78075 17.2121 1.58115 17.2121 1.38154 17.2121C1.29734 17.2121 1.25991 17.2434 1.26095 17.3298C1.26095 17.5174 1.26095 17.7049 1.26095 17.8924C1.26095 17.9789 1.29422 18.0122 1.37946 18.0112C1.58739 18.0112 1.79531 18.0112 2.00323 18.0112C2.03974 18.0139 2.07628 18.0063 2.10865 17.9892C2.14102 17.972 2.1679 17.9461 2.1862 17.9143C2.35166 17.6633 2.56576 17.4482 2.81578 17.2818C3.06581 17.1153 3.34666 17.0009 3.64165 16.9454C3.73472 16.9261 3.82305 16.8886 3.90156 16.835C4.26732 16.5973 4.69671 16.477 5.13245 16.4901C5.69657 16.4988 6.23625 16.7223 6.64197 17.1152C6.66517 17.1436 6.69437 17.1664 6.72745 17.1821C6.76053 17.1978 6.79666 17.2059 6.83325 17.2059C6.86985 17.2059 6.90598 17.1978 6.93906 17.1821C6.97214 17.1664 7.00133 17.1436 7.02454 17.1152C7.38715 16.768 7.85591 16.5534 8.35518 16.5059C8.85446 16.4585 9.35513 16.581 9.77639 16.8537C9.83351 16.895 9.89814 16.9248 9.96664 16.9412C10.2757 16.9899 10.5708 17.1044 10.8321 17.2769C11.0934 17.4494 11.3147 17.676 11.4813 17.9414C11.5055 17.9842 11.5415 18.0192 11.5851 18.0419C11.6286 18.0647 11.6778 18.0743 11.7267 18.0695C12.6987 18.0539 13.6718 18.0695 14.6449 18.0497C15.802 18.0237 16.9455 18.031 18.1016 18.0237C18.2804 18.0237 18.4592 18.031 18.638 18.0122C18.7181 18.0028 18.742 17.9695 18.742 17.8924C18.742 17.7018 18.742 17.509 18.742 17.3184C18.742 17.2361 18.7087 17.2069 18.6307 17.2079C18.4311 17.2079 18.2315 17.2017 18.0319 17.2079C17.7616 17.2079 17.6483 17.1037 17.6483 16.837V6.52293C17.6483 5.17688 17.6483 3.83084 17.6483 2.48479C17.6483 2.41291 17.6597 2.35144 17.5443 2.35144C16.3342 2.35665 15.1252 2.35144 13.9151 2.35144C12.705 2.35144 11.471 2.35144 10.2494 2.35144H2.51784C2.34214 2.35144 2.3411 2.35144 2.3411 2.52334V9.68071ZM9.99159 1.76281H19.1848C19.399 1.76281 19.399 1.76281 19.4 1.54194V0.795989C19.4 0.587623 19.4 0.587623 19.1984 0.587623H0.762976C0.595599 0.587623 0.59456 0.587623 0.59456 0.750148V1.56278C0.59456 1.75239 0.59456 1.75239 0.786887 1.75239L9.99159 1.76281ZM11.3192 19.3926C11.2733 19.3082 11.2518 19.2126 11.2568 19.1166C11.2483 18.7308 11.1057 18.3601 10.8537 18.0683C10.6017 17.7766 10.256 17.5821 9.87619 17.5184C9.74079 17.4992 9.61164 17.4489 9.49881 17.3715C9.19193 17.1585 8.82175 17.0568 8.4494 17.0831C8.07704 17.1095 7.72478 17.2623 7.45078 17.5163C7.34089 17.6215 7.21119 17.7036 7.06925 17.758C6.74801 17.8778 6.48498 17.7757 6.26355 17.5632C5.66889 16.9933 4.73116 16.9173 4.10428 17.4059C4.04539 17.4563 3.97316 17.4885 3.89636 17.4986C3.53551 17.536 3.19677 17.6907 2.93175 17.939C2.66674 18.1872 2.48999 18.5155 2.42843 18.8738C2.4014 19.0332 2.44091 19.2009 2.36397 19.3531C2.34422 19.3926 2.37957 19.4041 2.41076 19.4051C2.44194 19.4062 2.48561 19.4051 2.52303 19.4051H11.0925C11.1686 19.4075 11.2448 19.4005 11.3192 19.3843V19.3926ZM15.7074 19.4156H17.64C18.1795 19.4156 18.7201 19.4156 19.2607 19.4156C19.3647 19.4156 19.4032 19.3833 19.399 19.2791C19.3928 19.1207 19.399 18.9665 19.399 18.804C19.399 18.6165 19.399 18.6144 19.214 18.6165C17.9664 18.6269 16.7127 18.6165 15.462 18.6373C14.2665 18.655 13.0709 18.654 11.8733 18.6592C11.8203 18.6592 11.7901 18.6675 11.8036 18.728C11.8462 18.9144 11.8317 19.1124 11.9668 19.2791C11.9933 19.3219 12.0304 19.3571 12.0745 19.3812C12.1186 19.4053 12.1682 19.4175 12.2184 19.4166C13.3807 19.4062 14.544 19.4072 15.7074 19.4072V19.4156ZM1.09773 19.4156C1.2308 19.4156 1.36387 19.4156 1.4959 19.4156C1.52818 19.4152 1.55992 19.4072 1.58861 19.3924C1.6173 19.3776 1.64215 19.3563 1.6612 19.3301C1.83897 19.1447 1.8213 18.903 1.86912 18.6811C1.88264 18.6165 1.84001 18.6154 1.79427 18.6154C1.43041 18.6154 1.06654 18.6154 0.7006 18.6154C0.62055 18.6154 0.590401 18.6488 0.596639 18.728C0.596639 18.9186 0.596639 19.1103 0.596639 19.301C0.596639 19.3916 0.636144 19.4166 0.717233 19.4145C0.840947 19.4051 0.969858 19.4072 1.09773 19.4072V19.4156Z" fill="black"/><path d="M6.36653 15.6661H3.81013C3.58974 15.6661 3.47226 15.5619 3.4681 15.3723C3.46629 15.3348 3.472 15.2974 3.48492 15.2621C3.49783 15.2269 3.51768 15.1946 3.54327 15.1672C3.56887 15.1398 3.5997 15.1178 3.63394 15.1026C3.66817 15.0874 3.70511 15.0792 3.74256 15.0785C3.87979 15.0785 4.01702 15.0712 4.1584 15.0785C4.26236 15.0848 4.30187 15.0483 4.30083 14.9379C4.29563 14.3795 4.30083 13.821 4.30083 13.2637C4.30083 12.9792 4.42766 12.8469 4.70836 12.8469H7.37183C7.59639 12.8469 7.81991 12.8469 8.04446 12.8469C8.30956 12.8469 8.44991 12.9876 8.45095 13.2564C8.45095 13.8023 8.45095 14.3472 8.45095 14.8931C8.45095 15.0712 8.45095 15.0723 8.62768 15.0733C8.73892 15.0733 8.8512 15.0733 8.96348 15.0733C9.00313 15.0702 9.04301 15.0752 9.08062 15.0882C9.11823 15.1013 9.15275 15.1219 9.18203 15.1489C9.2113 15.1759 9.2347 15.2086 9.25076 15.2451C9.26682 15.2816 9.2752 15.321 9.27536 15.3609C9.27608 15.4007 9.26872 15.4402 9.25372 15.4771C9.23872 15.514 9.2164 15.5474 9.1881 15.5754C9.15981 15.6034 9.12613 15.6253 9.08913 15.6398C9.05212 15.6543 9.01255 15.6611 8.97283 15.6599C8.81481 15.6661 8.66095 15.6599 8.49877 15.6599L6.36653 15.6661ZM6.37277 15.0764C6.82604 15.0764 7.27931 15.0764 7.73258 15.0764C7.8251 15.0764 7.86669 15.0546 7.86565 14.9514C7.86149 14.4888 7.86149 14.0263 7.86565 13.5637C7.86565 13.4595 7.8303 13.4345 7.73466 13.4345C6.82812 13.4345 5.92193 13.4345 5.01608 13.4345C4.91212 13.4345 4.87989 13.4731 4.88093 13.5741C4.88093 14.0284 4.88093 14.4826 4.88093 14.9368C4.88093 15.0494 4.9194 15.0775 5.02544 15.0764C5.47455 15.0744 5.92574 15.0764 6.37277 15.0764Z" fill="black"/><path d="M13.6193 6.21872C12.7599 6.21872 11.8994 6.21872 11.0379 6.21872C10.83 6.21872 10.726 6.10516 10.7343 5.90617C10.7352 5.84311 10.7582 5.78236 10.7992 5.73455C10.8403 5.68675 10.8968 5.65493 10.9589 5.64467C11.0991 5.62558 11.2408 5.62 11.382 5.628C11.5556 5.628 11.5567 5.628 11.5567 5.45818C11.5567 4.9081 11.5567 4.35801 11.5567 3.80897C11.5567 3.54955 11.696 3.40161 11.9538 3.40057C13.0766 3.40057 14.199 3.40057 15.3211 3.40057C15.3745 3.3968 15.4281 3.40477 15.478 3.42393C15.528 3.44309 15.5732 3.47298 15.6105 3.51149C15.6477 3.55 15.6761 3.59621 15.6936 3.64688C15.7112 3.69755 15.7174 3.75145 15.712 3.8048C15.712 4.35905 15.712 4.91227 15.712 5.46652C15.712 5.59258 15.7474 5.63634 15.8742 5.63113C16.0127 5.61716 16.1523 5.62031 16.29 5.6405C16.364 5.65063 16.4313 5.68856 16.4784 5.74659C16.5255 5.80462 16.5489 5.87843 16.5437 5.95305C16.5356 6.02634 16.5001 6.09384 16.4444 6.14197C16.3886 6.1901 16.3168 6.21529 16.2433 6.21247C15.973 6.21247 15.7027 6.21247 15.4324 6.21247L13.6193 6.21872ZM13.6463 3.99545C13.1972 3.99545 12.7481 3.99545 12.2948 3.99545C12.1784 3.99545 12.1357 4.02358 12.1368 4.14756C12.1441 4.5893 12.1368 5.03103 12.1368 5.47277C12.1368 5.6353 12.1368 5.63634 12.3073 5.63634H14.0528C14.3647 5.63634 14.6849 5.63634 15.0009 5.63634C15.0726 5.63634 15.1184 5.62175 15.1184 5.53215C15.1184 5.05291 15.1184 4.57367 15.1184 4.09443C15.1184 4.02879 15.0966 3.99754 15.0238 3.99754C14.5684 3.9965 14.1079 3.99545 13.6463 3.99545Z" fill="black"/><path d="M13.5621 15.6659H11.0193C10.9271 15.6749 10.835 15.6476 10.7625 15.5899C10.7169 15.5525 10.6841 15.5018 10.6684 15.4449C10.6528 15.388 10.6551 15.3276 10.6751 15.2721C10.6899 15.2171 10.7221 15.1684 10.7669 15.1334C10.8118 15.0985 10.8668 15.0791 10.9236 15.0783C11.0621 15.0704 11.201 15.0704 11.3395 15.0783C11.4528 15.0856 11.4902 15.0481 11.4892 14.9314C11.4892 14.3855 11.4892 13.8406 11.4892 13.2947C11.4892 12.9707 11.6108 12.8499 11.9331 12.8499H15.238C15.5249 12.8499 15.6455 12.9717 15.6466 13.2666C15.6466 13.824 15.6466 14.3824 15.6466 14.9408C15.6466 15.045 15.6777 15.0898 15.7879 15.0825C15.8981 15.0752 16.0374 15.0825 16.1622 15.0825C16.2019 15.0774 16.2422 15.0809 16.2804 15.0929C16.3186 15.1049 16.3538 15.1251 16.3834 15.152C16.4131 15.179 16.4365 15.2121 16.4522 15.249C16.4678 15.2859 16.4753 15.3258 16.4741 15.3659C16.4765 15.4072 16.47 15.4485 16.455 15.4871C16.4401 15.5256 16.417 15.5605 16.3874 15.5893C16.3579 15.6182 16.3225 15.6403 16.2836 15.6543C16.2447 15.6682 16.2033 15.6736 16.1622 15.6701C15.9792 15.6701 15.7963 15.6701 15.6133 15.6701L13.5621 15.6659ZM13.5538 15.0763C14.0113 15.0763 14.4687 15.0763 14.9261 15.0763C15.0124 15.0763 15.054 15.0565 15.054 14.9585C15.0498 14.4918 15.0498 14.0254 15.054 13.5593C15.054 13.4656 15.0207 13.4354 14.9303 13.4354C14.0196 13.4354 13.1089 13.4354 12.1982 13.4354C12.0942 13.4354 12.0703 13.4718 12.0713 13.5677C12.0713 14.0261 12.0713 14.4845 12.0713 14.9429C12.0713 15.0471 12.1077 15.0783 12.2086 15.0773C12.6556 15.0742 13.1047 15.0763 13.5538 15.0763Z" fill="black"/><path d="M6.37008 10.9392H3.80016C3.63486 10.9392 3.53818 10.8808 3.48828 10.7579C3.4659 10.7014 3.46087 10.6395 3.47383 10.5801C3.4868 10.5207 3.51717 10.4665 3.56105 10.4245C3.58859 10.3982 3.62131 10.3779 3.65711 10.365C3.69292 10.3521 3.73102 10.3468 3.76897 10.3495C3.89788 10.3495 4.0268 10.3433 4.15467 10.3495C4.25863 10.3558 4.30125 10.3235 4.30021 10.2099C4.29502 9.66502 4.30021 9.1191 4.30021 8.57318C4.30021 8.24084 4.41561 8.12207 4.74725 8.12207H8.02201C8.31311 8.12207 8.45241 8.25959 8.45241 8.54818C8.45241 9.0941 8.45241 9.64002 8.45241 10.1859C8.45241 10.3485 8.45241 10.3485 8.61979 10.3485H8.93167C9.13959 10.3485 9.27266 10.4641 9.2737 10.6454C9.27474 10.8267 9.14167 10.9392 8.92751 10.9392H6.37008ZM6.38047 8.71175C5.93136 8.71175 5.48225 8.71175 5.02898 8.71175C4.91774 8.71175 4.87512 8.73883 4.8772 8.85864C4.88343 9.30351 4.8772 9.74941 4.8772 10.1953C4.8772 10.312 4.90631 10.3537 5.03002 10.3537C5.91992 10.3481 6.80948 10.3481 7.6987 10.3537C7.82137 10.3537 7.86503 10.3245 7.86295 10.1943C7.85568 9.75253 7.85672 9.3108 7.86295 8.86906C7.86295 8.75134 7.83281 8.70966 7.71013 8.7107C7.26934 8.71904 6.82438 8.71487 6.38047 8.71487V8.71175Z" fill="black"/><path d="M6.37177 6.22183H3.79042C3.59081 6.22183 3.47854 6.12598 3.47126 5.95095C3.46703 5.91038 3.47158 5.86937 3.48462 5.83072C3.49766 5.79208 3.51887 5.75671 3.54681 5.72703C3.57474 5.69736 3.60874 5.67408 3.64648 5.65878C3.68421 5.64348 3.7248 5.63653 3.76547 5.6384C3.88191 5.62903 3.99834 5.6384 4.11478 5.6384C4.29567 5.6384 4.29567 5.6384 4.29567 5.46234V3.81937C4.29567 3.55371 4.43498 3.40264 4.698 3.40264C5.81593 3.40264 6.93385 3.40264 8.05178 3.40264C8.10645 3.39972 8.16112 3.40863 8.21205 3.42876C8.26299 3.44889 8.30901 3.47977 8.34698 3.5193C8.38495 3.55884 8.41398 3.6061 8.43211 3.65787C8.45024 3.70965 8.45703 3.76473 8.45203 3.81937C8.45203 4.36946 8.45203 4.9185 8.45203 5.46859C8.45203 5.63215 8.45203 5.63007 8.62044 5.6332C8.7617 5.62344 8.90361 5.62938 9.04357 5.65091C9.09939 5.66069 9.15086 5.68742 9.19103 5.72748C9.23119 5.76754 9.2581 5.819 9.26812 5.8749C9.28023 5.93039 9.27529 5.98826 9.25395 6.04089C9.23261 6.09352 9.19587 6.13844 9.14857 6.16974C9.10122 6.20482 9.04309 6.22215 8.98431 6.2187H6.37177V6.22183ZM6.37177 3.99336C5.9185 3.99336 5.46523 3.99336 5.013 3.99336C4.90904 3.99336 4.88409 4.02774 4.88409 4.12359C4.88825 4.58199 4.88825 5.04005 4.88409 5.49776C4.88409 5.60194 4.91736 5.63632 5.02132 5.63528C5.92647 5.63528 6.83232 5.63528 7.73886 5.63528C7.8345 5.63528 7.86985 5.60402 7.86881 5.50609C7.86881 5.05186 7.86881 4.59762 7.86881 4.14442C7.86881 4.0267 7.82514 3.99336 7.71494 3.9944C7.26583 3.99648 6.81672 3.99336 6.36865 3.99336H6.37177Z" fill="black"/><path d="M13.554 10.9392H11.0111C10.8749 10.9392 10.7533 10.91 10.6899 10.7714C10.6688 10.7275 10.659 10.6791 10.6615 10.6304C10.664 10.5818 10.6787 10.5345 10.7041 10.493C10.7296 10.4516 10.765 10.4171 10.8072 10.393C10.8494 10.3688 10.897 10.3556 10.9456 10.3547C11.0841 10.3473 11.2229 10.3473 11.3614 10.3547C11.4654 10.3547 11.4893 10.3182 11.4883 10.2234C11.4883 9.67334 11.4883 9.12325 11.4883 8.57317C11.4883 8.26062 11.6193 8.12622 11.9343 8.12622H15.2132C15.5251 8.12622 15.6446 8.24916 15.6446 8.5565C15.6446 9.10658 15.6446 9.65667 15.6446 10.2057C15.6446 10.3203 15.6758 10.363 15.7923 10.3547C15.9087 10.3464 16.0418 10.3547 16.1665 10.3547C16.2049 10.3522 16.2435 10.3574 16.2798 10.3703C16.3162 10.3831 16.3495 10.4031 16.3779 10.4292C16.4063 10.4553 16.4291 10.4869 16.4449 10.5221C16.4608 10.5573 16.4693 10.5953 16.4701 10.6339C16.4737 10.6736 16.4687 10.7137 16.4556 10.7514C16.4425 10.7891 16.4215 10.8235 16.3941 10.8524C16.3666 10.8813 16.3333 10.904 16.2964 10.919C16.2595 10.9339 16.2198 10.9408 16.18 10.9392C16.0345 10.9465 15.8889 10.9392 15.7434 10.9392H13.554ZM13.554 10.3484C14.0062 10.3484 14.4595 10.3484 14.9117 10.3484C15.0157 10.3484 15.0531 10.3224 15.0521 10.2151C15.0469 9.75773 15.0521 9.29932 15.0521 8.84196C15.0521 8.74819 15.0281 8.70756 14.9263 8.70756C14.0169 8.70756 13.1069 8.70756 12.1962 8.70756C12.0923 8.70756 12.0684 8.74298 12.0694 8.83883C12.0694 9.29307 12.0694 9.74731 12.0694 10.2005C12.0694 10.3193 12.111 10.3495 12.2222 10.3484C12.6662 10.3484 13.1111 10.3516 13.5561 10.3516L13.554 10.3484Z" fill="black"/></svg>';
      } else if (type.startsWith("Mixed-Use Apartment")) {
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.6667 7.48071L19.0084 8.9501C19.6001 9.07605 20.0001 9.57984 20.0001 10.176V18.7404C20.0001 19.4373 19.4418 19.9999 18.7501 19.9999H11.25C11.4833 19.9999 11.6667 19.8152 11.6667 19.5801V19.1602H18.7501C18.9751 19.1602 19.1668 18.9755 19.1668 18.7404V10.176C19.1668 9.98287 19.0334 9.80654 18.8418 9.76456L11.6667 8.33716V7.48071Z" fill="black"/>
                        <path d="M16.2494 11.6035C16.4827 11.6035 16.666 11.7882 16.666 12.0233C16.666 12.2584 16.4827 12.4432 16.2494 12.4432H14.5827C14.3494 12.4432 14.166 12.2584 14.166 12.0233C14.166 11.7882 14.3494 11.6035 14.5827 11.6035H16.2494Z" fill="black"/>
                        <path d="M16.2494 14.1226C16.4827 14.1226 16.666 14.3073 16.666 14.5424C16.666 14.7775 16.4827 14.9622 16.2494 14.9622H14.5827C14.3494 14.9622 14.166 14.7775 14.166 14.5424C14.166 14.3073 14.3494 14.1226 14.5827 14.1226H16.2494Z" fill="black"/>
                        <path d="M16.2494 16.6414C16.4827 16.6414 16.666 16.8261 16.666 17.0612C16.666 17.2963 16.4827 17.481 16.2494 17.481H14.5827C14.3494 17.481 14.166 17.2963 14.166 17.0612C14.166 16.8261 14.3494 16.6414 14.5827 16.6414H16.2494Z" fill="black"/>
                        <path d="M11.6663 19.58C11.6663 19.8151 11.483 19.9999 11.2497 19.9999C11.0163 19.9999 10.833 19.8151 10.833 19.58V19.1602V7.82497C10.833 7.69902 10.8913 7.58147 10.983 7.49751C11.083 7.42194 11.208 7.38835 11.333 7.41354L11.6663 7.48072V8.33716V19.1602V19.58Z" fill="black"/>
                        <path d="M10.8327 19.1604V19.5802C10.8327 19.8153 11.016 20 11.2494 20H7.91602C8.14935 20 8.33269 19.8153 8.33269 19.5802V19.1604H10.8327Z" fill="black"/>
                        <path d="M8.74937 4.04663C8.98271 4.04663 9.16605 4.23135 9.16605 4.46646C9.16605 4.70156 8.98271 4.88628 8.74937 4.88628H7.08269C6.84935 4.88628 6.66602 4.70156 6.66602 4.46646C6.66602 4.23135 6.84935 4.04663 7.08269 4.04663H8.74937Z" fill="black"/>
                        <path d="M9.16605 6.9855C9.16605 7.2206 8.98271 7.40532 8.74937 7.40532H7.08269C6.84935 7.40532 6.66602 7.2206 6.66602 6.9855C6.66602 6.7504 6.84935 6.56567 7.08269 6.56567H8.74937C8.98271 6.56567 9.16605 6.7504 9.16605 6.9855Z" fill="black"/>
                        <path d="M8.74937 9.08447C8.98271 9.08447 9.16605 9.2692 9.16605 9.5043C9.16605 9.7394 8.98271 9.92412 8.74937 9.92412H7.08269C6.84935 9.92412 6.66602 9.7394 6.66602 9.5043C6.66602 9.2692 6.84935 9.08447 7.08269 9.08447H8.74937Z" fill="black"/>
                        <path d="M8.74937 11.6035C8.98271 11.6035 9.16605 11.7882 9.16605 12.0233C9.16605 12.2584 8.98271 12.4432 8.74937 12.4432H7.08269C6.84935 12.4432 6.66602 12.2584 6.66602 12.0233C6.66602 11.7882 6.84935 11.6035 7.08269 11.6035H8.74937Z" fill="black"/>
                        <path d="M5.00003 12.0233C5.00003 12.2584 4.81669 12.4432 4.58336 12.4432H2.91667C2.68334 12.4432 2.5 12.2584 2.5 12.0233C2.5 11.7882 2.68334 11.6035 2.91667 11.6035H4.58336C4.81669 11.6035 5.00003 11.7882 5.00003 12.0233Z" fill="black"/>
                        <path d="M4.58336 4.04663C4.81669 4.04663 5.00003 4.23135 5.00003 4.46646C5.00003 4.70156 4.81669 4.88628 4.58336 4.88628H2.91667C2.68334 4.88628 2.5 4.70156 2.5 4.46646C2.5 4.23135 2.68334 4.04663 2.91667 4.04663H4.58336Z" fill="black"/>
                        <path d="M4.58336 6.56567C4.81669 6.56567 5.00003 6.7504 5.00003 6.9855C5.00003 7.2206 4.81669 7.40532 4.58336 7.40532H2.91667C2.68334 7.40532 2.5 7.2206 2.5 6.9855C2.5 6.7504 2.68334 6.56567 2.91667 6.56567H4.58336Z" fill="black"/>
                        <path d="M4.58336 9.08447C4.81669 9.08447 5.00003 9.2692 5.00003 9.5043C5.00003 9.7394 4.81669 9.92412 4.58336 9.92412H2.91667C2.68334 9.92412 2.5 9.7394 2.5 9.5043C2.5 9.2692 2.68334 9.08447 2.91667 9.08447H4.58336Z" fill="black"/>
                        <path d="M7.49972 15.382C7.49972 15.1469 7.30806 14.9622 7.08305 14.9622H4.58302C4.34969 14.9622 4.16635 15.1469 4.16635 15.382V19.1605H3.33301V15.382C3.33301 14.6851 3.89135 14.1226 4.58302 14.1226H7.08305C7.77473 14.1226 8.33307 14.6851 8.33307 15.382V19.1605H7.49972V15.382Z" fill="black"/>
                        <path d="M4.16635 19.1604H7.49972H8.33307V19.5802C8.33307 19.8153 8.14973 20 7.9164 20H3.74968C3.51634 20 3.33301 19.8153 3.33301 19.5802V19.1604H4.16635Z" fill="black"/>
                        <path d="M1.45835 0.0163471L10.6168 1.41856C11.2251 1.51932 11.6668 2.0399 11.6668 2.66124V7.48082L11.3335 7.41365C11.2085 7.38846 11.0835 7.42205 10.9835 7.49762C10.8918 7.58158 10.8335 7.69913 10.8335 7.82508V2.66124C10.8335 2.45133 10.6835 2.275 10.4835 2.24142L1.32502 0.8476C1.30002 0.839203 1.27502 0.839203 1.25002 0.839203C1.15001 0.839203 1.05835 0.872789 0.983345 0.939961C0.883344 1.02393 0.833343 1.13308 0.833343 1.25903V18.7405C0.833343 18.9756 1.02501 19.1603 1.25002 19.1603H3.33337V19.5802C3.33337 19.8153 3.51671 20 3.75005 20H1.25002C0.55834 20 0 19.4374 0 18.7405V1.25903C0 0.889582 0.158335 0.536929 0.441672 0.301828C0.725009 0.0583296 1.09168 -0.0424283 1.45835 0.0163471Z" fill="black"/>
                        </svg>`;
      } else if (type.startsWith("Townhome")) {
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.6875 13.1251L18.3813 6.56256H17.1875V4.63412L17.8916 5.13693C18.0516 5.25193 18.2403 5.31256 18.4372 5.31256C18.7394 5.31256 19.0247 5.16568 19.2003 4.91975C19.346 4.716 19.4035 4.46756 19.3622 4.22037C19.3207 3.97287 19.1857 3.75693 18.9822 3.61256L14.6069 0.486934C14.2869 0.258809 13.8369 0.258809 13.5178 0.487559L9.14347 3.61193C8.9394 3.75693 8.8044 3.97318 8.76284 4.22037C8.72159 4.46756 8.77878 4.716 8.92503 4.92037C9.21503 5.32537 9.82722 5.42725 10.2325 5.13756L10.9375 4.63381V6.56256H7.93409L7.49878 6.17568C7.15472 5.86881 6.59503 5.86943 6.25222 6.17506L0.627528 11.1744C0.440028 11.3407 0.328778 11.5701 0.314091 11.8201C0.299716 12.0704 0.383153 12.311 0.549091 12.4976C0.726903 12.6982 0.982528 12.8132 1.25003 12.8132C1.47972 12.8132 1.70097 12.7288 1.87315 12.5757L2.18753 12.2963V19.6876H19.0625V15.3126H19.6875V13.1251ZM17.8688 7.18756L19.0625 13.156V13.4376H11.5625V12.2963L11.8769 12.5757C12.2488 12.9066 12.8703 12.8694 13.2007 12.4982C13.3669 12.311 13.4503 12.0704 13.4357 11.8201C13.421 11.5697 13.3097 11.3407 13.1228 11.1751L11.8013 10.0001H17.1875V7.18756H17.8688ZM14.6875 9.37506H13.4375V6.87506H14.6875V9.37506ZM9.86909 4.62912C9.73347 4.72568 9.5294 4.691 9.43315 4.55693C9.3844 4.48881 9.36534 4.406 9.37909 4.3235C9.39315 4.23975 9.4369 4.17006 9.50597 4.12068L13.881 0.995996C13.9878 0.919746 14.1375 0.920371 14.2438 0.995684L18.6191 4.12162C18.6866 4.16943 18.7316 4.24131 18.7453 4.3235C18.7591 4.406 18.74 4.4885 18.6916 4.55631C18.595 4.69193 18.3919 4.72693 18.255 4.62881L14.0625 1.63412L9.86909 4.62912ZM14.0625 2.40193L16.5625 4.18787V9.37506H15.3125V6.25006H12.8125V9.37506H11.5625V4.18756L14.0625 2.40193ZM10.9375 7.18756V9.23225L8.63722 7.18756H10.9375ZM1.45784 12.1088C1.33315 12.2197 1.12722 12.2069 1.01628 12.0826C0.960966 12.0207 0.933153 11.9404 0.938153 11.8566C0.943153 11.7732 0.980028 11.6969 1.04253 11.6416L6.66753 6.64162C6.72503 6.59068 6.79847 6.56256 6.87503 6.56256C6.95159 6.56256 7.02534 6.59068 7.08315 6.64225L12.7082 11.6422C12.7703 11.6976 12.8072 11.7735 12.8119 11.8569C12.8169 11.9416 12.7897 12.0197 12.7335 12.0835C12.6235 12.2072 12.4166 12.2197 12.2922 12.1091L6.87503 7.2935L1.45784 12.1088ZM6.87503 8.12975L10.9375 11.7407V12.8126H8.43753V10.3126H5.31253V12.8126H2.81253V11.7407L6.87503 8.12975ZM7.81253 12.8126H5.93753V10.9376H7.81253V12.8126ZM2.81253 13.4376H10.9375V19.0626H7.18753V15.3126H3.43753V19.0626H2.81253V13.4376ZM6.56253 19.0626H4.06253V15.9376H6.56253V19.0626ZM18.4375 19.0626H11.5625V15.3126H18.4375V19.0626ZM11.5625 14.6876V14.0626H19.0625V14.6876H11.5625Z" fill="black"/>
                        <path d="M10.3125 14.0625H7.8125V16.5625H10.3125V14.0625ZM9.6875 15.9375H8.4375V14.6875H9.6875V15.9375Z" fill="black"/>
                        <path d="M14.6875 18.4375V15.9375H12.1875V18.4375H14.6875ZM12.8125 16.5625H14.0625V17.8125H12.8125V16.5625Z" fill="black"/>
                        <path d="M17.8125 15.9375H15.3125V18.4375H17.8125V15.9375ZM17.1875 17.8125H15.9375V16.5625H17.1875V17.8125Z" fill="black"/>
                        </svg>`;
      } else if (type.startsWith("Stacked Townhome")) {
        return `<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.33333 17.6666C7.51742 17.6666 7.66667 17.5173 7.66667 17.3333V16.6666C7.66667 16.4825 7.51742 16.3333 7.33333 16.3333C7.14925 16.3333 7 16.4825 7 16.6666V17.3333C7 17.5173 7.14925 17.6666 7.33333 17.6666Z" fill="black"/>
                        <path d="M15.6667 8H14.6667V2.66667H15.6667C15.8508 2.66654 15.9999 2.51717 15.9998 2.33308C15.9997 2.29737 15.994 2.26188 15.9827 2.228L15.316 0.228C15.2707 0.0919167 15.1434 0.000125 15 0H1C0.856583 0.000125 0.729333 0.0919167 0.684 0.228L0.0173333 2.228C-0.0408333 2.40267 0.0535834 2.59142 0.22825 2.64958C0.262125 2.66088 0.297625 2.66663 0.333333 2.66667H1.33333V8H0.333333C0.14925 8 0 8.14925 0 8.33333V9.66667C0 9.85075 0.14925 10 0.333333 10H1.33333V19.6667C1.33333 19.8507 1.48258 20 1.66667 20H14.3333C14.5174 20 14.6667 19.8507 14.6667 19.6667V10H15.6667C15.8508 10 16 9.85075 16 9.66667V8.33333C16 8.14925 15.8508 8 15.6667 8ZM0.796 2L1.24033 0.666667H14.7597L15.204 2H0.796ZM14 2.66667V8H2V2.66667H14ZM9.33333 19.3333H6.66667V15.3333H9.33333V19.3333ZM14 19.3333H10V15C10 14.8159 9.85075 14.6667 9.66667 14.6667H6.33333C6.14925 14.6667 6 14.8159 6 15V19.3333H2V10H14V19.3333ZM15.3333 9.33333H0.666667V8.66667H15.3333V9.33333Z" fill="black"/>
                        <path d="M3.66683 6.66667H5.66683C5.85091 6.66667 6.00016 6.51742 6.00016 6.33333V4.33333C6.00016 4.14925 5.85091 4 5.66683 4H3.66683C3.48275 4 3.3335 4.14925 3.3335 4.33333V6.33333C3.3335 6.51742 3.48275 6.66667 3.66683 6.66667ZM4.00016 4.66667H5.3335V6H4.00016V4.66667Z" fill="black"/>
                        <path d="M10.3333 6.66667H12.3333C12.5174 6.66667 12.6667 6.51742 12.6667 6.33333V4.33333C12.6667 4.14925 12.5174 4 12.3333 4H10.3333C10.1493 4 10 4.14925 10 4.33333V6.33333C10 6.51742 10.1493 6.66667 10.3333 6.66667ZM10.6667 4.66667H12V6H10.6667V4.66667Z" fill="black"/>
                        <path d="M3.66683 13.9999H5.66683C5.85091 13.9999 6.00016 13.8507 6.00016 13.6666V11.6666C6.00016 11.4825 5.85091 11.3333 5.66683 11.3333H3.66683C3.48275 11.3333 3.3335 11.4825 3.3335 11.6666V13.6666C3.3335 13.8507 3.48275 13.9999 3.66683 13.9999ZM4.00016 11.9999H5.3335V13.3333H4.00016V11.9999Z" fill="black"/>
                        <path d="M10.3333 13.9999H12.3333C12.5174 13.9999 12.6667 13.8507 12.6667 13.6666V11.6666C12.6667 11.4825 12.5174 11.3333 12.3333 11.3333H10.3333C10.1493 11.3333 10 11.4825 10 11.6666V13.6666C10 13.8507 10.1493 13.9999 10.3333 13.9999ZM10.6667 11.9999H12V13.3333H10.6667V11.9999Z" fill="black"/>
                        </svg>`;
      } else if (type.startsWith("Commercial")) {
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.619048 19.4091H7.95238V5.42541L0.619048 8.2871V19.4091ZM8.14908 5.34865C8.14915 5.34862 8.14922 5.34859 8.1493 5.34856L8.09524 5.22234L8.1493 5.34856L8.14908 5.34865ZM0 19.5455V8.19553C0 8.01092 0.116974 7.84464 0.295994 7.77478L7.91504 4.8016C8.2283 4.67935 8.57143 4.89929 8.57143 5.22234V19.5455C8.57143 19.7965 8.35823 20 8.09524 20H0.476191C0.213198 20 0 19.7965 0 19.5455Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0951 0.590909V19.4091H19.3808V0.590909H11.0951ZM10.9523 0C10.6893 0 10.4761 0.203507 10.4761 0.454545V19.5455C10.4761 19.7965 10.6893 20 10.9523 20H19.5237C19.7867 20 19.9999 19.7965 19.9999 19.5455V0.454546C19.9999 0.203507 19.7867 0 19.5237 0H10.9523Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 5.81823H12.7618V6.90914H13.9047V5.81823ZM12.3809 5.45459V7.27277H14.2856V5.45459H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 2.18175H12.7618V3.27266H13.9047V2.18175ZM12.3809 1.81812V3.6363H14.2856V1.81812H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 9.45446H12.7618V10.5454H13.9047V9.45446ZM12.3809 9.09082V10.909H14.2856V9.09082H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 13.0909H12.7618V14.1818H13.9047V13.0909ZM12.3809 12.7273V14.5455H14.2856V12.7273H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 16.7272H12.7618V17.8181H13.9047V16.7272ZM12.3809 16.3635V18.1817H14.2856V16.3635H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 16.7272H5.14267V17.8181H6.28553V16.7272ZM4.76172 16.3635V18.1817H6.66648V16.3635H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 16.7272H2.28525V17.8181H3.42811V16.7272ZM1.9043 16.3635V18.1817H3.80906V16.3635H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 13.0909H5.14267V14.1818H6.28553V13.0909ZM4.76172 12.7273V14.5455H6.66648V12.7273H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 13.0909H2.28525V14.1818H3.42811V13.0909ZM1.9043 12.7273V14.5455H3.80906V12.7273H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 9.45446H5.14267V10.5454H6.28553V9.45446ZM4.76172 9.09082V10.909H6.66648V9.09082H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 9.45446H2.28525V10.5454H3.42811V9.45446ZM1.9043 9.09082V10.909H3.80906V9.09082H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 5.81823H16.5714V6.90914H17.7142V5.81823ZM16.1904 5.45459V7.27277H18.0952V5.45459H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 2.18175H16.5714V3.27266H17.7142V2.18175ZM16.1904 1.81812V3.6363H18.0952V1.81812H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 9.45446H16.5714V10.5454H17.7142V9.45446ZM16.1904 9.09082V10.909H18.0952V9.09082H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 13.0909H16.5714V14.1818H17.7142V13.0909ZM16.1904 12.7273V14.5455H18.0952V12.7273H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 16.7272H16.5714V17.8181H17.7142V16.7272ZM16.1904 16.3635V18.1817H18.0952V16.3635H16.1904Z" fill="black"/>
                        </svg>`;
      } else {
        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.0037 7.23897C15.0003 7.16645 14.9682 7.09828 14.9144 7.04945C14.8607 7.00061 14.7898 6.97512 14.7172 6.97858C14.6447 6.98204 14.5766 7.01417 14.5277 7.0679C14.4789 7.12162 14.4534 7.19255 14.4569 7.26507L14.4995 8.1571C14.5028 8.22725 14.5331 8.29343 14.5839 8.3419C14.6347 8.39037 14.7023 8.41741 14.7725 8.41741H14.7856C14.8216 8.41587 14.857 8.40722 14.8896 8.39197C14.9223 8.37673 14.9516 8.35517 14.9759 8.32856C15.0002 8.30194 15.0189 8.27079 15.0312 8.23688C15.0434 8.20298 15.0488 8.167 15.047 8.131L15.0037 7.23897Z" fill="black"/>
                        <path d="M15.5664 1.67969C15.2454 1.68006 14.9376 1.80776 14.7106 2.03477C14.4835 2.26179 14.3558 2.56958 14.3555 2.89062C14.3555 2.96315 14.3843 3.03269 14.4356 3.08397C14.4868 3.13525 14.5564 3.16406 14.6289 3.16406C14.7014 3.16406 14.771 3.13525 14.8223 3.08397C14.8735 3.03269 14.9023 2.96315 14.9023 2.89062C14.9026 2.71457 14.9726 2.54578 15.0971 2.42129C15.2216 2.2968 15.3903 2.22677 15.5664 2.22656H16.3906C16.4631 2.22656 16.5327 2.19775 16.584 2.14647C16.6353 2.0952 16.6641 2.02565 16.6641 1.95312C16.6641 1.8806 16.6353 1.81105 16.584 1.75978C16.5327 1.7085 16.4631 1.67969 16.3906 1.67969H15.5664Z" fill="black"/>
                        <path d="M18.9841 1.67969H17.543C17.4704 1.67969 17.4009 1.7085 17.3496 1.75978C17.2983 1.81105 17.2695 1.8806 17.2695 1.95312C17.2695 2.02565 17.2983 2.0952 17.3496 2.14647C17.4009 2.19775 17.4704 2.22656 17.543 2.22656H18.9841C19.0566 2.22656 19.1261 2.19775 19.1774 2.14647C19.2287 2.0952 19.2575 2.02565 19.2575 1.95312C19.2575 1.8806 19.2287 1.81105 19.1774 1.75978C19.1261 1.7085 19.0566 1.67969 18.9841 1.67969Z" fill="black"/>
                        <path d="M18.6074 1.28906H18.984C19.0565 1.28906 19.1261 1.26025 19.1773 1.20897C19.2286 1.1577 19.2574 1.08815 19.2574 1.01562C19.2574 0.943105 19.2286 0.873555 19.1773 0.822276C19.1261 0.770996 19.0565 0.742188 18.984 0.742188H18.6074C18.5349 0.742188 18.4654 0.770996 18.4141 0.822276C18.3628 0.873555 18.334 0.943105 18.334 1.01562C18.334 1.08815 18.3628 1.1577 18.4141 1.20897C18.4654 1.26025 18.5349 1.28906 18.6074 1.28906Z" fill="black"/>
                        <path d="M13.6914 3.16406C13.7639 3.16406 13.8335 3.13525 13.8848 3.08397C13.936 3.0327 13.9648 2.96315 13.9648 2.89062C13.9653 2.466 14.1342 2.0589 14.4344 1.75865C14.7347 1.4584 15.1418 1.28952 15.5664 1.28906H17.1039C17.1764 1.28906 17.246 1.26025 17.2973 1.20897C17.3485 1.1577 17.3773 1.08815 17.3773 1.01562C17.3773 0.943105 17.3485 0.873555 17.2973 0.822276C17.246 0.770996 17.1764 0.742188 17.1039 0.742188H15.5664C14.9968 0.742808 14.4507 0.96936 14.0479 1.37214C13.6451 1.77491 13.4186 2.32101 13.418 2.89062C13.418 2.96315 13.4468 3.0327 13.4981 3.08397C13.5493 3.13525 13.6189 3.16406 13.6914 3.16406Z" fill="black"/>
                        <path d="M18.9844 17.7733H18.3203V11.8265C18.3203 11.754 18.2915 11.6844 18.2402 11.6331C18.1889 11.5818 18.1194 11.553 18.0469 11.553H16.1481L15.8341 4.9668C15.8823 4.94525 15.9234 4.91017 15.9521 4.8658C15.9809 4.82143 15.9961 4.76967 15.9961 4.7168V3.7793C15.9961 3.70678 15.9673 3.63723 15.916 3.58595C15.8647 3.53467 15.7952 3.50586 15.7227 3.50586H12.5977C12.5251 3.50586 12.4556 3.53467 12.4043 3.58595C12.353 3.63723 12.3242 3.70678 12.3242 3.7793V4.7168C12.3242 4.76967 12.3394 4.82143 12.3682 4.8658C12.397 4.91017 12.438 4.94525 12.4862 4.9668L12.1719 11.553H8.44688V10.2734H9.11062C9.18313 10.2733 9.25266 10.2445 9.30393 10.1932C9.3552 10.1419 9.38402 10.0724 9.38406 9.99992V9.06242C9.38402 8.98991 9.3552 8.92038 9.30393 8.86911C9.25266 8.81784 9.18313 8.78902 9.11062 8.78898H1.01562C0.943118 8.78902 0.873592 8.81784 0.822321 8.86911C0.771051 8.92038 0.742229 8.98991 0.742188 9.06242V9.99992C0.742229 10.0724 0.771051 10.1419 0.822321 10.1932C0.873592 10.2445 0.943118 10.2733 1.01562 10.2734H1.67969V17.7733H1.01562C0.943118 17.7734 0.873592 17.8022 0.822321 17.8535C0.771051 17.9048 0.742229 17.9743 0.742188 18.0468V18.9843C0.742229 19.0568 0.771051 19.1263 0.822321 19.1776C0.873592 19.2289 0.943118 19.2577 1.01562 19.2577H18.9844C19.0569 19.2577 19.1264 19.2289 19.1777 19.1776C19.229 19.1264 19.2578 19.0568 19.2578 18.9843V18.0468C19.2578 17.9743 19.229 17.9047 19.1777 17.8534C19.1264 17.8022 19.0569 17.7733 18.9844 17.7733ZM12.8711 4.05336H15.4492V4.44398H12.8711V4.05336ZM13.0327 4.99086H15.2877L15.6002 11.5534H12.7197L13.0327 4.99086ZM17.7734 12.1002V17.7737H8.44688V12.0999L17.7734 12.1002ZM1.28906 9.33585H8.83719V9.72648H1.28906V9.33585ZM2.22656 10.2734H7.9V17.7733H6.27406V14.9218C6.27402 14.8493 6.2452 14.7798 6.19393 14.7285C6.14266 14.6772 6.07313 14.6484 6.00062 14.6483H4.12562C4.0531 14.6483 3.98355 14.6772 3.93228 14.7284C3.881 14.7797 3.85219 14.8493 3.85219 14.9218V17.7733H2.22656V10.2734ZM5.72656 17.7733H4.39844V15.1952H5.72656V17.7733ZM18.7109 18.7108H1.28906V18.3202H18.7109V18.7108Z" fill="black"/>
                        <path d="M4.59424 13.8152H5.53174C5.60425 13.8151 5.67378 13.7863 5.72505 13.7351C5.77632 13.6838 5.80514 13.6143 5.80518 13.5417V12.6042C5.80518 12.5317 5.77637 12.4622 5.72509 12.4109C5.67381 12.3596 5.60426 12.3308 5.53174 12.3308H4.59424C4.55833 12.3308 4.52276 12.3378 4.48957 12.3516C4.45639 12.3653 4.42624 12.3855 4.40084 12.4109C4.37545 12.4362 4.35531 12.4664 4.34157 12.4996C4.32784 12.5328 4.32078 12.5683 4.3208 12.6042V13.5417C4.3208 13.6143 4.34961 13.6838 4.40089 13.7351C4.45217 13.7864 4.52172 13.8152 4.59424 13.8152ZM4.86768 12.8777H5.2583V13.2683H4.86768V12.8777Z" fill="black"/>
                        <path d="M9.5791 15.679H10.5166C10.5891 15.679 10.6587 15.6501 10.71 15.5989C10.7612 15.5476 10.79 15.478 10.79 15.4055V14.468C10.79 14.3955 10.7612 14.326 10.7099 14.2747C10.6586 14.2234 10.5891 14.1946 10.5166 14.1946H9.5791C9.50658 14.1946 9.43703 14.2234 9.38575 14.2747C9.33447 14.3259 9.30566 14.3955 9.30566 14.468V15.4055C9.30564 15.4414 9.3127 15.477 9.32644 15.5102C9.34017 15.5434 9.36031 15.5735 9.38571 15.5989C9.4111 15.6243 9.44125 15.6444 9.47444 15.6582C9.50762 15.6719 9.54319 15.679 9.5791 15.679ZM9.85254 14.7415H10.2432V15.1321H9.85254V14.7415Z" fill="black"/>
                        <path d="M12.6411 15.679H13.5786C13.6145 15.679 13.6501 15.6719 13.6833 15.6582C13.7165 15.6444 13.7466 15.6243 13.772 15.5989C13.7974 15.5735 13.8175 15.5434 13.8313 15.5102C13.845 15.477 13.8521 15.4414 13.8521 15.4055V14.468C13.8521 14.3955 13.8232 14.3259 13.772 14.2747C13.7207 14.2234 13.6511 14.1946 13.5786 14.1946H12.6411C12.5686 14.1946 12.499 14.2234 12.4478 14.2747C12.3965 14.3259 12.3677 14.3955 12.3677 14.468V15.4055C12.3677 15.4414 12.3747 15.477 12.3884 15.5102C12.4022 15.5434 12.4223 15.5735 12.4477 15.5989C12.4731 15.6243 12.5033 15.6444 12.5364 15.6582C12.5696 15.6719 12.6052 15.679 12.6411 15.679ZM12.9146 14.7415H13.3052V15.1321H12.9146V14.7415Z" fill="black"/>
                        <path d="M15.7031 15.679H16.6406C16.6765 15.679 16.7121 15.6719 16.7453 15.6582C16.7785 15.6444 16.8086 15.6243 16.834 15.5989C16.8594 15.5735 16.8796 15.5434 16.8933 15.5102C16.907 15.477 16.9141 15.4414 16.9141 15.4055V14.468C16.9141 14.3955 16.8853 14.3259 16.834 14.2747C16.7827 14.2234 16.7131 14.1946 16.6406 14.1946H15.7031C15.6306 14.1946 15.5611 14.2234 15.5098 14.2747C15.4585 14.3259 15.4297 14.3955 15.4297 14.468V15.4055C15.4297 15.4414 15.4367 15.477 15.4505 15.5102C15.4642 15.5434 15.4843 15.5735 15.5097 15.5989C15.5351 15.6243 15.5653 15.6444 15.5985 15.6582C15.6316 15.6719 15.6672 15.679 15.7031 15.679ZM15.9766 14.7415H16.3672V15.1321H15.9766V14.7415Z" fill="black"/>
                        </svg>`;
      }
    },
    statusSwitch(status) {
      switch (status) {
        case "Not Submitted":
          return "status-grey";
          break;
        case "In Process":
          return "status-yellow";
          break;
        case "Approved":
          return "status-purple";
          break;
        case "Issued":
          return "status-blue";
          break;
        case "Completed":
        case "Adopted":
          return "status-green";
          break;
        case "Denied":
          return "status-red";
          break;
        default:
          return "status-transparent";
          break;
      }
    },
    openGallery() {
      setTimeout(this.$refs.carousel.computeCarouselWidth, 300);
    },
    singleMapSecond(val_lat, val_lng) {
      var fenway = { lat: parseFloat(val_lat), lng: parseFloat(val_lng) };
      var map = new google.maps.Map(document.getElementById("map2"), {
        center: fenway,
        zoom: 14,
      });
      var markerIcon = {
        anchor: new google.maps.Point(22, 16),
        url: "/images/marker.png",
      };
      var marker = new google.maps.Marker({
        position: fenway,
        map: map,
        icon: markerIcon,
      });
    },
    singleMap(val_lat, val_lng) {
      var fenway = { lat: parseFloat(val_lat), lng: parseFloat(val_lng) };
      var allMaps = document.getElementsByClassName("updated-maps");

      Array.from(allMaps).forEach((x) => {
        var map = new google.maps.Map(x, {
          center: fenway,
          zoom: 14,
          zoomControl: true,
          scrollwheel: true,
        });
        var markerIcon = {
          anchor: new google.maps.Point(22, 16),
          url: "/images/marker.png",
        };
        var marker = new google.maps.Marker({
          position: fenway,
          map: map,
          icon: markerIcon,
        });
      });
    },
    exportUnitBreakdown() {
      const vm = this;
      let toDeci =
        ["developer", "admin", "developerbc"].includes(vm.current_user.role) &&
        vm.project.status &&
        ["now leasing", "now leasing 2", "leased out", "leased out 2"].includes(
          vm.project.status.toLowerCase()
        );

      let data = vm.mlsTotalSort.map((row) => ({
        ...row,
        bed: !["0", 0, "-", "s"].includes(row["bed"])
          ? row["bed"] + "-bed"
          : ["s"].includes(row["bed"])
            ? "Studio"
            : "-",
        fp_specs: !["none", 0, "-"].includes(row["fp_specs"].toLowerCase())
          ? row["fp_specs"]
          : "-",
        avg_units: vm.getAverageUnits(vm.mlsTotalSort, row["num"]) + "%",
        stall: row["stall"] ? row["stall"].final : "-",
        total_size: Math.round((row["total_size"] * 1.0) / row["num"]),
        avg_psf:
          toDeci && row["avgPrice"] && row["total_size"] && row["num"]
            ? Number(
              row["avgPrice"] / (row["total_size"] / row["num"])
            ).toFixed(2)
            : row["avgPrice"] && row["total_size"] && row["num"]
              ? Math.round(row["avgPrice"] / (row["total_size"] / row["num"]))
              : "-",
        avgPrice: row["avgPrice"] ? row["avgPrice"] : "-",
      }));
      const csvContent = vm.convertUnitBreakdownToCsv(data);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "exported-data.csv");
      link.click();
      URL.revokeObjectURL(url);
    },
    convertUnitBreakdownToCsv(data) {
      const vm = this;
      let toDeci =
        ["developer", "admin", "developerbc"].includes(vm.current_user.role) &&
        vm.project.status &&
        ["now leasing", "now leasing 2", "leased out", "leased out 2"].includes(
          vm.project.status.toLowerCase()
        );

      const headers = [
        { key: "bed", label: "Bed" },
        { key: "fp_specs", label: "FP Specs" },
        { key: "bath", label: "Baths" },
        { key: "num", label: "# Units" },
        { key: "avg_units", label: "%" },
        { key: "stall", label: "Stalls" },
        { key: "minSize", label: "Min SF" },
        { key: "maxSize", label: "Max SF" },
        { key: "total_size", label: "Avg SF" },
        { key: "minPrice", label: "Min Price" },
        { key: "maxPrice", label: "Max Price" },
        { key: "avgPrice", label: "Avg Price" },
        { key: "avg_psf", label: "Avg PSF" },
      ];
      if (toDeci) headers.splice(5, 0, { key: "parking", label: "Parking" });
      const rows = data.map((row) => {
        return headers.map((header) => {
          const cell = row[header.key];
          return typeof cell === "string" && cell.includes(",")
            ? `"${cell.replace(/"/g, '""')}"` // Escape commas and quotes
            : cell;
        });
      });

      const headerRow = headers.map((item) => item.label).join(",");
      const csvRows = [headerRow, ...rows.map((row) => row.join(","))];
      return csvRows.join("\n");
    },
    exportFloorPlanToCsv() {
      const vm = this;
      let data = vm.unitPreviewSummary;
      data = data.sort((a, b) => a["avg_size"] - b["avg_size"]);
      data = data.map((item) => {
        let beds =
          item.type.mls_beds == "s"
            ? "Studio"
            : item.type.mls_beds == "jr"
              ? "Jr 1-bed"
              : item.type.mls_beds + "-bed";
        let fp_specs = item.type.fp_specs == "None" ? "" : item.type.fp_specs;
        return {
          ...item,
          type: fp_specs ? beds + " / " + fp_specs : beds,
        };
      });
      vm.$bvToast.toast(
        `Download is in progress. Please wait for a moment while we prepare everything for you.`,
        {
          title: "Downloading...",
          variant: "info",
          autoHideDelay: 5000,
        }
      );

      try {
        const csvContent = this.convertFloorplansToCsv(data);
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "exported-data.csv");
        link.click();
        URL.revokeObjectURL(url); // Clean up the URL after download
        vm.$bvToast.toast(`You can now view the downloaded file`, {
          title: "Success!",
          variant: "success",
          autoHideDelay: 5000,
        });
      } catch (error) {
        // Handle any errors that occurred during the process
        console.error(
          "Error during image generation or report generation:",
          error
        );
        vm.$bvToast.toast(
          `${"Something went wrong. \n Please inform us to fix this for you."}`,
          {
            title: "Oops!",
            variant: "danger",
            autoHideDelay: 5000,
          }
        );
      }
    },
    convertFloorplansToCsv(data) {
      const vm = this;
      try {
        const headers = vm.unitPreviewSummaryHeader
          .filter((header) => header.key != "checkbox")
          .map((item) => item.label);
        const rows = data.map((row) => {
          return vm.unitPreviewSummaryHeader
            .filter((header) => header.key != "checkbox")
            .map((header) => {
              const cell = row[header.key];
              return typeof cell === "string" && cell.includes(",")
                ? `"${cell.replace(/"/g, '""')}"` // Escape commas and quotes
                : cell;
            });
        });

        const headerRow = headers.join(",");
        const csvRows = [headerRow, ...rows.map((row) => row.join(","))];
        return csvRows.join("\n");
      } catch (error) {
        console.error(
          "Error during image generation or report generation:",
          error
        );

        throw new Error(
          "Error during image generation or report generation:",
          error
        );
      }
    },
    exportData() {
      const vm = this;
      vm.$bvToast.toast(
        `Download is in progress. Please wait for a moment while we prepare everything for you.`,
        {
          title: "Downloading...",
          variant: "info",
          autoHideDelay: 5000,
        }
      );

      try {
        let activeListing = !["unitmix", "unitmixrental"].some(
          (item) => item === this.openTab.value
        )
          ? vm.allMlsData
          : vm.exportedData;
        let allListingData = activeListing.map((data) => {
          let clonedRow = {
            ...data,
            origin_bed: data.mls_beds,
            mls_address: data.mls_floor_plan_feature.preview
              ? `=HYPERLINK("${data.mls_floor_plan_feature.preview}", "${data.mls_address}")`
              : data.mls_address,
            mls_list_price: `${data.mls_list_price}`,
            custom_price_change:
              data.custom_price_change.diffPercentage != 0
                ? data.custom_price_change.diffPercentage + "%"
                : "-",
          };

          Object.keys(clonedRow).forEach((key) => {
            clonedRow[key] = !["-", 0, null, NaN, "0"].includes(clonedRow[key])
              ? clonedRow[key]
              : "-";
          });

          if (clonedRow["mls_beds"]) {
            let bed = "";
            let fpSpecs = "";
            bed = `${clonedRow["mls_beds"]}-bed`;

            if (!["None", ""].includes(clonedRow["fp_specs"]))
              fpSpecs = `${clonedRow["fp_specs"]}`;

            if (clonedRow["mls_beds"] == "s") bed = "Studio";

            clonedRow["mls_beds"] = fpSpecs ? bed + " + " + fpSpecs : bed;
          }
          return {
            ...clonedRow,
          };
        });
        const csvContent = this.convertToCsv(allListingData);
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "exported-data.csv");
        link.click();
        URL.revokeObjectURL(url); // Clean up the URL after download
        vm.$bvToast.toast(`You can now view the downloaded file`, {
          title: "Success!",
          variant: "success",
          autoHideDelay: 5000,
        });
      } catch (error) {
        // Handle any errors that occurred during the process
        console.error(
          "Error during image generation or report generation:",
          error
        );
        vm.$bvToast.toast(
          `${"Something went wrong. \n Please inform us to fix this for you."}`,
          {
            title: "Oops!",
            variant: "danger",
            autoHideDelay: 5000,
          }
        );
      }
    },
    convertToCsv(data) {
      const vm = this;
      try {
        const headers = vm.rpdTableList1
          .filter(
            (header) =>
              !["checkbox", "favorite", "updatemls"].includes(header.key)
          )
          .map((item) => item.label);
        const rows = data.map((row) => {
          return vm.rpdTableList1
            .filter(
              (header) =>
                !["checkbox", "favorite", "updatemls"].includes(header.key)
            )
            .map((header) => {
              const cell = row[header.key];
              return typeof cell === "string" && cell.includes(",")
                ? `"${cell.replace(/"/g, '""')}"` // Escape commas and quotes
                : cell;
            });
        });

        const headerRow = headers.join(",");
        const csvRows = [headerRow, ...rows.map((row) => row.join(","))];
        return csvRows.join("\n");
      } catch (error) {
        console.error(
          "Error during image generation or report generation:",
          error
        );

        throw new Error(
          "Error during image generation or report generation:",
          error
        );
      }
    },
    async getImageRatio(imgUrl) {
      const max = { height: 190, width: 133 };

      return new Promise(async (resolve) => {
        let image = new Image();
        image.src = imgUrl;

        image.onload = async function () {
          const ratio = image.height / image.width;

          if (image.height > max.height || image.width > max.width) {
            if (image.height > image.width) {
              image.height = max.height;
              image.width = image.height * (1 / ratio);
              // Making reciprocal of ratio because ration of height as width is no valid here needs width as height
            } else if (image.width > image.height) {
              image.width = max.width;
              image.height = image.width * ratio;
              // Ratio is valid here
            }
          }
          resolve({
            status: "success",
            image: image,
          });
        };
      });
    },

    async generateImage() {
      const vm = this;
      let promises = [];
      // if(confirm("Include Floor Plans in the report?")){
      //     vm.arrayOfImages = new Array()
      //     let filtered_floorplan_feature = [...this.mlsActiveSort.filter(item =>  item.mls_floor_plan_feature.length != 0), ...this.mlsSoldSort.filter(item =>  item.mls_floor_plan_feature.length != 0)].sort((a,b) => a.mls_plan_name.localeCompare(b.mls_plan_name))

      //     let grouped = Object.groupBy(filtered_floorplan_feature, ({mls_plan_name}) => mls_plan_name)

      //     for(var item in grouped) {
      //         let row = grouped[item][0];
      //         promises.push(vm.getImageRatio(row.mls_floor_plan_feature.preview))
      //         vm.getImageRatio(row.mls_floor_plan_feature.preview).then(resolve => {
      //                 if(resolve.status == "success"){
      //                 this.arrayOfImages.push(
      //                     {
      //                         project: {
      //                         name: row.mls_plan_name,
      //                         unit: row.mls_address,
      //                         price: this.roundToWholeNumber(row.mls_list_price).toString() ,
      //                         psf: row.mls_psf > 0 ? this.roundToWholeNumber(row.mls_psf).toString() : '-',
      //                         priceDate: row.mls_price_date
      //                         },
      //                         image: resolve.image
      //                     }
      //                 )
      //             }
      //         })
      //     }
      // }
      // else{

      // }

      // vm.$bvToast.toast(`Download is in progress. Please wait for a moment while we prepare everything for you.`, {
      //     title: 'Downloading...',
      //     variant: 'info',
      //     autoHideDelay: 5000,
      // })

      try {
        await Promise.all(promises);

        await this.generateReport();

        vm.$bvToast.toast(`You can now view the downloaded file`, {
          title: "Success!",
          variant: "success",
          autoHideDelay: 5000,
        });
      } catch (error) {
        console.error(
          "Error during image generation or report generation:",
          error
        );
        vm.$bvToast.toast(
          `${"Something went wrong. \n Please inform us to fix this for you."}`,
          {
            title: "Oops!",
            variant: "danger",
            autoHideDelay: 5000,
          }
        );
      }
    },
    async generateReport() {
      try {
        const vm = this;
        let activeListing = !["unitmix", "unitmixrental"].some(item => item === this.openTab.value)
          ? vm.allMlsData
          : vm.exportedData;

        let date = new Date();
        let formattedDate = vm.formatDate(date);
        let logo = document.createElement("img");
        logo.src = "/src/assets/images/viber_image_2023-11-07_11-30-39-588.webp";

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        let currentY = 20; // Initialize a dynamic Y cursor

        doc.setTextColor(19, 41, 62);

        // --- 1. Project Header ---
        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text(vm.project.project_name, 10, currentY);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        const addressWidth = doc.getTextWidth(vm.project.address);
        doc.text(vm.project.address, pageWidth - addressWidth - 10, currentY);

        currentY += 10;

        // --- 2. Project Info List (Left Side) ---
        let previewTextObject = [
          { label: "Developer", key: vm.developer },
          { label: "Project Type", key: vm.project.new_p_type },
          { label: "Storey", key: vm.project.new_p_storey },
          { label: "Project Status", key: vm.project.status },
          { label: "Unit Type", key: vm.project.utc_specified.gut },
          { label: "Construction Status", key: vm.project.construction_status },
          { label: "Occupancy Date", key: vm.project.occupancy_date },
          { label: "Deposit", key: vm.project.deposit },
          { label: "Sales Start Date", key: vm.project.sales_start_date },
          { label: "Neighbourhood", key: vm.project.neighbor },
        ];

        doc.setFontSize(9);
        let infoY = currentY + 5;
        previewTextObject.forEach((x) => {
          doc.setFont("helvetica", "bold");
          doc.text(x.label, 10, infoY);
          doc.setFont("helvetica", "normal");
          doc.text(x.key ? String(x.key) : "-", 50, infoY);
          infoY += 5;
        });

        // --- 3. Summary Boxes (Right Side) ---
        // Box A
        const sumBoxesA = [
          { text: "Avg Size", data: vm.project.unit_component.avg_size?.toString() || "-" },
          { text: "Sold Units", data: vm.project.unit_component.sold_total?.toString() || "-" },
          { text: "Rlsd Units", data: vm.project.unit_component.rlsd_units?.toString() || "-" },
          { text: "Total Units", data: vm.project.unit_component.total?.toString() || "-" },
        ];

        let boxXStart = pageWidth - 10;
        doc.setFontSize(8);
        sumBoxesA.forEach((box, i) => {
          const x = pageWidth - 30 - (i * 22);
          doc.setFillColor(211, 211, 211);
          doc.roundedRect(x, currentY + 2, 20, 18, 2, 2, "F");
          doc.setTextColor(19, 41, 62);
          doc.setFont("helvetica", "bold");
          doc.text(box.text, x + 10, currentY + 10, { align: 'center' });
          doc.text(box.data, x + 10, currentY + 15, { align: 'center' });
        });

        // Box B (Positioned below Box A)
        let shouldRound = !["now leasing", "leased out"].includes(vm.project.status.toLowerCase());
        let avgPsf = shouldRound
          ? Math.round(Number(vm.project.unit_component.avg_psf)).toLocaleString()
          : Number(vm.project.unit_component.avg_psf).toFixed(2);

        const sumBoxesB = [
          { text: "Net Price", data: vm.project.unit_net_price ? "$" + Number(vm.project.unit_net_price).toLocaleString() : "-" },
          { text: "Net $PSF", data: vm.project.unit_net_psf ? "$" + Number(vm.project.unit_net_psf).toFixed(2) : "-" },
          { text: "Gross Price", data: vm.project.unit_component.avg_price != 0 ? "$" + Math.round(Number(vm.project.unit_component.avg_price)).toLocaleString() : "-" },
          { text: "Gross $PSF", data: avgPsf != 0 ? "$" + avgPsf : "-" },
        ];

        sumBoxesB.forEach((box, i) => {
          const x = pageWidth - 30 - (i * 22);
          doc.setFillColor(166, 166, 166);
          doc.roundedRect(x, currentY + 22, 20, 18, 2, 2, "F");
          doc.setTextColor(19, 41, 62);
          doc.text(box.text, x + 10, currentY + 30, { align: 'center' });
          doc.text(box.data, x + 10, currentY + 35, { align: 'center' });
        });

        // Update currentY to whichever is lower: the list or the boxes
        currentY = Math.max(infoY, currentY + 45);

        // --- 4. Last Reported ---
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        const last_reported = "Last Reported: " + vm.project.last_update;
        doc.text(last_reported, pageWidth - 10, currentY, { align: 'right' });

        currentY += 5;
        doc.setDrawColor(215, 215, 215);
        doc.line(10, currentY, pageWidth - 10, currentY);

        currentY += 10;

        // --- 5. Unit Breakdown Table ---
        doc.setFontSize(15);
        doc.setFont("helvetica", "bold");
        doc.text("Unit Breakdown", 10, currentY);
        currentY += 5;

        let unitBreakDownHeaders = [
          { header: "Type", dataKey: "bed" },
          { header: "Baths", dataKey: "bath" },
          { header: "# Units", dataKey: "mls_address" },
          { header: "Stalls", dataKey: "stall" },
          { header: "Min SF", dataKey: "minSize" },
          { header: "Max SF", dataKey: "maxSize" },
          { header: "AVG SF", dataKey: "total_size" },
          { header: "Min Price", dataKey: "minPrice" },
          { header: "Max Price", dataKey: "maxPrice" },
          { header: "AVG $PSF", dataKey: "avgPrice" },
        ];

        const tableData = vm.mlsTotalSort.map((item) => {
          return unitBreakDownHeaders.map((header) => {
            if (header.dataKey == "bed") {
              let bed = item.bed == "s" ? "Studio" : `${item.bed}-bed`;
              let fpSpecs = !["None", ""].includes(item.fp_specs) ? `\n${item.fp_specs}` : "";
              return bed + fpSpecs;
            }
            if (header.dataKey === "mls_address") return item.mls_address.length;
            if (header.dataKey == "stall") return item.stall.final;
            if (header.dataKey == "total_size") return Math.round(item.total_size / item.num);
            if (["minPrice", "maxPrice"].includes(header.dataKey)) {
              return item[header.dataKey] ? `$${Number(item[header.dataKey]).toLocaleString()}` : "-";
            }
            if (header.dataKey == "avgPrice") {
              let val = (item.custom_avg_price / (item.custom_avg_size));
              return item.avgPrice ? vm.isMarketStrata ? "$" + Math.round(val).toLocaleString() : "$" + Number(val).toFixed(2) : "-";
            }
            return item[header.dataKey];
          });
        });

        autoTable(doc, {
          margin: 10,
          startY: currentY,
          styles: { fontSize: 8 },
          head: [unitBreakDownHeaders.map(h => h.header)],
          body: tableData,
          headStyles: { fillColor: "#476E93", halign: 'center' },
          bodyStyles: { halign: 'center' }
        });

        currentY = doc.autoTable.previous.finalY + 15;

        // --- 6. Project History / Absorptions ---
        if (!["Now Leasing", "Leased Out", "Sold Out", "Now Selling"].includes(vm.project.status)) {

          // Check for page break
          if (currentY > pageHeight - 40) {
            doc.addPage();
            currentY = 25;
          }

          let historyTitle = vm.isAdmin ? "Project History" : "Absorptions";
          doc.setFontSize(15);
          doc.setFont("helvetica", "bold");
          doc.text(historyTitle, 10, currentY);
          currentY += 5;

          // History Headers & Data mapping... (keeping your existing logic for logic's sake)
          let custom_history_header = vm.isAdmin ?
            vm.history_header_fields.filter(i => i.key !== 'files') :
            [
              { label: "Total Units", key: "total" },
              { label: "Rlsd Units", key: "rlsd_units" },
              { label: "Rept Sold", key: "sold_total" },
              { label: "Rept Avail", key: "available" },
              { label: "Avg Size", key: "avg_size" },
              { label: "Gross $PSF", key: "avg_psf" },
              { label: "Gross Price", key: "avg_price" },
              { label: "Net $PSF", key: "total_net_psf" },
              { label: "Net Price", key: "current_total_net_price" },
            ];

          const historyData = vm.projectHistory.map(item => {
            return custom_history_header.map(h => item[h.key] || "-");
          });

          autoTable(doc, {
            margin: 10,
            startY: currentY,
            styles: { fontSize: 8 },
            head: [custom_history_header.map(h => h.label)],
            body: historyData,
            headStyles: { fillColor: "#476E93" }
          });

          currentY = doc.autoTable.previous.finalY + 15;
        }
        const absorptionDataHeaders = vm.soldLastQuarterFields.filter(
          (item) => !["sold_update"].includes(item.key)
        );

        const absorptionData = vm.soldLastQuarter.map((item) => {
          return absorptionDataHeaders.map((header) => {
            if (["note"].includes(header.key)) {
              return item[header.key] ? item[header.key][0].note : "-";
            }
            return item[header.key] ? item[header.key] : "-";
          });
        });

        if (currentY > 225) {
          doc.addPage();
          currentY = 30;
        }

        doc.setFontSize(15);
        doc.setFont("helvetica", "bold");
        doc.text(vm.isAdmin ? "Project History" : "Absorptions", 10, currentY - 5);

        autoTable(doc, {
          margin: { top: 10, right: 10, bottom: 30, left: 10 },
          startY: currentY,
          styles: { fontSize: 8 },
          head: [absorptionDataHeaders.map((header) => header.label)],
          body: absorptionData,
          headStyles: {
            fillColor: "#476E93",
            cellPadding: { top: 3, bottom: 5, left: 1 },
            valign: "center",
          },
          didParseCell: function (data) {
            // Sanitize HTML tags out of notes if they exist
            if (data.cell.raw) {
              data.cell.text = [data.cell.raw.toString().replace(/(<p[^>]+?>|<p>|<\/p>|<\/?header[^>]*>)/gim, "")];
            }
          }
        });

        currentY = doc.autoTable.previous.finalY + 15;
        let activeListingHeader = vm.rpdTableList1
          .filter((x) => !["checkbox", "favorite", "updatemls"].includes(x.key));
        const activeListingData = vm.setListingData(
          activeListing,
          activeListingHeader
        );
        const lastActiveColumnData = activeListing.map(
          (row) => row.price_back_up
        );
        doc.addPage("l", "mm");
        doc.setFontSize(15);
        doc.setFont("helvetica", "bold");
        doc.text("Active Listing", 10, 20);

        // --- 1. DYNAMIC SCALING LOGIC ---
        const colCount = activeListingHeader.length;
        let dynamicFontSize = 8;
        let dynamicPadding = 1.5;

        // Adjust font and padding based on column density
        if (colCount > 12) {
          dynamicFontSize = 7;
          dynamicPadding = 1;
        }
        if (colCount > 18) {
          dynamicFontSize = 6;
          dynamicPadding = 0.7;
        }
        if (colCount > 22) {
          dynamicFontSize = 5.5; // Very small for extreme amounts of data
          dynamicPadding = 0.5;
        }

        // --- 2. LEGEND BOXES ---
        // (Your existing code for boxes is fine, but make sure it uses dynamic coordinates)
        const boxes = [
          { color: [220, 53, 69], text: "Estimated" },
          { color: [255, 111, 22], text: "Semi-Verified" },
          { color: [11, 54, 220], text: "Verified" },
        ];

        boxes.forEach((box, i) => {
          const x = doc.internal.pageSize.width - 40 - i * 35;
          doc.setFillColor(...box.color);
          doc.rect(x, 14, 30, 8, "F");
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(8);
          doc.text(box.text, x + 15, 19, { align: 'center' });
        });

        // --- 3. THE TABLE ---
        autoTable(doc, {
          margin: { top: 15, right: 10, bottom: 25, left: 10 },
          startY: 25,

          // Use the dynamic variables here
          styles: {
            fontSize: dynamicFontSize,
            cellPadding: dynamicPadding,
            overflow: 'linebreak', // Allows text to wrap into multiple lines instead of scaling down
            halign: 'center'
          },

          headStyles: {
            fillColor: "#476E93",
            fontSize: Math.max(dynamicFontSize - 0.5, 5), // Headers slightly smaller if needed
            valign: 'middle'
          },

          // This is the CRITICAL line for dynamic headers:
          // It forces columns to maintain a minimum width so they don't turn into vertical lines.
          // If the table is too wide for the page, it will overflow the right margin
          // (which is better than having an unreadable table).
          columnStyles: {
            all: { minCellWidth: 10 }
          },

          head: [activeListingHeader.map((header) => header.label)],
          body: activeListingData,

          rowPageBreak: "avoid",

          didParseCell: function (data) {
            const rowIndex = data.row.index;
            const changeIndex = activeListingHeader.findIndex(
              (header) => header.key == "custom_price_change"
            );

            // Style logic for prices
            if (data.cell.raw && data.cell.raw.toString().match(/^\$/) && data.row.section == "body") {
              data.cell.styles.textColor = vm.setColor(lastActiveColumnData[rowIndex]);
            }

            // Style logic for price change column
            if (data.column.index === changeIndex && data.cell.section === "body") {
              if (data.cell.raw && data.cell.raw != "-") {
                data.cell.styles.textColor = data.cell.raw.color;
                // IMPORTANT: Ensure text is an array for jsPDF multi-line compatibility
                data.cell.text = [data.cell.raw.diffPercentage + "%"];
              }
            }
          }
        });

        // --- Finalize: Headers, Footers and Images ---
        const pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pW = doc.internal.pageSize.width;
          const pH = doc.internal.pageSize.height;

          doc.setFontSize(8);
          doc.setTextColor(150);
          doc.text(formattedDate, 10, 10);
          doc.text("realpropertydata.ca", pW - 10, 10, { align: 'right' });

          if (logo.src) {
            doc.addImage(logo, "PNG", 10, pH - 15, 40, 8);
          }
          doc.text(`Page ${i} of ${pageCount}`, pW - 10, pH - 10, { align: 'right' });
        }

        window.open(
          doc.output("bloburl"),
          "_blank",
          "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,modal=yes,top=100,left=500,width=1000,height=800"
        );

      } catch (error) {
        console.error("Report Generation Error:", error);
      }
    },

    formatDate(dateVal) {
      let vm = this;
      var newDate = new Date(dateVal);

      var sMonth = vm.padValue(newDate.getMonth() + 1);
      var sDay = vm.padValue(newDate.getDate());
      var sYear = newDate.getFullYear();
      var sHour = newDate.getHours();
      var sMinute = vm.padValue(newDate.getMinutes());
      var sAMPM = "AM";

      var iHourCheck = parseInt(sHour);

      if (iHourCheck > 12) {
        sAMPM = "PM";
        sHour = iHourCheck - 12;
      } else if (iHourCheck === 0) {
        sHour = "12";
      }

      sHour = vm.padValue(sHour);

      return (
        sMonth +
        "/" +
        sDay +
        "/" +
        sYear +
        " " +
        sHour +
        ":" +
        sMinute +
        " " +
        sAMPM
      );
    },
    padValue(value) {
      return value < 10 ? "0" + value : value;
    },
    createHeaders(keys) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 65,
          align: "center",
          padding: 0,
        });
      }
      return result;
    },
  },
  watch: {
    'project.unit_component.bed': {
      handler: 'fetchMlsData',
      immediate: true
    },
    totalRows(newVal) {
      this.totalRows = newVal;
    },
    mlsHeaderFields(newVal) {
      this.mlsHeaderFields = newVal;
    },
    project(newVal) {
      const vm = this;
      if (newVal) {
        vm.totalRows = {
          active: vm.mlsActiveSort.length,
          sold: vm.mlsSoldSort.length,
          other: vm.mlsOtherSort.length,
          all: vm.allMlsData.length,
        };
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.masonry-div {
  overflow-y: scroll;
  max-height: 50rem;
}

table#permit_table tr td:first-child,
table#permit_table thead th:first-child {
  text-align: left;
}

._text-no-wrap {
  text-wrap: nowrap;
}

.add-entry-btn {
  border: 1px solid;
  padding: 10px;
  position: absolute;
  cursor: pointer;
}

.note-wrapper {
  display: flex;
}

.type-note {
  width: 33.333%;
  padding: 15px;
}

.note-date {
  font-size: 20px;
  font-weight: 600;
}

.note-item {
  background: #d8d6d2;
  padding: 25px;
  border-radius: 25px;
}

.note-item::-webkit-scrollbar {
  width: 8px;
}

.note-item::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 100px;
}

.note-item::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
}

.note-body p {
  font-size: 18px;
  font-weight: 300;
  color: #000;
}

.type-icons {
  flex-grow: 1;
}

.type-icons-fontawesome {
  cursor: pointer;
}

.square-wrapper {
  text-align: center;
}

.square-blue {
  min-height: 105px;
  border-radius: 15px;
  margin: auto;
  width: 135px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
}

.display--inline-grid {
  display: flex;
}

.square-blue strong {
  font-weight: bold;
}

.type-page .container {
  margin-left: 0;
}

.type-title {
  padding: 15px 30px;
  background: #4a5f73;
  margin-left: -30px;
  margin-right: -30px;
  display: flex;
  flex-grow: 1;
  text-align: right;
  filter: drop-shadow(0px 0px 3px #b8b8b8);
  font-weight: 18px;
}

.type-title h1 {
  text-align: left;
}

.type-container {
  width: 88%;
  padding-left: 30px;
  padding-right: 30px;
  position: relative;
  display: block;
}

.side-menu-bottom {}

.side-menu-bottom-item {
  color: #fff;
  font-size: 1.2rem;
  text-align: left;
  font-weight: 400;
  padding: 15px 0 15px 40px;
  cursor: pointer;
}

.side-menu-item.active {
  background: #4a5f73;
}

.side-menu-item {
  font-size: 1.3rem;
  text-align: left;
  font-weight: 500;
  width: 100%;
  padding: 15px 0 15px 40px;
  cursor: pointer;
}

.logo-img {
  width: 100%;
  padding: 30px 15px;
}

.left-side-bar {
  background: #13293e;
  width: 12%;
  height: 150vh;
  position: sticky;
  z-index: 9;
  overflow-y: hidden;
  top: 0;
}

.side-menu-wrapper {
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 115vh;
  justify-content: space-between;
}

section {
  padding-left: 0;
  padding-right: 0;
}

.st-symbol {
  display: inline-block;
  position: absolute;
  font-size: 2rem;
  line-height: 0;
  margin-top: 13px;
  margin-left: 15px;
}

.st-label {
  margin-left: 50px;
}

.mt-auto {
  margin-top: auto;
}

.view-button {
  font-weight: bold;
  margin-right: 5px;
}

.edit-button {
  font-weight: bold;
  display: block;
  margin-top: 30px;
}

.back-label {
  padding: 0;
}

.btn-header {
  font-size: 11px;
  padding: 10px;
}

.upload-spinner {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.row-grey {
  background-color: rgba(0, 0, 0, 0.03);
}

.row-green {
  background: #68ca72;
}

.row-red {
  background: #ff1953;
}

.row-blue {
  background: #79b8f2;
}

.row-orange {
  background: #ff9357;
}

.flex-center {
  align-self: center;
}

h1 {
  font-family: Poppins;
  font-weight: 600;
  font-size: 3rem;
  text-transform: uppercase;
}

h2 {
  font-family: Poppins;
  font-weight: 600;
  font-size: 1.5rem;
  text-decoration: underline;
  cursor: pointer;
}

.function_icons {
  width: 30px;
  margin-right: 10px;
  cursor: pointer;
  margin-top: 12px;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  font-family: Poppins;
}

.tab-logo {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
}

.tab-row {
  position: relative;
}

.overview-val {
  font-weight: 600;
}

.btn-primary-reverse {
  color: #fff;
  font-weight: 600;
  background: #13293e;
  border-radius: 30px;
}

.btn-primary-reverse:hover {
  background: #4b6072;
  color: white;
}

h3 {
  font-weight: 600;
  font-size: 1.5rem;
}

.pic-media-wrapper {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.pic-media {
  width: 100%;
}

.modal-close {
  color: #fff;
  top: 10px;
  right: 10px;
  position: absolute;
  opacity: 1;
}

.plan-table {
  color: #000;
}

.plan-table th {
  font-size: 1.2rem;
  font-weight: 500;
}

.plan-table td {
  font-size: 1.2rem;
  font-weight: 300;
}

.floor-plan-block {
  font-weight: 400;
}

.status-cell {
  font-weight: 700;
}

.status-col {
  /* border-left: 2px solid #545454; */
}

.planning-table-cell td:nth-child(2) {
  border-left: 2px solid #545454;
  border-right: 2px solid #545454;
}

.table-header-text {
  text-decoration: none;
  font-size: 2.3rem;
  margin-top: 20px;
  margin-bottom: 20px;
}

.fp-img {
  background: #13293e;
  padding: 20px;
  margin: 30px;
}

.plan-table td {
  padding-top: 0;
}

.site-plan-bg {
  padding: 30px;
}

.site-plan-bg a {
  display: inline-block;
  padding: 20px;
  background: #13293e;
}

@media (max-width: 1020px) {
  .display--inline-grid {
    display: inline-grid;
    grid-template-columns: max-content max-content max-content max-content;
    gap: 2px;
  }

  .fp-img {
    margin: 5px;
  }

  .col-xs-4 {
    padding-left: 5px;
    padding-right: 5px;
  }
}

@media print {
  .table th {
    background-color: #12283fe5 !important;
  }

  .table .fa {
    display: none;
  }
}
</style>
<style>
.form-group label {
  font-size: 1.8rem;
}

.type-image .nav-tabs {
  border-top: 2px solid #bbb;
  border-bottom: 2px solid #bbb !important;
}

.type-image .nav-tabs .nav-item .nav-link {
  text-decoration: none;
  padding-top: 20px;
}

.type-page .single-project-detail .tab-row>div>div>.nav-tabs {
  display: none;
}

td p {
  color: #000;
  font-size: 1rem;
  font-weight: 500;
}

.nav-link {
  padding: 20px;
}

.nav.nav-tabs.type-nav-general {
  border-bottom: 2px solid #545454;
}

.type-nav-general {
  margin-top: 20px;
}

.type-nav-general .nav-item .nav-link {
  font-weight: 600;
  text-decoration: underline;
  color: #000000;
}

.type-nav-general .nav-item .nav-link.active {
  background: #c4c4c4;
}

.type-nav-general .nav-item {
  margin: 0;
}

.modal-header {
  background: #eee;
  color: #222222;
  font-family: Poppins;
  font-weight: 600;
  font-size: 1.7rem;
  text-transform: uppercase;
  padding: 50px;
  align-items: center !important;
  padding: 35px;
}

.logo-modal {
  width: 275px;
  position: absolute;
  right: 15px;
}

.modal-address {
  font-size: 1.4rem;
  font-weight: 300;
  font-family: Poppins;
}

.modal-table td {
  font-size: 1.2rem;
}

.modal-body {
  padding: 3rem;
}

@media only screen and (max-width: 768px) {
  .logo-modal {
    display: none;
  }
}

@media (max-width: 991px) {
  .modal-body {
    padding: 10px;
  }
}

.dropdown-toggle::after {
  position: absolute;
  right: 1rem;
  top: 1.5rem;
}

.dropdown,
.dropdown-toggle,
.dropdown-menu {
  width: 20rem;
}

.dropdown>button {
  text-align: left;
  border-radius: 0;
  padding: 0.75rem 1rem;
}

.round_btn {
  width: 60px;
  height: 60px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50% !important;
  border: none;
  text-decoration: none;
  transition: background 0.2s;
}

.content-utc-body {
  max-width: 80vw;
}

._bg-light-blue {
  background-color: #d9e0e7;
}

.active_tab {
  background: #7793ac;
}

@media (min-width: 1700px) {
  ._custom-col-xl-6 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }

  ._custom-width {
    max-width: 70vw;
  }
}

@media (max-width: 1699px) {
  ._custom-width {
    max-width: 40vw;
  }
}

th,
td,
.table thead th {
  text-align: center;
  font-size: large;
}

@media (min-width: 999px) and (max-width: 1699px) {
  ._custom-width {
    max-width: 50vw;
  }
}

th,
td,
.table thead th {
  text-align: center;
}

.thumbnails {
  margin: auto;
  width: 500px;
}

.thumbnails .vueperslide {
  box-sizing: border-box;
  border: 1px solid #fff;
  transition: 0.3s ease-in-out;
  opacity: 0.7;
  cursor: pointer;
}

.thumbnails .vueperslide--active {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  opacity: 1;
}

.vueperslide.vueperslide--active.vueperslide--visible {
  background-size: contain;
  background-repeat: no-repeat;
}

.text-left.note-body>p {
  font-size: 16px;
}

.fields-toggle-title {
  color: #13293e;
  font-size: 1.4rem;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}

.fields-toggle-wrapper {
  zoom: 1.4;
  border: 3px #13293e solid;
  position: absolute;
  width: 450px;
  border-radius: 20px;
  z-index: 999;
  background: #f8f7f7;
  margin-top: 10px;
  padding: 30px;
  top: 15rem;
  left: 19rem;
}

.selected-fields .list-group-item {
  background: #fc5868;
  color: #fff;
}

.fields-toggle-bar {
  border-bottom: 3px solid #13293e;
  margin-left: -30px;
  margin-right: -30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.list-group-item {
  background: #d9d9d9;
  color: #13293e;
  font-size: 0.9rem;
  border: none;
}

.list-group {
  flex-direction: inherit;
}

.list-group-item {
  width: calc(50% - 20px);
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
}

._field_icon {
  height: max-content;
  cursor: pointer;
}

.fp-header th,
.fp-body td {
  vertical-align: middle !important;
}

tr._tr-fix-height {
  height: 80px;
}

label#datepicker-dateformat1__value_ {
  margin-top: 4px;
}

._no-wrap {
  white-space: nowrap;
}
</style>
<style>
.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
  /* Make space for the arrow */
}

.sortable .arrow {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  opacity: 0.6;
}

.sortable .arrow.asc {
  border-bottom: 5px solid #fff;
  /* Up arrow */
}

.sortable .arrow.desc {
  border-top: 5px solid #fff;
  /* Down arrow */
}

.sortable.active .arrow {
  opacity: 1;
  /* Make the arrow more prominent for the active sort column */
}

.nav.nav-tabs.type-nav-general {
  display: none;
}
</style>
